export default [
    {
     "Country": "Albania",
     "Region": "Balkan Peninsula",
     "Province": "Dibër"
    },
    {
     "Country": "Albania",
     "Region": "Balkan Peninsula",
     "Province": "Durrës"
    },
    {
     "Country": "Albania",
     "Region": "Balkan Peninsula",
     "Province": "Elbasan"
    },
    {
     "Country": "Albania",
     "Region": "Balkan Peninsula",
     "Province": "Fier"
    },
    {
     "Country": "Albania",
     "Region": "Balkan Peninsula",
     "Province": "Gjirokastër"
    },
    {
     "Country": "Albania",
     "Region": "Balkan Peninsula",
     "Province": "Korçë"
    },
    {
     "Country": "Albania",
     "Region": "Balkan Peninsula",
     "Province": "Kukës"
    },
    {
     "Country": "Albania",
     "Region": "Balkan Peninsula",
     "Province": "Lezhë"
    },
    {
     "Country": "Albania",
     "Region": "Balkan Peninsula",
     "Province": "Shkodër"
    },
    {
     "Country": "Albania",
     "Region": "Balkan Peninsula",
     "Province": "Tirana"
    },
    {
     "Country": "Albania",
     "Region": "Balkan Peninsula",
     "Province": "Vlorë"
    },
    {
     "Country": "Algeria",
     "Region": "Northern Africa",
     "Province": "Adrar"
    },
    {
     "Country": "Algeria",
     "Region": "Northern Africa",
     "Province": "Chlef"
    },
    {
     "Country": "Algeria",
     "Region": "Northern Africa",
     "Province": "Laghouat"
    },
    {
     "Country": "Algeria",
     "Region": "Northern Africa",
     "Province": "Oum El Bouaghi"
    },
    {
     "Country": "Algeria",
     "Region": "Northern Africa",
     "Province": "Batna"
    },
    {
     "Country": "Algeria",
     "Region": "Northern Africa",
     "Province": "Béjaïa"
    },
    {
     "Country": "Algeria",
     "Region": "Northern Africa",
     "Province": "Biskra"
    },
    {
     "Country": "Algeria",
     "Region": "Northern Africa",
     "Province": "Béchar"
    },
    {
     "Country": "Algeria",
     "Region": "Northern Africa",
     "Province": "Blida"
    },
    {
     "Country": "Algeria",
     "Region": "Northern Africa",
     "Province": "Bouïra"
    },
    {
     "Country": "Algeria",
     "Region": "Northern Africa",
     "Province": "Tamanrasset"
    },
    {
     "Country": "Algeria",
     "Region": "Northern Africa",
     "Province": "Tébessa"
    },
    {
     "Country": "Algeria",
     "Region": "Northern Africa",
     "Province": "Tlemcen"
    },
    {
     "Country": "Algeria",
     "Region": "Northern Africa",
     "Province": "Tiaret"
    },
    {
     "Country": "Algeria",
     "Region": "Northern Africa",
     "Province": "Tizi Ouzou"
    },
    {
     "Country": "Algeria",
     "Region": "Northern Africa",
     "Province": "Algiers"
    },
    {
     "Country": "Algeria",
     "Region": "Northern Africa",
     "Province": "Djelfa"
    },
    {
     "Country": "Algeria",
     "Region": "Northern Africa",
     "Province": "Jijel"
    },
    {
     "Country": "Algeria",
     "Region": "Northern Africa",
     "Province": "Sétif"
    },
    {
     "Country": "Algeria",
     "Region": "Northern Africa",
     "Province": "Saïda"
    },
    {
     "Country": "Algeria",
     "Region": "Northern Africa",
     "Province": "Skikda"
    },
    {
     "Country": "Algeria",
     "Region": "Northern Africa",
     "Province": "Sidi Bel Abbès"
    },
    {
     "Country": "Algeria",
     "Region": "Northern Africa",
     "Province": "Annaba"
    },
    {
     "Country": "Algeria",
     "Region": "Northern Africa",
     "Province": "Guelma"
    },
    {
     "Country": "Algeria",
     "Region": "Northern Africa",
     "Province": "Constantine"
    },
    {
     "Country": "Algeria",
     "Region": "Northern Africa",
     "Province": "Médéa"
    },
    {
     "Country": "Algeria",
     "Region": "Northern Africa",
     "Province": "Mostaganem"
    },
    {
     "Country": "Algeria",
     "Region": "Northern Africa",
     "Province": "M'Sila"
    },
    {
     "Country": "Algeria",
     "Region": "Northern Africa",
     "Province": "Mascara"
    },
    {
     "Country": "Andorra",
     "Region": "Southern Europe",
     "Province": "Andorra la Vella"
    },
    {
     "Country": "Andorra",
     "Region": "Southern Europe",
     "Province": "Canillo"
    },
    {
     "Country": "Andorra",
     "Region": "Southern Europe",
     "Province": "Encamp"
    },
    {
     "Country": "Andorra",
     "Region": "Southern Europe",
     "Province": "Escaldes-Engordany"
    },
    {
     "Country": "Andorra",
     "Region": "Southern Europe",
     "Province": "La Massana"
    },
    {
     "Country": "Andorra",
     "Region": "Southern Europe",
     "Province": "Ordino"
    },
    {
     "Country": "Andorra",
     "Region": "Southern Europe",
     "Province": "Sant Julià de Lòria"
    },
    {
     "Country": "Andorra",
     "Region": "Southern Europe",
     "Province": "Andorra"
    },
    {
     "Country": "Angola",
     "Region": "Central Africa",
     "Province": "Bengo"
    },
    {
     "Country": "Angola",
     "Region": "Central Africa",
     "Province": "Benguela"
    },
    {
     "Country": "Angola",
     "Region": "Central Africa",
     "Province": "Bié"
    },
    {
     "Country": "Angola",
     "Region": "Central Africa",
     "Province": "Cabinda"
    },
    {
     "Country": "Angola",
     "Region": "Central Africa",
     "Province": "Cuando Cubango"
    },
    {
     "Country": "Angola",
     "Region": "Central Africa",
     "Province": "Cuanza Norte"
    },
    {
     "Country": "Angola",
     "Region": "Central Africa",
     "Province": "Cuanza Sul"
    },
    {
     "Country": "Angola",
     "Region": "Central Africa",
     "Province": "Cunene"
    },
    {
     "Country": "Angola",
     "Region": "Central Africa",
     "Province": "Huambo"
    },
    {
     "Country": "Angola",
     "Region": "Central Africa",
     "Province": "Huíla"
    },
    {
     "Country": "Angola",
     "Region": "Central Africa",
     "Province": "Luanda"
    },
    {
     "Country": "Angola",
     "Region": "Central Africa",
     "Province": "Lunda Norte"
    },
    {
     "Country": "Angola",
     "Region": "Central Africa",
     "Province": "Lunda Sul"
    },
    {
     "Country": "Angola",
     "Region": "Central Africa",
     "Province": "Malanje"
    },
    {
     "Country": "Angola",
     "Region": "Central Africa",
     "Province": "Moxico"
    },
    {
     "Country": "Angola",
     "Region": "Central Africa",
     "Province": "Namibe"
    },
    {
     "Country": "Angola",
     "Region": "Central Africa",
     "Province": "Uíge"
    },
    {
     "Country": "Angola",
     "Region": "Central Africa",
     "Province": "Zaire"
    },
    {
     "Country": "Antigua and Barbuda",
     "Region": "Leeward Islands, Caribbean",
     "Province": "Saint George"
    },
    {
     "Country": "Antigua and Barbuda",
     "Region": "Leeward Islands, Caribbean",
     "Province": "Saint John"
    },
    {
     "Country": "Antigua and Barbuda",
     "Region": "Leeward Islands, Caribbean",
     "Province": "Saint Mary"
    },
    {
     "Country": "Antigua and Barbuda",
     "Region": "Leeward Islands, Caribbean",
     "Province": "Saint Paul"
    },
    {
     "Country": "Antigua and Barbuda",
     "Region": "Leeward Islands, Caribbean",
     "Province": "Saint Peter"
    },
    {
     "Country": "Antigua and Barbuda",
     "Region": "Leeward Islands, Caribbean",
     "Province": "Saint Philip"
    },
    {
     "Country": "Antigua and Barbuda",
     "Region": "Leeward Islands, Caribbean",
     "Province": "Barbuda"
    },
    {
     "Country": "Antigua and Barbuda",
     "Region": "Leeward Islands, Caribbean",
     "Province": "Redonda"
    },
    {
     "Country": "Argentina",
     "Region": "Southern South America",
     "Province": "Autonomous City of Buenos Aires"
    },
    {
     "Country": "Argentina",
     "Region": "Southern South America",
     "Province": "Buenos Aires"
    },
    {
     "Country": "Argentina",
     "Region": "Southern South America",
     "Province": "Catamarca"
    },
    {
     "Country": "Argentina",
     "Region": "Southern South America",
     "Province": "Chaco"
    },
    {
     "Country": "Argentina",
     "Region": "Southern South America",
     "Province": "Chubut"
    },
    {
     "Country": "Argentina",
     "Region": "Southern South America",
     "Province": "Córdoba"
    },
    {
     "Country": "Argentina",
     "Region": "Southern South America",
     "Province": "Corrientes"
    },
    {
     "Country": "Argentina",
     "Region": "Southern South America",
     "Province": "Entre Ríos"
    },
    {
     "Country": "Argentina",
     "Region": "Southern South America",
     "Province": "Formosa"
    },
    {
     "Country": "Argentina",
     "Region": "Southern South America",
     "Province": "Jujuy"
    },
    {
     "Country": "Argentina",
     "Region": "Southern South America",
     "Province": "La Pampa"
    },
    {
     "Country": "Argentina",
     "Region": "Southern South America",
     "Province": "La Rioja"
    },
    {
     "Country": "Argentina",
     "Region": "Southern South America",
     "Province": "Mendoza"
    },
    {
     "Country": "Argentina",
     "Region": "Southern South America",
     "Province": "Misiones"
    },
    {
     "Country": "Argentina",
     "Region": "Southern South America",
     "Province": "Neuquén"
    },
    {
     "Country": "Argentina",
     "Region": "Southern South America",
     "Province": "Río Negro"
    },
    {
     "Country": "Argentina",
     "Region": "Southern South America",
     "Province": "Salta"
    },
    {
     "Country": "Argentina",
     "Region": "Southern South America",
     "Province": "San Juan"
    },
    {
     "Country": "Argentina",
     "Region": "Southern South America",
     "Province": "San Luis"
    },
    {
     "Country": "Argentina",
     "Region": "Southern South America",
     "Province": "Santa Cruz"
    },
    {
     "Country": "Argentina",
     "Region": "Southern South America",
     "Province": "Santa Fe"
    },
    {
     "Country": "Argentina",
     "Region": "Southern South America",
     "Province": "Santiago del Estero"
    },
    {
     "Country": "Argentina",
     "Region": "Southern South America",
     "Province": "Tierra del Fuego, Antártida e Islas del Atlántico Sur"
    },
    {
     "Country": "Argentina",
     "Region": "Southern South America",
     "Province": "Tucumán"
    },
    {
     "Country": "Armenia",
     "Region": "Western Asia",
     "Province": "Aragatsotn"
    },
    {
     "Country": "Armenia",
     "Region": "Western Asia",
     "Province": "Ararat"
    },
    {
     "Country": "Armenia",
     "Region": "Western Asia",
     "Province": "Armavir"
    },
    {
     "Country": "Armenia",
     "Region": "Western Asia",
     "Province": " Gegharkunik"
    },
    {
     "Country": "Armenia",
     "Region": "Western Asia",
     "Province": " Kotayk"
    },
    {
     "Country": "Armenia",
     "Region": "Western Asia",
     "Province": " Lori"
    },
    {
     "Country": "Armenia",
     "Region": "Western Asia",
     "Province": "Shirak"
    },
    {
     "Country": "Armenia",
     "Region": "Western Asia",
     "Province": "Syunik"
    },
    {
     "Country": "Armenia",
     "Region": "Western Asia",
     "Province": "Tavush"
    },
    {
     "Country": "Armenia",
     "Region": "Western Asia",
     "Province": " Vayots Dzor"
    },
    {
     "Country": "Armenia",
     "Region": "Western Asia",
     "Province": " Yerevan"
    },
    {
     "Country": "Australia",
     "Region": "Australia\/Oceania",
     "Province": "New South Wales"
    },
    {
     "Country": "Australia",
     "Region": "Australia\/Oceania",
     "Province": "Victoria"
    },
    {
     "Country": "Australia",
     "Region": "Australia\/Oceania",
     "Province": "Queensland"
    },
    {
     "Country": "Australia",
     "Region": "Australia\/Oceania",
     "Province": "Western Australia"
    },
    {
     "Country": "Australia",
     "Region": "Australia\/Oceania",
     "Province": "South Australia"
    },
    {
     "Country": "Australia",
     "Region": "Australia\/Oceania",
     "Province": "Tasmania"
    },
    {
     "Country": "Austria",
     "Region": "Western Europe",
     "Province": "Burgenland"
    },
    {
     "Country": "Austria",
     "Region": "Western Europe",
     "Province": "Carinthia (Kärnten)"
    },
    {
     "Country": "Austria",
     "Region": "Western Europe",
     "Province": "Lower Austria (Nieder­österreich)"
    },
    {
     "Country": "Austria",
     "Region": "Western Europe",
     "Province": "Salzburg"
    },
    {
     "Country": "Austria",
     "Region": "Western Europe",
     "Province": "Styria (Steiermark)"
    },
    {
     "Country": "Austria",
     "Region": "Western Europe",
     "Province": "Tyrol (Tirol)"
    },
    {
     "Country": "Austria",
     "Region": "Western Europe",
     "Province": "Upper Austria (Ober­österreich)"
    },
    {
     "Country": "Austria",
     "Region": "Western Europe",
     "Province": "Vienna (Wien)"
    },
    {
     "Country": "Austria",
     "Region": "Western Europe",
     "Province": "Vorarlberg"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Absheron District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Aghjabadi District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Aghdam District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Agdash District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Aghstafa District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Agsu District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Şirvan (city)"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Astara District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Baku (city)"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Balakan District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Barda District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Beylagan District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Bilasuvar District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Jabrayil District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Jalilabad District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Dashkasan District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Shabran District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Fuzuli District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Gadabay District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Ganja (city)"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Goranboy District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Goychay District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Hajigabul District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Imishli District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Ismayilli District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Kalbajar District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Kurdamir District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Lachin District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Lankaran District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Lankaran (city)"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Lerik District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Masally District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Mingachevir (city)"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Naftalan (city)"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Neftchala District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Oghuz District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Qabala District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Qakh District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Qazax District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Gobustan District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Quba District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Qubadli District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Qusar District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Saatly District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Sabirabad District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Shaki District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Shaki (city)"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Salyan District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Shamakhi District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Shamkir District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Samukh District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Siyazan District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Sumgait (city)"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Shusha District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Tartar District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Tovuz District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Ujar District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Khachmaz District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Khankendi (city)"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Goygol District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Khizi District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Khojaly District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Khojavend District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Yardimli District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Yevlakh District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Yevlakh (city)"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Zangilan District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Zagatala District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Zardab District"
    },
    {
     "Country": "Azerbaijan",
     "Region": "Caucasus, Western Asia",
     "Province": "Aghdara District"
    },
    {
     "Country": "Bahamas",
     "Region": "Caribbean",
     "Province": "Bain and Grants Town"
    },
    {
     "Country": "Bahamas",
     "Region": "Caribbean",
     "Province": "Bamboo Town"
    },
    {
     "Country": "Bahamas",
     "Region": "Caribbean",
     "Province": "Carmichael"
    },
    {
     "Country": "Bahamas",
     "Region": "Caribbean",
     "Province": "Centreville"
    },
    {
     "Country": "Bahamas",
     "Region": "Caribbean",
     "Province": "Elizabeth"
    },
    {
     "Country": "Bahamas",
     "Region": "Caribbean",
     "Province": "Englerston"
    },
    {
     "Country": "Bahamas",
     "Region": "Caribbean",
     "Province": "Freetown"
    },
    {
     "Country": "Bahamas",
     "Region": "Caribbean",
     "Province": "Fort Charlotte"
    },
    {
     "Country": "Bahamas",
     "Region": "Caribbean",
     "Province": "Fox Hill"
    },
    {
     "Country": "Bahamas",
     "Region": "Caribbean",
     "Province": "Garden Hills"
    },
    {
     "Country": "Bahamas",
     "Region": "Caribbean",
     "Province": "Golden Gates"
    },
    {
     "Country": "Bahamas",
     "Region": "Caribbean",
     "Province": "Golden Isles"
    },
    {
     "Country": "Bahamas",
     "Region": "Caribbean",
     "Province": "Killarney"
    },
    {
     "Country": "Bahamas",
     "Region": "Caribbean",
     "Province": "Marathon"
    },
    {
     "Country": "Bahamas",
     "Region": "Caribbean",
     "Province": "Mount Moriah"
    },
    {
     "Country": "Bahamas",
     "Region": "Caribbean",
     "Province": "Nassau Village"
    },
    {
     "Country": "Bahamas",
     "Region": "Caribbean",
     "Province": "Pinewood"
    },
    {
     "Country": "Bahamas",
     "Region": "Caribbean",
     "Province": "Sea Breeze"
    },
    {
     "Country": "Bahamas",
     "Region": "Caribbean",
     "Province": "South Beach"
    },
    {
     "Country": "Bahamas",
     "Region": "Caribbean",
     "Province": "Southern Shores"
    },
    {
     "Country": "Bahamas",
     "Region": "Caribbean",
     "Province": "St Annes"
    },
    {
     "Country": "Bahamas",
     "Region": "Caribbean",
     "Province": "St Barnabas"
    },
    {
     "Country": "Bahamas",
     "Region": "Caribbean",
     "Province": "Tall Pines"
    },
    {
     "Country": "Bahamas",
     "Region": "Caribbean",
     "Province": "Yamacraw"
    },
    {
     "Country": "Bahrain",
     "Region": "Arabian Peninsula, Middle East",
     "Province": " Al Hidd"
    },
    {
     "Country": "Bahrain",
     "Region": "Arabian Peninsula, Middle East",
     "Province": " Manama"
    },
    {
     "Country": "Bahrain",
     "Region": "Arabian Peninsula, Middle East",
     "Province": " Western Region"
    },
    {
     "Country": "Bahrain",
     "Region": "Arabian Peninsula, Middle East",
     "Province": " Central Region"
    },
    {
     "Country": "Bahrain",
     "Region": "Arabian Peninsula, Middle East",
     "Province": " Northern Region"
    },
    {
     "Country": "Bahrain",
     "Region": "Arabian Peninsula, Middle East",
     "Province": " Muharraq"
    },
    {
     "Country": "Bahrain",
     "Region": "Arabian Peninsula, Middle East",
     "Province": " Rifa and Southern Region"
    },
    {
     "Country": "Bahrain",
     "Region": "Arabian Peninsula, Middle East",
     "Province": " Jidd Haffs"
    },
    {
     "Country": "Bahrain",
     "Region": "Arabian Peninsula, Middle East",
     "Province": " Hamad Town (not shown)"
    },
    {
     "Country": "Bahrain",
     "Region": "Arabian Peninsula, Middle East",
     "Province": " Isa Town"
    },
    {
     "Country": "Bahrain",
     "Region": "Arabian Peninsula, Middle East",
     "Province": " Hawar Islands"
    },
    {
     "Country": "Bahrain",
     "Region": "Arabian Peninsula, Middle East",
     "Province": " Sitra"
    },
    {
     "Country": "Bangladesh",
     "Region": "South-Central Asia",
     "Province": "Barisal"
    },
    {
     "Country": "Bangladesh",
     "Region": "South-Central Asia",
     "Province": "Chittagong"
    },
    {
     "Country": "Bangladesh",
     "Region": "South-Central Asia",
     "Province": "Dhaka"
    },
    {
     "Country": "Bangladesh",
     "Region": "South-Central Asia",
     "Province": "Khulna"
    },
    {
     "Country": "Bangladesh",
     "Region": "South-Central Asia",
     "Province": "Mymensingh"
    },
    {
     "Country": "Bangladesh",
     "Region": "South-Central Asia",
     "Province": "Rajshahi"
    },
    {
     "Country": "Bangladesh",
     "Region": "South-Central Asia",
     "Province": "Rangpur"
    },
    {
     "Country": "Bangladesh",
     "Region": "South-Central Asia",
     "Province": "Sylhet"
    },
    {
     "Country": "Barbados",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Christ Church"
    },
    {
     "Country": "Barbados",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "St. Andrew"
    },
    {
     "Country": "Barbados",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "St. George"
    },
    {
     "Country": "Barbados",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "St. James"
    },
    {
     "Country": "Barbados",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "St. John"
    },
    {
     "Country": "Barbados",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "St. Joseph"
    },
    {
     "Country": "Barbados",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "St. Lucy"
    },
    {
     "Country": "Barbados",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "St. Michael"
    },
    {
     "Country": "Barbados",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "St. Peter"
    },
    {
     "Country": "Barbados",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "St. Philip"
    },
    {
     "Country": "Barbados",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "St. Thomas"
    },
    {
     "Country": "Belarus",
     "Region": "Eastern Europe",
     "Province": "Brest"
    },
    {
     "Country": "Belarus",
     "Region": "Eastern Europe",
     "Province": "Gomel"
    },
    {
     "Country": "Belarus",
     "Region": "Eastern Europe",
     "Province": "Grodno"
    },
    {
     "Country": "Belarus",
     "Region": "Eastern Europe",
     "Province": "Mogilev"
    },
    {
     "Country": "Belarus",
     "Region": "Eastern Europe",
     "Province": "Minsk"
    },
    {
     "Country": "Belarus",
     "Region": "Eastern Europe",
     "Province": "Vitebsk"
    },
    {
     "Country": "Belarus",
     "Region": "Eastern Europe",
     "Province": "Minsk"
    },
    {
     "Country": "Belgium",
     "Region": "Western Europe",
     "Province": "Antwerp"
    },
    {
     "Country": "Belgium",
     "Region": "Western Europe",
     "Province": "Limburg"
    },
    {
     "Country": "Belgium",
     "Region": "Western Europe",
     "Province": "Flemish Brabant"
    },
    {
     "Country": "Belgium",
     "Region": "Western Europe",
     "Province": "East Flanders"
    },
    {
     "Country": "Belgium",
     "Region": "Western Europe",
     "Province": "West Flanders"
    },
    {
     "Country": "Belgium",
     "Region": "Western Europe",
     "Province": "Hainaut"
    },
    {
     "Country": "Belgium",
     "Region": "Western Europe",
     "Province": "Walloon Brabant"
    },
    {
     "Country": "Belgium",
     "Region": "Western Europe",
     "Province": "Namur"
    },
    {
     "Country": "Belgium",
     "Region": "Western Europe",
     "Province": "Liège"
    },
    {
     "Country": "Belgium",
     "Region": "Western Europe",
     "Province": "Luxembourg"
    },
    {
     "Country": "Belize",
     "Region": "Central America",
     "Province": "Cayo"
    },
    {
     "Country": "Belize",
     "Region": "Central America",
     "Province": "Corozal"
    },
    {
     "Country": "Belize",
     "Region": "Central America",
     "Province": "Orange Walk"
    },
    {
     "Country": "Belize",
     "Region": "Central America",
     "Province": "Stann Creek"
    },
    {
     "Country": "Belize",
     "Region": "Central America",
     "Province": "Toledo"
    },
    {
     "Country": "Belize",
     "Region": "Central America",
     "Province": "Belize City"
    },
    {
     "Country": "Belize",
     "Region": "Central America",
     "Province": "San Ignacio"
    },
    {
     "Country": "Belize",
     "Region": "Central America",
     "Province": "Corozal Town"
    },
    {
     "Country": "Belize",
     "Region": "Central America",
     "Province": "Orange Walk Town"
    },
    {
     "Country": "Belize",
     "Region": "Central America",
     "Province": "Dangriga"
    },
    {
     "Country": "Belize",
     "Region": "Central America",
     "Province": "Punta Gorda"
    },
    {
     "Country": "Benin",
     "Region": "West Africa",
     "Province": "Alibori"
    },
    {
     "Country": "Benin",
     "Region": "West Africa",
     "Province": "Atakora"
    },
    {
     "Country": "Benin",
     "Region": "West Africa",
     "Province": "Atlantique"
    },
    {
     "Country": "Benin",
     "Region": "West Africa",
     "Province": "Borgou"
    },
    {
     "Country": "Benin",
     "Region": "West Africa",
     "Province": "Collines"
    },
    {
     "Country": "Benin",
     "Region": "West Africa",
     "Province": "Kouffo"
    },
    {
     "Country": "Benin",
     "Region": "West Africa",
     "Province": "Donga"
    },
    {
     "Country": "Benin",
     "Region": "West Africa",
     "Province": "Littoral"
    },
    {
     "Country": "Benin",
     "Region": "West Africa",
     "Province": "Mono"
    },
    {
     "Country": "Benin",
     "Region": "West Africa",
     "Province": "Ouémé"
    },
    {
     "Country": "Benin",
     "Region": "West Africa",
     "Province": "Plateau"
    },
    {
     "Country": "Benin",
     "Region": "West Africa",
     "Province": "Zou"
    },
    {
     "Country": "Bermuda",
     "Region": "North America",
     "Province": "Devonshire"
    },
    {
     "Country": "Bermuda",
     "Region": "North America",
     "Province": "Hamilton"
    },
    {
     "Country": "Bermuda",
     "Region": "North America",
     "Province": "Paget"
    },
    {
     "Country": "Bermuda",
     "Region": "North America",
     "Province": "Pembroke"
    },
    {
     "Country": "Bermuda",
     "Region": "North America",
     "Province": "St George's"
    },
    {
     "Country": "Bermuda",
     "Region": "North America",
     "Province": "Sandys"
    },
    {
     "Country": "Bermuda",
     "Region": "North America",
     "Province": "Smith's"
    },
    {
     "Country": "Bermuda",
     "Region": "North America",
     "Province": "Southampton"
    },
    {
     "Country": "Bermuda",
     "Region": "North America",
     "Province": "Warwick"
    },
    {
     "Country": "Bhutan",
     "Region": "South-Central Asia",
     "Province": "Bumthang"
    },
    {
     "Country": "Bhutan",
     "Region": "South-Central Asia",
     "Province": "Chhukha"
    },
    {
     "Country": "Bhutan",
     "Region": "South-Central Asia",
     "Province": "Dagana"
    },
    {
     "Country": "Bhutan",
     "Region": "South-Central Asia",
     "Province": "Gasa"
    },
    {
     "Country": "Bhutan",
     "Region": "South-Central Asia",
     "Province": "Haa"
    },
    {
     "Country": "Bhutan",
     "Region": "South-Central Asia",
     "Province": "Lhuentse"
    },
    {
     "Country": "Bhutan",
     "Region": "South-Central Asia",
     "Province": "Mongar"
    },
    {
     "Country": "Bhutan",
     "Region": "South-Central Asia",
     "Province": "Paro"
    },
    {
     "Country": "Bhutan",
     "Region": "South-Central Asia",
     "Province": "Pemagatshel"
    },
    {
     "Country": "Bhutan",
     "Region": "South-Central Asia",
     "Province": "Punakha"
    },
    {
     "Country": "Bhutan",
     "Region": "South-Central Asia",
     "Province": "Samdrup Jongkhar"
    },
    {
     "Country": "Bhutan",
     "Region": "South-Central Asia",
     "Province": "Samtse"
    },
    {
     "Country": "Bhutan",
     "Region": "South-Central Asia",
     "Province": "Sarpang"
    },
    {
     "Country": "Bhutan",
     "Region": "South-Central Asia",
     "Province": "Thimphu"
    },
    {
     "Country": "Bhutan",
     "Region": "South-Central Asia",
     "Province": "Trashigang"
    },
    {
     "Country": "Bhutan",
     "Region": "South-Central Asia",
     "Province": "Trashiyangtse"
    },
    {
     "Country": "Bhutan",
     "Region": "South-Central Asia",
     "Province": "Trongsa"
    },
    {
     "Country": "Bhutan",
     "Region": "South-Central Asia",
     "Province": "Tsirang"
    },
    {
     "Country": "Bhutan",
     "Region": "South-Central Asia",
     "Province": "Wangdue Phodrang"
    },
    {
     "Country": "Bhutan",
     "Region": "South-Central Asia",
     "Province": "Zhemgang"
    },
    {
     "Country": "Bhutan",
     "Region": "South-Central Asia",
     "Province": "Bhutan"
    },
    {
     "Country": "Bolivia",
     "Region": "Central South America",
     "Province": "Beni"
    },
    {
     "Country": "Bolivia",
     "Region": "Central South America",
     "Province": "Chuquisaca"
    },
    {
     "Country": "Bolivia",
     "Region": "Central South America",
     "Province": "Cochabamba"
    },
    {
     "Country": "Bolivia",
     "Region": "Central South America",
     "Province": "La Paz"
    },
    {
     "Country": "Bolivia",
     "Region": "Central South America",
     "Province": "Oruro"
    },
    {
     "Country": "Bolivia",
     "Region": "Central South America",
     "Province": "Pando"
    },
    {
     "Country": "Bolivia",
     "Region": "Central South America",
     "Province": "Potosí"
    },
    {
     "Country": "Bolivia",
     "Region": "Central South America",
     "Province": "Santa Cruz"
    },
    {
     "Country": "Bolivia",
     "Region": "Central South America",
     "Province": "Tarija"
    },
    {
     "Country": "Bosnia and Herzegovina",
     "Region": "Southern Europe",
     "Province": "Sarajevo"
    },
    {
     "Country": "Bosnia and Herzegovina",
     "Region": "Southern Europe",
     "Province": "Tuzla"
    },
    {
     "Country": "Bosnia and Herzegovina",
     "Region": "Southern Europe",
     "Province": "Zenica"
    },
    {
     "Country": "Bosnia and Herzegovina",
     "Region": "Southern Europe",
     "Province": "Mostar"
    },
    {
     "Country": "Bosnia and Herzegovina",
     "Region": "Southern Europe",
     "Province": "Ilidža"
    },
    {
     "Country": "Bosnia and Herzegovina",
     "Region": "Southern Europe",
     "Province": "Cazin"
    },
    {
     "Country": "Bosnia and Herzegovina",
     "Region": "Southern Europe",
     "Province": "Živinice"
    },
    {
     "Country": "Bosnia and Herzegovina",
     "Region": "Southern Europe",
     "Province": "Bihać"
    },
    {
     "Country": "Bosnia and Herzegovina",
     "Region": "Southern Europe",
     "Province": "Travnik"
    },
    {
     "Country": "Bosnia and Herzegovina",
     "Region": "Southern Europe",
     "Province": "Gračanica"
    },
    {
     "Country": "Bosnia and Herzegovina",
     "Region": "Southern Europe",
     "Province": "Lukavac"
    },
    {
     "Country": "Bosnia and Herzegovina",
     "Region": "Southern Europe",
     "Province": "Tešanj"
    },
    {
     "Country": "Bosnia and Herzegovina",
     "Region": "Southern Europe",
     "Province": "Gradačac"
    },
    {
     "Country": "Bosnia and Herzegovina",
     "Region": "Southern Europe",
     "Province": "Sanski Most"
    },
    {
     "Country": "Bosnia and Herzegovina",
     "Region": "Southern Europe",
     "Province": "Visoko"
    },
    {
     "Country": "Bosnia and Herzegovina",
     "Region": "Southern Europe",
     "Province": "Velika Kladuša"
    },
    {
     "Country": "Bosnia and Herzegovina",
     "Region": "Southern Europe",
     "Province": "Zavidovići"
    },
    {
     "Country": "Bosnia and Herzegovina",
     "Region": "Southern Europe",
     "Province": "Srebrenik"
    },
    {
     "Country": "Bosnia and Herzegovina",
     "Region": "Southern Europe",
     "Province": "Kakanj"
    },
    {
     "Country": "Bosnia and Herzegovina",
     "Region": "Southern Europe",
     "Province": "Livno"
    },
    {
     "Country": "Bosnia and Herzegovina",
     "Region": "Southern Europe",
     "Province": "Banja Luka"
    },
    {
     "Country": "Bosnia and Herzegovina",
     "Region": "Southern Europe",
     "Province": "Bijeljina"
    },
    {
     "Country": "Bosnia and Herzegovina",
     "Region": "Southern Europe",
     "Province": "Prijedor"
    },
    {
     "Country": "Bosnia and Herzegovina",
     "Region": "Southern Europe",
     "Province": "Doboj"
    },
    {
     "Country": "Bosnia and Herzegovina",
     "Region": "Southern Europe",
     "Province": "Istočno Sarajevo"
    },
    {
     "Country": "Bosnia and Herzegovina",
     "Region": "Southern Europe",
     "Province": "Zvornik"
    },
    {
     "Country": "Bosnia and Herzegovina",
     "Region": "Southern Europe",
     "Province": "Gradiška"
    },
    {
     "Country": "Bosnia and Herzegovina",
     "Region": "Southern Europe",
     "Province": "Teslić"
    },
    {
     "Country": "Bosnia and Herzegovina",
     "Region": "Southern Europe",
     "Province": "Prnjavor"
    },
    {
     "Country": "Bosnia and Herzegovina",
     "Region": "Southern Europe",
     "Province": "Laktaši"
    },
    {
     "Country": "Botswana",
     "Region": "Southern Africa",
     "Province": "Southern District"
    },
    {
     "Country": "Botswana",
     "Region": "Southern Africa",
     "Province": "South-East District"
    },
    {
     "Country": "Botswana",
     "Region": "Southern Africa",
     "Province": "Kweneng District"
    },
    {
     "Country": "Botswana",
     "Region": "Southern Africa",
     "Province": "Kgatleng District"
    },
    {
     "Country": "Botswana",
     "Region": "Southern Africa",
     "Province": "Central District"
    },
    {
     "Country": "Botswana",
     "Region": "Southern Africa",
     "Province": "North-East District"
    },
    {
     "Country": "Botswana",
     "Region": "Southern Africa",
     "Province": "North-West District"
    },
    {
     "Country": "Botswana",
     "Region": "Southern Africa",
     "Province": "Ghanzi District"
    },
    {
     "Country": "Botswana",
     "Region": "Southern Africa",
     "Province": "Kgalagadi District"
    },
    {
     "Country": "Botswana",
     "Region": "Southern Africa",
     "Province": "Gaborone city"
    },
    {
     "Country": "Botswana",
     "Region": "Southern Africa",
     "Province": "Francistown city"
    },
    {
     "Country": "Botswana",
     "Region": "Southern Africa",
     "Province": "Lobatse town"
    },
    {
     "Country": "Botswana",
     "Region": "Southern Africa",
     "Province": "Selebi-Phikwe town"
    },
    {
     "Country": "Botswana",
     "Region": "Southern Africa",
     "Province": "Orapa town"
    },
    {
     "Country": "Botswana",
     "Region": "Southern Africa",
     "Province": "Jwaneng town"
    },
    {
     "Country": "Botswana",
     "Region": "Southern Africa",
     "Province": "Sowa town"
    },
    {
     "Country": "Brazil",
     "Region": "Central Eastern South America",
     "Province": " Acre"
    },
    {
     "Country": "Brazil",
     "Region": "Central Eastern South America",
     "Province": " Alagoas"
    },
    {
     "Country": "Brazil",
     "Region": "Central Eastern South America",
     "Province": " Amapá"
    },
    {
     "Country": "Brazil",
     "Region": "Central Eastern South America",
     "Province": " Amazonas"
    },
    {
     "Country": "Brazil",
     "Region": "Central Eastern South America",
     "Province": " Bahia"
    },
    {
     "Country": "Brazil",
     "Region": "Central Eastern South America",
     "Province": " Ceará"
    },
    {
     "Country": "Brazil",
     "Region": "Central Eastern South America",
     "Province": " Distrito Federal"
    },
    {
     "Country": "Brazil",
     "Region": "Central Eastern South America",
     "Province": " Espírito Santo"
    },
    {
     "Country": "Brazil",
     "Region": "Central Eastern South America",
     "Province": " Goiás"
    },
    {
     "Country": "Brazil",
     "Region": "Central Eastern South America",
     "Province": " Maranhão"
    },
    {
     "Country": "Brazil",
     "Region": "Central Eastern South America",
     "Province": " Mato Grosso"
    },
    {
     "Country": "Brazil",
     "Region": "Central Eastern South America",
     "Province": " Mato Grosso do Sul"
    },
    {
     "Country": "Brazil",
     "Region": "Central Eastern South America",
     "Province": " Minas Gerais"
    },
    {
     "Country": "Brazil",
     "Region": "Central Eastern South America",
     "Province": " Pará"
    },
    {
     "Country": "Brazil",
     "Region": "Central Eastern South America",
     "Province": " Paraíba"
    },
    {
     "Country": "Brazil",
     "Region": "Central Eastern South America",
     "Province": " Paraná"
    },
    {
     "Country": "Brazil",
     "Region": "Central Eastern South America",
     "Province": " Pernambuco"
    },
    {
     "Country": "Brazil",
     "Region": "Central Eastern South America",
     "Province": " Piauí"
    },
    {
     "Country": "Brazil",
     "Region": "Central Eastern South America",
     "Province": " Rio de Janeiro"
    },
    {
     "Country": "Brazil",
     "Region": "Central Eastern South America",
     "Province": " Rio Grande do Norte"
    },
    {
     "Country": "Brazil",
     "Region": "Central Eastern South America",
     "Province": " Rio Grande do Sul"
    },
    {
     "Country": "Brazil",
     "Region": "Central Eastern South America",
     "Province": " Rondônia"
    },
    {
     "Country": "Brazil",
     "Region": "Central Eastern South America",
     "Province": " Roraima"
    },
    {
     "Country": "Brazil",
     "Region": "Central Eastern South America",
     "Province": " Santa Catarina"
    },
    {
     "Country": "Brazil",
     "Region": "Central Eastern South America",
     "Province": " São Paulo"
    },
    {
     "Country": "Brazil",
     "Region": "Central Eastern South America",
     "Province": " Sergipe"
    },
    {
     "Country": "Brazil",
     "Region": "Central Eastern South America",
     "Province": " Tocantins"
    },
    {
     "Country": "Brunei Darussalam",
     "Region": "Southeast Asia",
     "Province": "Brunei-Muara"
    },
    {
     "Country": "Brunei Darussalam",
     "Region": "Southeast Asia",
     "Province": "Belait"
    },
    {
     "Country": "Brunei Darussalam",
     "Region": "Southeast Asia",
     "Province": "Tutong"
    },
    {
     "Country": "Brunei Darussalam",
     "Region": "Southeast Asia",
     "Province": "Temburong"
    },
    {
     "Country": "Bulgaria",
     "Region": "Balkan, Eastern Europe",
     "Province": "Blagoevgrad"
    },
    {
     "Country": "Bulgaria",
     "Region": "Balkan, Eastern Europe",
     "Province": "Burgas"
    },
    {
     "Country": "Bulgaria",
     "Region": "Balkan, Eastern Europe",
     "Province": "Dobrich"
    },
    {
     "Country": "Bulgaria",
     "Region": "Balkan, Eastern Europe",
     "Province": "Gabrovo"
    },
    {
     "Country": "Bulgaria",
     "Region": "Balkan, Eastern Europe",
     "Province": "Haskovo"
    },
    {
     "Country": "Bulgaria",
     "Region": "Balkan, Eastern Europe",
     "Province": "Kardzhali"
    },
    {
     "Country": "Bulgaria",
     "Region": "Balkan, Eastern Europe",
     "Province": "Kyustendil"
    },
    {
     "Country": "Bulgaria",
     "Region": "Balkan, Eastern Europe",
     "Province": "Lovech"
    },
    {
     "Country": "Bulgaria",
     "Region": "Balkan, Eastern Europe",
     "Province": "Montana"
    },
    {
     "Country": "Bulgaria",
     "Region": "Balkan, Eastern Europe",
     "Province": "Pazardzhik"
    },
    {
     "Country": "Bulgaria",
     "Region": "Balkan, Eastern Europe",
     "Province": "Pernik"
    },
    {
     "Country": "Bulgaria",
     "Region": "Balkan, Eastern Europe",
     "Province": "Pleven"
    },
    {
     "Country": "Bulgaria",
     "Region": "Balkan, Eastern Europe",
     "Province": "Plovdiv"
    },
    {
     "Country": "Bulgaria",
     "Region": "Balkan, Eastern Europe",
     "Province": "Razgrad"
    },
    {
     "Country": "Bulgaria",
     "Region": "Balkan, Eastern Europe",
     "Province": "Ruse"
    },
    {
     "Country": "Bulgaria",
     "Region": "Balkan, Eastern Europe",
     "Province": "Shumen"
    },
    {
     "Country": "Bulgaria",
     "Region": "Balkan, Eastern Europe",
     "Province": "Silistra"
    },
    {
     "Country": "Bulgaria",
     "Region": "Balkan, Eastern Europe",
     "Province": "Sliven"
    },
    {
     "Country": "Bulgaria",
     "Region": "Balkan, Eastern Europe",
     "Province": "Smolyan"
    },
    {
     "Country": "Bulgaria",
     "Region": "Balkan, Eastern Europe",
     "Province": "Sofia City"
    },
    {
     "Country": "Bulgaria",
     "Region": "Balkan, Eastern Europe",
     "Province": "Sofia Province"
    },
    {
     "Country": "Bulgaria",
     "Region": "Balkan, Eastern Europe",
     "Province": "Stara Zagora"
    },
    {
     "Country": "Bulgaria",
     "Region": "Balkan, Eastern Europe",
     "Province": "Targovishte"
    },
    {
     "Country": "Bulgaria",
     "Region": "Balkan, Eastern Europe",
     "Province": "Varna"
    },
    {
     "Country": "Bulgaria",
     "Region": "Balkan, Eastern Europe",
     "Province": "Veliko Tarnovo"
    },
    {
     "Country": "Bulgaria",
     "Region": "Balkan, Eastern Europe",
     "Province": "Vidin"
    },
    {
     "Country": "Bulgaria",
     "Region": "Balkan, Eastern Europe",
     "Province": "Vratsa"
    },
    {
     "Country": "Bulgaria",
     "Region": "Balkan, Eastern Europe",
     "Province": "Yambol"
    },
    {
     "Country": "Burkina Faso",
     "Region": "West Africa",
     "Province": "Boucle du Mouhoun"
    },
    {
     "Country": "Burkina Faso",
     "Region": "West Africa",
     "Province": "Cascades"
    },
    {
     "Country": "Burkina Faso",
     "Region": "West Africa",
     "Province": "Centre"
    },
    {
     "Country": "Burkina Faso",
     "Region": "West Africa",
     "Province": "Centre-Est"
    },
    {
     "Country": "Burkina Faso",
     "Region": "West Africa",
     "Province": "Centre-Nord"
    },
    {
     "Country": "Burkina Faso",
     "Region": "West Africa",
     "Province": "Centre-Ouest"
    },
    {
     "Country": "Burkina Faso",
     "Region": "West Africa",
     "Province": "Centre-Sud"
    },
    {
     "Country": "Burkina Faso",
     "Region": "West Africa",
     "Province": "Est"
    },
    {
     "Country": "Burkina Faso",
     "Region": "West Africa",
     "Province": "Hauts-Bassins"
    },
    {
     "Country": "Burkina Faso",
     "Region": "West Africa",
     "Province": "Nord"
    },
    {
     "Country": "Burkina Faso",
     "Region": "West Africa",
     "Province": "Plateau-Central"
    },
    {
     "Country": "Burkina Faso",
     "Region": "West Africa",
     "Province": "Sahel"
    },
    {
     "Country": "Burkina Faso",
     "Region": "West Africa",
     "Province": "Sud-Ouest"
    },
    {
     "Country": "Burundi",
     "Region": "Eastern Africa, African Great Lakes",
     "Province": "Eastern Burundi"
    },
    {
     "Country": "Burundi",
     "Region": "Eastern Africa, African Great Lakes",
     "Province": "Cankuzo"
    },
    {
     "Country": "Burundi",
     "Region": "Eastern Africa, African Great Lakes",
     "Province": "Gitega"
    },
    {
     "Country": "Burundi",
     "Region": "Eastern Africa, African Great Lakes",
     "Province": "Rutana"
    },
    {
     "Country": "Burundi",
     "Region": "Eastern Africa, African Great Lakes",
     "Province": "Ruyigi"
    },
    {
     "Country": "Burundi",
     "Region": "Eastern Africa, African Great Lakes",
     "Province": "Northern Burundi"
    },
    {
     "Country": "Burundi",
     "Region": "Eastern Africa, African Great Lakes",
     "Province": "Karuzi"
    },
    {
     "Country": "Burundi",
     "Region": "Eastern Africa, African Great Lakes",
     "Province": "Kayanza"
    },
    {
     "Country": "Burundi",
     "Region": "Eastern Africa, African Great Lakes",
     "Province": "Kirundo"
    },
    {
     "Country": "Burundi",
     "Region": "Eastern Africa, African Great Lakes",
     "Province": "Muyinga"
    },
    {
     "Country": "Burundi",
     "Region": "Eastern Africa, African Great Lakes",
     "Province": "Ngozi"
    },
    {
     "Country": "Burundi",
     "Region": "Eastern Africa, African Great Lakes",
     "Province": "Southern Burundi"
    },
    {
     "Country": "Burundi",
     "Region": "Eastern Africa, African Great Lakes",
     "Province": "Bururi"
    },
    {
     "Country": "Burundi",
     "Region": "Eastern Africa, African Great Lakes",
     "Province": "Makamba"
    },
    {
     "Country": "Burundi",
     "Region": "Eastern Africa, African Great Lakes",
     "Province": "Rumonge"
    },
    {
     "Country": "Burundi",
     "Region": "Eastern Africa, African Great Lakes",
     "Province": "Western Burundi"
    },
    {
     "Country": "Burundi",
     "Region": "Eastern Africa, African Great Lakes",
     "Province": "Bubanza"
    },
    {
     "Country": "Burundi",
     "Region": "Eastern Africa, African Great Lakes",
     "Province": "Bujumbura Mairie"
    },
    {
     "Country": "Burundi",
     "Region": "Eastern Africa, African Great Lakes",
     "Province": "Bujumbura Rural"
    },
    {
     "Country": "Burundi",
     "Region": "Eastern Africa, African Great Lakes",
     "Province": "Cibitoke"
    },
    {
     "Country": "Burundi",
     "Region": "Eastern Africa, African Great Lakes",
     "Province": "Muramvya"
    },
    {
     "Country": "Burundi",
     "Region": "Eastern Africa, African Great Lakes",
     "Province": "Mwaro"
    },
    {
     "Country": "Cambodia",
     "Region": "South-East Asia",
     "Province": "Banteay Meanchey"
    },
    {
     "Country": "Cambodia",
     "Region": "South-East Asia",
     "Province": "Battambang"
    },
    {
     "Country": "Cambodia",
     "Region": "South-East Asia",
     "Province": "Kampong Cham"
    },
    {
     "Country": "Cambodia",
     "Region": "South-East Asia",
     "Province": "Kampong Chhnang"
    },
    {
     "Country": "Cambodia",
     "Region": "South-East Asia",
     "Province": "Kampong Speu"
    },
    {
     "Country": "Cambodia",
     "Region": "South-East Asia",
     "Province": "Kampong Thom"
    },
    {
     "Country": "Cambodia",
     "Region": "South-East Asia",
     "Province": "Kampot"
    },
    {
     "Country": "Cambodia",
     "Region": "South-East Asia",
     "Province": "Kandal"
    },
    {
     "Country": "Cambodia",
     "Region": "South-East Asia",
     "Province": "Kep"
    },
    {
     "Country": "Cambodia",
     "Region": "South-East Asia",
     "Province": "Koh Kong"
    },
    {
     "Country": "Cambodia",
     "Region": "South-East Asia",
     "Province": "Kratié"
    },
    {
     "Country": "Cambodia",
     "Region": "South-East Asia",
     "Province": "Mondulkiri"
    },
    {
     "Country": "Cambodia",
     "Region": "South-East Asia",
     "Province": "Oddar Meanchey"
    },
    {
     "Country": "Cambodia",
     "Region": "South-East Asia",
     "Province": "Pailin"
    },
    {
     "Country": "Cambodia",
     "Region": "South-East Asia",
     "Province": "Phnom Penh"
    },
    {
     "Country": "Cambodia",
     "Region": "South-East Asia",
     "Province": "Preah Sihanouk"
    },
    {
     "Country": "Cambodia",
     "Region": "South-East Asia",
     "Province": "Preah Vihear"
    },
    {
     "Country": "Cambodia",
     "Region": "South-East Asia",
     "Province": "Prey Veng"
    },
    {
     "Country": "Cambodia",
     "Region": "South-East Asia",
     "Province": "Pursat"
    },
    {
     "Country": "Cambodia",
     "Region": "South-East Asia",
     "Province": "Ratanakiri"
    },
    {
     "Country": "Cambodia",
     "Region": "South-East Asia",
     "Province": "Siem Reap"
    },
    {
     "Country": "Cambodia",
     "Region": "South-East Asia",
     "Province": "Stung Treng"
    },
    {
     "Country": "Cambodia",
     "Region": "South-East Asia",
     "Province": "Svay Rieng"
    },
    {
     "Country": "Cambodia",
     "Region": "South-East Asia",
     "Province": "Takéo"
    },
    {
     "Country": "Cambodia",
     "Region": "South-East Asia",
     "Province": "Tboung Khmum"
    },
    {
     "Country": "Cameroon",
     "Region": "Central Africa",
     "Province": "Adamawa"
    },
    {
     "Country": "Cameroon",
     "Region": "Central Africa",
     "Province": "Centre"
    },
    {
     "Country": "Cameroon",
     "Region": "Central Africa",
     "Province": "East"
    },
    {
     "Country": "Cameroon",
     "Region": "Central Africa",
     "Province": "Far North"
    },
    {
     "Country": "Cameroon",
     "Region": "Central Africa",
     "Province": "Littoral"
    },
    {
     "Country": "Cameroon",
     "Region": "Central Africa",
     "Province": "North"
    },
    {
     "Country": "Cameroon",
     "Region": "Central Africa",
     "Province": "Northwest"
    },
    {
     "Country": "Cameroon",
     "Region": "Central Africa",
     "Province": "South"
    },
    {
     "Country": "Cameroon",
     "Region": "Central Africa",
     "Province": "Southwest"
    },
    {
     "Country": "Cameroon",
     "Region": "Central Africa",
     "Province": "West"
    },
    {
     "Country": "Canada",
     "Region": "North North America",
     "Province": "Ontario"
    },
    {
     "Country": "Canada",
     "Region": "North North America",
     "Province": "Quebec"
    },
    {
     "Country": "Canada",
     "Region": "North North America",
     "Province": "Nova Scotia"
    },
    {
     "Country": "Canada",
     "Region": "North North America",
     "Province": "New Brunswick"
    },
    {
     "Country": "Canada",
     "Region": "North North America",
     "Province": "Manitoba"
    },
    {
     "Country": "Canada",
     "Region": "North North America",
     "Province": "British Columbia"
    },
    {
     "Country": "Canada",
     "Region": "North North America",
     "Province": "Prince Edward Island"
    },
    {
     "Country": "Canada",
     "Region": "North North America",
     "Province": "Saskatchewan"
    },
    {
     "Country": "Canada",
     "Region": "North North America",
     "Province": "Alberta"
    },
    {
     "Country": "Canada",
     "Region": "North North America",
     "Province": "Newfoundland and Labrador"
    },
    {
     "Country": "Canada",
     "Region": "North North America",
     "Province": "Toronto"
    },
    {
     "Country": "Canada",
     "Region": "North North America",
     "Province": "Quebec City"
    },
    {
     "Country": "Canada",
     "Region": "North North America",
     "Province": "Halifax"
    },
    {
     "Country": "Canada",
     "Region": "North North America",
     "Province": "Fredericton"
    },
    {
     "Country": "Canada",
     "Region": "North North America",
     "Province": "Winnipeg"
    },
    {
     "Country": "Canada",
     "Region": "North North America",
     "Province": "Victoria"
    },
    {
     "Country": "Canada",
     "Region": "North North America",
     "Province": "Charlottetown"
    },
    {
     "Country": "Canada",
     "Region": "North North America",
     "Province": "Regina"
    },
    {
     "Country": "Canada",
     "Region": "North North America",
     "Province": "Edmonton"
    },
    {
     "Country": "Canada",
     "Region": "North North America",
     "Province": "St. John's"
    },
    {
     "Country": "Cape Verde",
     "Region": "West Africa",
     "Province": "Tarrafal"
    },
    {
     "Country": "Cape Verde",
     "Region": "West Africa",
     "Province": "São Miguel"
    },
    {
     "Country": "Cape Verde",
     "Region": "West Africa",
     "Province": "São Salvador do Mundo"
    },
    {
     "Country": "Cape Verde",
     "Region": "West Africa",
     "Province": "Santa Cruz"
    },
    {
     "Country": "Cape Verde",
     "Region": "West Africa",
     "Province": "São Domingos"
    },
    {
     "Country": "Cape Verde",
     "Region": "West Africa",
     "Province": "Praia"
    },
    {
     "Country": "Cape Verde",
     "Region": "West Africa",
     "Province": "Ribeira Grande de Santiago"
    },
    {
     "Country": "Cape Verde",
     "Region": "West Africa",
     "Province": "São Lourenço dos Órgãos"
    },
    {
     "Country": "Cape Verde",
     "Region": "West Africa",
     "Province": "Santa Catarina"
    },
    {
     "Country": "Cape Verde",
     "Region": "West Africa",
     "Province": "Brava"
    },
    {
     "Country": "Cape Verde",
     "Region": "West Africa",
     "Province": "São Filipe"
    },
    {
     "Country": "Cayman Islands",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Bodden Town"
    },
    {
     "Country": "Cayman Islands",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Cayman Brac"
    },
    {
     "Country": "Cayman Islands",
     "Region": "Greater Antilles, Caribbean",
     "Province": "East End"
    },
    {
     "Country": "Cayman Islands",
     "Region": "Greater Antilles, Caribbean",
     "Province": "George Town"
    },
    {
     "Country": "Cayman Islands",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Little Cayman"
    },
    {
     "Country": "Cayman Islands",
     "Region": "Greater Antilles, Caribbean",
     "Province": "North Side"
    },
    {
     "Country": "Cayman Islands",
     "Region": "Greater Antilles, Caribbean",
     "Province": "West Bay"
    },
    {
     "Country": "Cayman Islands",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Cayman Islands"
    },
    {
     "Country": "Central African Republic",
     "Region": "Central Africa",
     "Province": "Bangui"
    },
    {
     "Country": "Central African Republic",
     "Region": "Central Africa",
     "Province": "Mbomou"
    },
    {
     "Country": "Central African Republic",
     "Region": "Central Africa",
     "Province": "Basse-Kotto"
    },
    {
     "Country": "Central African Republic",
     "Region": "Central Africa",
     "Province": "Kémo"
    },
    {
     "Country": "Central African Republic",
     "Region": "Central Africa",
     "Province": "Nana-Mambéré"
    },
    {
     "Country": "Central African Republic",
     "Region": "Central Africa",
     "Province": "Ouham"
    },
    {
     "Country": "Central African Republic",
     "Region": "Central Africa",
     "Province": "Sangha-Mbaéré"
    },
    {
     "Country": "Central African Republic",
     "Region": "Central Africa",
     "Province": "Lobaye"
    },
    {
     "Country": "Central African Republic",
     "Region": "Central Africa",
     "Province": "Ombella-M'Poko"
    },
    {
     "Country": "Central African Republic",
     "Region": "Central Africa",
     "Province": "Ouham-Pendé"
    },
    {
     "Country": "Central African Republic",
     "Region": "Central Africa",
     "Province": "Haut-Mbomou"
    },
    {
     "Country": "Central African Republic",
     "Region": "Central Africa",
     "Province": "Ouaka"
    },
    {
     "Country": "Central African Republic",
     "Region": "Central Africa",
     "Province": "Haute-Kotto"
    },
    {
     "Country": "Central African Republic",
     "Region": "Central Africa",
     "Province": "Bamingui-Bangoran"
    },
    {
     "Country": "Central African Republic",
     "Region": "Central Africa",
     "Province": "Vakaga"
    },
    {
     "Country": "Central African Republic",
     "Region": "Central Africa",
     "Province": "Nana-Grébizi"
    },
    {
     "Country": "Central African Republic",
     "Region": "Central Africa",
     "Province": "Mambéré-Kadéï"
    },
    {
     "Country": "Central African Republic",
     "Region": "Central Africa",
     "Province": "Mambéré"
    },
    {
     "Country": "Central African Republic",
     "Region": "Central Africa",
     "Province": "Lim-Pendé"
    },
    {
     "Country": "Central African Republic",
     "Region": "Central Africa",
     "Province": "Ouham-Fafa"
    },
    {
     "Country": "Chad",
     "Region": "Central Africa",
     "Province": "Batha"
    },
    {
     "Country": "Chad",
     "Region": "Central Africa",
     "Province": "Chari-Baguirmi"
    },
    {
     "Country": "Chad",
     "Region": "Central Africa",
     "Province": "Hadjer-Lamis"
    },
    {
     "Country": "Chad",
     "Region": "Central Africa",
     "Province": "Wadi Fira"
    },
    {
     "Country": "Chad",
     "Region": "Central Africa",
     "Province": "Bahr el Gazel"
    },
    {
     "Country": "Chad",
     "Region": "Central Africa",
     "Province": "Borkou"
    },
    {
     "Country": "Chad",
     "Region": "Central Africa",
     "Province": "Ennedi-Est"
    },
    {
     "Country": "Chad",
     "Region": "Central Africa",
     "Province": "Ennedi-Ouest"
    },
    {
     "Country": "Chad",
     "Region": "Central Africa",
     "Province": "Guéra"
    },
    {
     "Country": "Chad",
     "Region": "Central Africa",
     "Province": "Kanem"
    },
    {
     "Country": "Chad",
     "Region": "Central Africa",
     "Province": "Lac"
    },
    {
     "Country": "Chad",
     "Region": "Central Africa",
     "Province": "Logone Occidental"
    },
    {
     "Country": "Chad",
     "Region": "Central Africa",
     "Province": "Logone Oriental"
    },
    {
     "Country": "Chad",
     "Region": "Central Africa",
     "Province": "Mandoul"
    },
    {
     "Country": "Chad",
     "Region": "Central Africa",
     "Province": "Mayo-Kebbi Est"
    },
    {
     "Country": "Chad",
     "Region": "Central Africa",
     "Province": "Mayo-Kebbi Ouest"
    },
    {
     "Country": "Chad",
     "Region": "Central Africa",
     "Province": "Moyen-Chari"
    },
    {
     "Country": "Chad",
     "Region": "Central Africa",
     "Province": "Ouaddaï"
    },
    {
     "Country": "Chad",
     "Region": "Central Africa",
     "Province": "Salamat"
    },
    {
     "Country": "Chad",
     "Region": "Central Africa",
     "Province": "Sila"
    },
    {
     "Country": "Chad",
     "Region": "Central Africa",
     "Province": "Tandjilé"
    },
    {
     "Country": "Chad",
     "Region": "Central Africa",
     "Province": "Tibesti"
    },
    {
     "Country": "Chad",
     "Region": "Central Africa",
     "Province": "N'Djamena (capital)"
    },
    {
     "Country": "Chile",
     "Region": "Western South America",
     "Province": "Arica and Parinacota"
    },
    {
     "Country": "Chile",
     "Region": "Western South America",
     "Province": "Región de Arica y Parinacota"
    },
    {
     "Country": "Chile",
     "Region": "Western South America",
     "Province": "Tarapacá"
    },
    {
     "Country": "Chile",
     "Region": "Western South America",
     "Province": "Región de Tarapacá"
    },
    {
     "Country": "Chile",
     "Region": "Western South America",
     "Province": "Antofagasta"
    },
    {
     "Country": "Chile",
     "Region": "Western South America",
     "Province": "Región de Antofagasta"
    },
    {
     "Country": "Chile",
     "Region": "Western South America",
     "Province": "Atacama"
    },
    {
     "Country": "Chile",
     "Region": "Western South America",
     "Province": "Región de Atacama"
    },
    {
     "Country": "Chile",
     "Region": "Western South America",
     "Province": "Coquimbo"
    },
    {
     "Country": "Chile",
     "Region": "Western South America",
     "Province": "Región de Coquimbo"
    },
    {
     "Country": "Chile",
     "Region": "Western South America",
     "Province": "Valparaíso"
    },
    {
     "Country": "Chile",
     "Region": "Western South America",
     "Province": "Región de Valparaíso"
    },
    {
     "Country": "Chile",
     "Region": "Western South America",
     "Province": "Metropolitan"
    },
    {
     "Country": "Chile",
     "Region": "Western South America",
     "Province": "Región Metropolitana de Santiago"
    },
    {
     "Country": "Chile",
     "Region": "Western South America",
     "Province": "O'Higgins"
    },
    {
     "Country": "Chile",
     "Region": "Western South America",
     "Province": "Región del Libertador General Bernardo O'Higgins"
    },
    {
     "Country": "Chile",
     "Region": "Western South America",
     "Province": "Maule"
    },
    {
     "Country": "Chile",
     "Region": "Western South America",
     "Province": "Región del Maule"
    },
    {
     "Country": "Chile",
     "Region": "Western South America",
     "Province": "Ñuble"
    },
    {
     "Country": "Chile",
     "Region": "Western South America",
     "Province": "Región de Ñuble"
    },
    {
     "Country": "Chile",
     "Region": "Western South America",
     "Province": "Biobío"
    },
    {
     "Country": "Chile",
     "Region": "Western South America",
     "Province": "Región del Biobío"
    },
    {
     "Country": "Chile",
     "Region": "Western South America",
     "Province": "Araucanía"
    },
    {
     "Country": "Chile",
     "Region": "Western South America",
     "Province": "Región de La Araucanía"
    },
    {
     "Country": "Chile",
     "Region": "Western South America",
     "Province": "Los Ríos"
    },
    {
     "Country": "Chile",
     "Region": "Western South America",
     "Province": "Región de Los Ríos"
    },
    {
     "Country": "Chile",
     "Region": "Western South America",
     "Province": "Los Lagos"
    },
    {
     "Country": "Chile",
     "Region": "Western South America",
     "Province": "Región de Los Lagos"
    },
    {
     "Country": "Chile",
     "Region": "Western South America",
     "Province": "Aysén"
    },
    {
     "Country": "Chile",
     "Region": "Western South America",
     "Province": "Región Aysén del General Carlos Ibáñez del Campo"
    },
    {
     "Country": "Chile",
     "Region": "Western South America",
     "Province": "Magallanes"
    },
    {
     "Country": "Chile",
     "Region": "Western South America",
     "Province": "Región de Magallanes y de la Antártica Chilena"
    },
    {
     "Country": "China",
     "Region": "Eastern Asia",
     "Province": "Hebei"
    },
    {
     "Country": "China",
     "Region": "Eastern Asia",
     "Province": "Shanxi"
    },
    {
     "Country": "China",
     "Region": "Eastern Asia",
     "Province": "Liaoning"
    },
    {
     "Country": "China",
     "Region": "Eastern Asia",
     "Province": "Jilin"
    },
    {
     "Country": "China",
     "Region": "Eastern Asia",
     "Province": "Heilongjiang"
    },
    {
     "Country": "China",
     "Region": "Eastern Asia",
     "Province": "Jiangsu"
    },
    {
     "Country": "China",
     "Region": "Eastern Asia",
     "Province": "Zhejiang"
    },
    {
     "Country": "China",
     "Region": "Eastern Asia",
     "Province": "Anhui"
    },
    {
     "Country": "China",
     "Region": "Eastern Asia",
     "Province": "Fujian"
    },
    {
     "Country": "China",
     "Region": "Eastern Asia",
     "Province": "Jiangxi"
    },
    {
     "Country": "China",
     "Region": "Eastern Asia",
     "Province": "Shandong"
    },
    {
     "Country": "China",
     "Region": "Eastern Asia",
     "Province": "Henan"
    },
    {
     "Country": "China",
     "Region": "Eastern Asia",
     "Province": "Hubei"
    },
    {
     "Country": "China",
     "Region": "Eastern Asia",
     "Province": "Hunan"
    },
    {
     "Country": "China",
     "Region": "Eastern Asia",
     "Province": "Guangdong"
    },
    {
     "Country": "China",
     "Region": "Eastern Asia",
     "Province": "Hainan"
    },
    {
     "Country": "China",
     "Region": "Eastern Asia",
     "Province": "Sichuan"
    },
    {
     "Country": "China",
     "Region": "Eastern Asia",
     "Province": "Guizhou"
    },
    {
     "Country": "China",
     "Region": "Eastern Asia",
     "Province": "Yunnan"
    },
    {
     "Country": "China",
     "Region": "Eastern Asia",
     "Province": "Shaanxi"
    },
    {
     "Country": "China",
     "Region": "Eastern Asia",
     "Province": "Gansu"
    },
    {
     "Country": "China",
     "Region": "Eastern Asia",
     "Province": "Qinghai"
    },
    {
     "Country": "China",
     "Region": "Eastern Asia",
     "Province": "Taiwan"
    },
    {
     "Country": "Cocos (Keeling) Islands",
     "Region": "South-East Asia, Australia",
     "Province": "Aindil Minkom"
    },
    {
     "Country": "Cocos (Keeling) Islands",
     "Region": "South-East Asia, Australia",
     "Province": "Isa Minkom"
    },
    {
     "Country": "Cocos (Keeling) Islands",
     "Region": "South-East Asia, Australia",
     "Province": "Ayesha Young"
    },
    {
     "Country": "Cocos (Keeling) Islands",
     "Region": "South-East Asia, Australia",
     "Province": "Tony Lacy"
    },
    {
     "Country": "Cocos (Keeling) Islands",
     "Region": "South-East Asia, Australia",
     "Province": "Signa Knight"
    },
    {
     "Country": "Cocos (Keeling) Islands",
     "Region": "South-East Asia, Australia",
     "Province": "Osman Sloan"
    },
    {
     "Country": "Cocos (Keeling) Islands",
     "Region": "South-East Asia, Australia",
     "Province": "Azah Badlu"
    },
    {
     "Country": "Colombia",
     "Region": "North West South America",
     "Province": "Bouélachamba"
    },
    {
     "Country": "Comoros",
     "Region": "Eastern Africa",
     "Province": "Bouelamahombe"
    },
    {
     "Country": "Comoros",
     "Region": "Eastern Africa",
     "Province": "Mbouzi"
    },
    {
     "Country": "Comoros",
     "Region": "Eastern Africa",
     "Province": "Bouelamanga"
    },
    {
     "Country": "Comoros",
     "Region": "Eastern Africa",
     "Province": "Chikoundo"
    },
    {
     "Country": "Comoros",
     "Region": "Eastern Africa",
     "Province": "Gnandza"
    },
    {
     "Country": "Comoros",
     "Region": "Eastern Africa",
     "Province": "Mchaco"
    },
    {
     "Country": "Comoros",
     "Region": "Eastern Africa",
     "Province": "Foro"
    },
    {
     "Country": "Comoros",
     "Region": "Eastern Africa",
     "Province": "Mea"
    },
    {
     "Country": "Comoros",
     "Region": "Eastern Africa",
     "Province": "Bouelamiradji"
    },
    {
     "Country": "Comoros",
     "Region": "Eastern Africa",
     "Province": "Mbougo"
    },
    {
     "Country": "Comoros",
     "Region": "Eastern Africa",
     "Province": "Ouenefou"
    },
    {
     "Country": "Comoros",
     "Region": "Eastern Africa",
     "Province": "Kanzoni"
    },
    {
     "Country": "Comoros",
     "Region": "Eastern Africa",
     "Province": "Dzaha"
    },
    {
     "Country": "Comoros",
     "Region": "Eastern Africa",
     "Province": "Magnougni"
    },
    {
     "Country": "Comoros",
     "Region": "Eastern Africa",
     "Province": "Ilot Sanzi"
    },
    {
     "Country": "Comoros",
     "Region": "Eastern Africa",
     "Province": "Mbo Mbili"
    },
    {
     "Country": "Democratic Republic of the Congo (Kinshasa)",
     "Region": "Central Africa",
     "Province": "Kinshasa"
    },
    {
     "Country": "Democratic Republic of the Congo (Kinshasa)",
     "Region": "Central Africa",
     "Province": "Kongo Central"
    },
    {
     "Country": "Democratic Republic of the Congo (Kinshasa)",
     "Region": "Central Africa",
     "Province": "Kwango"
    },
    {
     "Country": "Democratic Republic of the Congo (Kinshasa)",
     "Region": "Central Africa",
     "Province": "Kwilu"
    },
    {
     "Country": "Democratic Republic of the Congo (Kinshasa)",
     "Region": "Central Africa",
     "Province": "Mai-Ndombe"
    },
    {
     "Country": "Democratic Republic of the Congo (Kinshasa)",
     "Region": "Central Africa",
     "Province": "Kasaï"
    },
    {
     "Country": "Democratic Republic of the Congo (Kinshasa)",
     "Region": "Central Africa",
     "Province": "Kasaï-Central"
    },
    {
     "Country": "Democratic Republic of the Congo (Kinshasa)",
     "Region": "Central Africa",
     "Province": "Kasaï-Oriental"
    },
    {
     "Country": "Democratic Republic of the Congo (Kinshasa)",
     "Region": "Central Africa",
     "Province": "Lomami"
    },
    {
     "Country": "Democratic Republic of the Congo (Kinshasa)",
     "Region": "Central Africa",
     "Province": "Sankuru"
    },
    {
     "Country": "Democratic Republic of the Congo (Kinshasa)",
     "Region": "Central Africa",
     "Province": "Maniema"
    },
    {
     "Country": "Democratic Republic of the Congo (Kinshasa)",
     "Region": "Central Africa",
     "Province": "South Kivu"
    },
    {
     "Country": "Democratic Republic of the Congo (Kinshasa)",
     "Region": "Central Africa",
     "Province": "North Kivu"
    },
    {
     "Country": "Democratic Republic of the Congo (Kinshasa)",
     "Region": "Central Africa",
     "Province": "Ituri"
    },
    {
     "Country": "Democratic Republic of the Congo (Kinshasa)",
     "Region": "Central Africa",
     "Province": "Haut-Uele"
    },
    {
     "Country": "Democratic Republic of the Congo (Kinshasa)",
     "Region": "Central Africa",
     "Province": "Tshopo"
    },
    {
     "Country": "Democratic Republic of the Congo (Kinshasa)",
     "Region": "Central Africa",
     "Province": "Bas-Uele"
    },
    {
     "Country": "Democratic Republic of the Congo (Kinshasa)",
     "Region": "Central Africa",
     "Province": "Nord-Ubangi"
    },
    {
     "Country": "Democratic Republic of the Congo (Kinshasa)",
     "Region": "Central Africa",
     "Province": "Mongala"
    },
    {
     "Country": "Democratic Republic of the Congo (Kinshasa)",
     "Region": "Central Africa",
     "Province": "Sud-Ubangi"
    },
    {
     "Country": "Democratic Republic of the Congo (Kinshasa)",
     "Region": "Central Africa",
     "Province": "Équateur"
    },
    {
     "Country": "Democratic Republic of the Congo (Kinshasa)",
     "Region": "Central Africa",
     "Province": "Tshuapa"
    },
    {
     "Country": "Democratic Republic of the Congo (Kinshasa)",
     "Region": "Central Africa",
     "Province": "Tanganyika"
    },
    {
     "Country": "Democratic Republic of the Congo (Kinshasa)",
     "Region": "Central Africa",
     "Province": "Haut-Lomami"
    },
    {
     "Country": "Democratic Republic of the Congo (Kinshasa)",
     "Region": "Central Africa",
     "Province": "Lualaba"
    },
    {
     "Country": "Democratic Republic of the Congo (Kinshasa)",
     "Region": "Central Africa",
     "Province": "Haut-Katanga"
    },
    {
     "Country": "Congo, Republic of (Brazzaville)",
     "Region": "Central Africa",
     "Province": "Kouilou"
    },
    {
     "Country": "Congo, Republic of (Brazzaville)",
     "Region": "Central Africa",
     "Province": "Niari"
    },
    {
     "Country": "Congo, Republic of (Brazzaville)",
     "Region": "Central Africa",
     "Province": "Lékoumou"
    },
    {
     "Country": "Congo, Republic of (Brazzaville)",
     "Region": "Central Africa",
     "Province": "Bouenza"
    },
    {
     "Country": "Congo, Republic of (Brazzaville)",
     "Region": "Central Africa",
     "Province": "Pool"
    },
    {
     "Country": "Congo, Republic of (Brazzaville)",
     "Region": "Central Africa",
     "Province": "Plateaux"
    },
    {
     "Country": "Congo, Republic of (Brazzaville)",
     "Region": "Central Africa",
     "Province": "Cuvette"
    },
    {
     "Country": "Congo, Republic of (Brazzaville)",
     "Region": "Central Africa",
     "Province": "Cuvette-Ouest"
    },
    {
     "Country": "Congo, Republic of (Brazzaville)",
     "Region": "Central Africa",
     "Province": "Sangha"
    },
    {
     "Country": "Congo, Republic of (Brazzaville)",
     "Region": "Central Africa",
     "Province": "Likouala"
    },
    {
     "Country": "Congo, Republic of (Brazzaville)",
     "Region": "Central Africa",
     "Province": "Brazzaville"
    },
    {
     "Country": "Congo, Republic of (Brazzaville)",
     "Region": "Central Africa",
     "Province": "Pointe-Noire"
    },
    {
     "Country": "Cook Islands",
     "Region": "Polynesia, Oceania",
     "Province": "Penrhyn"
    },
    {
     "Country": "Cook Islands",
     "Region": "Polynesia, Oceania",
     "Province": "Rakahanga"
    },
    {
     "Country": "Cook Islands",
     "Region": "Polynesia, Oceania",
     "Province": "Manihiki"
    },
    {
     "Country": "Cook Islands",
     "Region": "Polynesia, Oceania",
     "Province": "Pukapuka"
    },
    {
     "Country": "Cook Islands",
     "Region": "Polynesia, Oceania",
     "Province": "Tema Reef (submerged)"
    },
    {
     "Country": "Cook Islands",
     "Region": "Polynesia, Oceania",
     "Province": "Nassau"
    },
    {
     "Country": "Cook Islands",
     "Region": "Polynesia, Oceania",
     "Province": "Suwarrow"
    },
    {
     "Country": "Cook Islands",
     "Region": "Polynesia, Oceania",
     "Province": "Palmerston"
    },
    {
     "Country": "Cook Islands",
     "Region": "Polynesia, Oceania",
     "Province": "Aitutaki"
    },
    {
     "Country": "Cook Islands",
     "Region": "Polynesia, Oceania",
     "Province": "Manuae"
    },
    {
     "Country": "Cook Islands",
     "Region": "Polynesia, Oceania",
     "Province": "Takutea"
    },
    {
     "Country": "Cook Islands",
     "Region": "Polynesia, Oceania",
     "Province": "Mitiaro"
    },
    {
     "Country": "Cook Islands",
     "Region": "Polynesia, Oceania",
     "Province": "Atiu"
    },
    {
     "Country": "Cook Islands",
     "Region": "Polynesia, Oceania",
     "Province": "Mauke"
    },
    {
     "Country": "Cook Islands",
     "Region": "Polynesia, Oceania",
     "Province": "Winslow Reef (submerged)"
    },
    {
     "Country": "Cook Islands",
     "Region": "Polynesia, Oceania",
     "Province": "Rarotonga"
    },
    {
     "Country": "Cook Islands",
     "Region": "Polynesia, Oceania",
     "Province": "Mangaia"
    },
    {
     "Country": "Costa Rica",
     "Region": "Central America",
     "Province": "Alajuela"
    },
    {
     "Country": "Costa Rica",
     "Region": "Central America",
     "Province": "Cartago"
    },
    {
     "Country": "Costa Rica",
     "Region": "Central America",
     "Province": "Guanacaste"
    },
    {
     "Country": "Costa Rica",
     "Region": "Central America",
     "Province": "Heredia"
    },
    {
     "Country": "Costa Rica",
     "Region": "Central America",
     "Province": "Limón"
    },
    {
     "Country": "Costa Rica",
     "Region": "Central America",
     "Province": "Puntarenas"
    },
    {
     "Country": "Costa Rica",
     "Region": "Central America",
     "Province": "San José"
    },
    {
     "Country": "Croatia",
     "Region": "Balkan Peninsula, Southern Europe",
     "Province": "Križevci "
    },
    {
     "Country": "Croatia",
     "Region": "Balkan Peninsula, Southern Europe",
     "Province": "Požega"
    },
    {
     "Country": "Croatia",
     "Region": "Balkan Peninsula, Southern Europe",
     "Province": "Syrmia"
    },
    {
     "Country": "Croatia",
     "Region": "Balkan Peninsula, Southern Europe",
     "Province": "Varaždin"
    },
    {
     "Country": "Croatia",
     "Region": "Balkan Peninsula, Southern Europe",
     "Province": "Virovitica"
    },
    {
     "Country": "Croatia",
     "Region": "Balkan Peninsula, Southern Europe",
     "Province": "Zagreb"
    },
    {
     "Country": "Croatia",
     "Region": "Balkan Peninsula, Southern Europe",
     "Province": "Littoral"
    },
    {
     "Country": "Croatia",
     "Region": "Balkan Peninsula, Southern Europe",
     "Province": "Bjelovar"
    },
    {
     "Country": "Cuba",
     "Region": "Greater Antilles, Caribbean",
     "Province": " Pinar del Río"
    },
    {
     "Country": "Cuba",
     "Region": "Greater Antilles, Caribbean",
     "Province": " Artemisa"
    },
    {
     "Country": "Cuba",
     "Region": "Greater Antilles, Caribbean",
     "Province": " La Habana"
    },
    {
     "Country": "Cuba",
     "Region": "Greater Antilles, Caribbean",
     "Province": " Mayabeque"
    },
    {
     "Country": "Cuba",
     "Region": "Greater Antilles, Caribbean",
     "Province": " Matanzas"
    },
    {
     "Country": "Cuba",
     "Region": "Greater Antilles, Caribbean",
     "Province": " Cienfuegos"
    },
    {
     "Country": "Cuba",
     "Region": "Greater Antilles, Caribbean",
     "Province": " Villa Clara"
    },
    {
     "Country": "Cuba",
     "Region": "Greater Antilles, Caribbean",
     "Province": " Sancti Spíritus"
    },
    {
     "Country": "Cuba",
     "Region": "Greater Antilles, Caribbean",
     "Province": " Ciego de Ávila"
    },
    {
     "Country": "Cuba",
     "Region": "Greater Antilles, Caribbean",
     "Province": " Camagüey"
    },
    {
     "Country": "Cuba",
     "Region": "Greater Antilles, Caribbean",
     "Province": " Las Tunas"
    },
    {
     "Country": "Cuba",
     "Region": "Greater Antilles, Caribbean",
     "Province": " Granma"
    },
    {
     "Country": "Cuba",
     "Region": "Greater Antilles, Caribbean",
     "Province": " Holguín"
    },
    {
     "Country": "Cuba",
     "Region": "Greater Antilles, Caribbean",
     "Province": " Santiago de Cuba"
    },
    {
     "Country": "Cuba",
     "Region": "Greater Antilles, Caribbean",
     "Province": " Guantánamo"
    },
    {
     "Country": "Cuba",
     "Region": "Greater Antilles, Caribbean",
     "Province": " Isla de la Juventud (\"special municipality\")"
    },
    {
     "Country": "Cyprus",
     "Region": "Mediterranean, Western Asia",
     "Province": "Nicosia "
    },
    {
     "Country": "Cyprus",
     "Region": "Mediterranean, Western Asia",
     "Province": "Limassol "
    },
    {
     "Country": "Cyprus",
     "Region": "Mediterranean, Western Asia",
     "Province": "Larnaca "
    },
    {
     "Country": "Cyprus",
     "Region": "Mediterranean, Western Asia",
     "Province": "Paphos "
    },
    {
     "Country": "Cyprus",
     "Region": "Mediterranean, Western Asia",
     "Province": "Famagusta "
    },
    {
     "Country": "Cyprus",
     "Region": "Mediterranean, Western Asia",
     "Province": "Kyrenia "
    },
    {
     "Country": "Czech Republic",
     "Region": "Eastern Europe",
     "Province": " Prague"
    },
    {
     "Country": "Czech Republic",
     "Region": "Eastern Europe",
     "Province": " Central Bohemian"
    },
    {
     "Country": "Czech Republic",
     "Region": "Eastern Europe",
     "Province": " South Bohemian"
    },
    {
     "Country": "Czech Republic",
     "Region": "Eastern Europe",
     "Province": " Plzeň"
    },
    {
     "Country": "Czech Republic",
     "Region": "Eastern Europe",
     "Province": " Karlovy Vary"
    },
    {
     "Country": "Czech Republic",
     "Region": "Eastern Europe",
     "Province": " Ústí nad Labem"
    },
    {
     "Country": "Czech Republic",
     "Region": "Eastern Europe",
     "Province": " Liberec"
    },
    {
     "Country": "Czech Republic",
     "Region": "Eastern Europe",
     "Province": " Hradec Králové"
    },
    {
     "Country": "Czech Republic",
     "Region": "Eastern Europe",
     "Province": " Pardubice"
    },
    {
     "Country": "Czech Republic",
     "Region": "Eastern Europe",
     "Province": " Vysočina"
    },
    {
     "Country": "Czech Republic",
     "Region": "Eastern Europe",
     "Province": " South Moravian"
    },
    {
     "Country": "Czech Republic",
     "Region": "Eastern Europe",
     "Province": " Olomouc"
    },
    {
     "Country": "Czech Republic",
     "Region": "Eastern Europe",
     "Province": " Zlín"
    },
    {
     "Country": "Czech Republic",
     "Region": "Eastern Europe",
     "Province": " Moravian-Silesian"
    },
    {
     "Country": "Czech Republic",
     "Region": "Eastern Europe",
     "Province": " Czech Republic"
    },
    {
     "Country": "Denmark",
     "Region": "Northern Europe",
     "Province": "Hillerød (Copenhagen)"
    },
    {
     "Country": "Denmark",
     "Region": "Northern Europe",
     "Province": "Viborg (Aarhus)"
    },
    {
     "Country": "Denmark",
     "Region": "Northern Europe",
     "Province": "Aalborg"
    },
    {
     "Country": "Denmark",
     "Region": "Northern Europe",
     "Province": "Sorø (Roskilde)"
    },
    {
     "Country": "Denmark",
     "Region": "Northern Europe",
     "Province": "Vejle (Odense)"
    },
    {
     "Country": "Denmark",
     "Region": "Northern Europe",
     "Province": "Copenhagen"
    },
    {
     "Country": "Djibouti",
     "Region": "Eastern Africa",
     "Province": "Djibouti"
    },
    {
     "Country": "Djibouti",
     "Region": "Eastern Africa",
     "Province": "Ali Sabieh"
    },
    {
     "Country": "Djibouti",
     "Region": "Eastern Africa",
     "Province": "Arta"
    },
    {
     "Country": "Djibouti",
     "Region": "Eastern Africa",
     "Province": "Dikhil"
    },
    {
     "Country": "Djibouti",
     "Region": "Eastern Africa",
     "Province": "Tadjourah"
    },
    {
     "Country": "Djibouti",
     "Region": "Eastern Africa",
     "Province": "Obock"
    },
    {
     "Country": "Dominica",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Saint Andrew"
    },
    {
     "Country": "Dominica",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Saint David"
    },
    {
     "Country": "Dominica",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Saint George"
    },
    {
     "Country": "Dominica",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Saint John"
    },
    {
     "Country": "Dominica",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Saint Joseph"
    },
    {
     "Country": "Dominica",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Saint Luke"
    },
    {
     "Country": "Dominica",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Saint Mark"
    },
    {
     "Country": "Dominica",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Saint Patrick"
    },
    {
     "Country": "Dominica",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Saint Paul"
    },
    {
     "Country": "Dominica",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Saint Peter"
    },
    {
     "Country": "Dominican Republic",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Azua"
    },
    {
     "Country": "Dominican Republic",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Baoruco"
    },
    {
     "Country": "Dominican Republic",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Barahona"
    },
    {
     "Country": "Dominican Republic",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Dajabón"
    },
    {
     "Country": "Dominican Republic",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Duarte"
    },
    {
     "Country": "Dominican Republic",
     "Region": "Greater Antilles, Caribbean",
     "Province": "El Seibo"
    },
    {
     "Country": "Dominican Republic",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Elías Piña"
    },
    {
     "Country": "Dominican Republic",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Espaillat"
    },
    {
     "Country": "Dominican Republic",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Hato Mayor"
    },
    {
     "Country": "Dominican Republic",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Hermanas Mirabal"
    },
    {
     "Country": "Dominican Republic",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Independencia"
    },
    {
     "Country": "Dominican Republic",
     "Region": "Greater Antilles, Caribbean",
     "Province": "La Altagracia"
    },
    {
     "Country": "Dominican Republic",
     "Region": "Greater Antilles, Caribbean",
     "Province": "La Romana"
    },
    {
     "Country": "Dominican Republic",
     "Region": "Greater Antilles, Caribbean",
     "Province": "La Vega"
    },
    {
     "Country": "Dominican Republic",
     "Region": "Greater Antilles, Caribbean",
     "Province": "María Trinidad Sánchez"
    },
    {
     "Country": "Dominican Republic",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Monseñor Nouel"
    },
    {
     "Country": "Dominican Republic",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Monte Cristi"
    },
    {
     "Country": "Dominican Republic",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Monte Plata"
    },
    {
     "Country": "Dominican Republic",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Pedernales"
    },
    {
     "Country": "Dominican Republic",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Peravia"
    },
    {
     "Country": "Dominican Republic",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Puerto Plata"
    },
    {
     "Country": "Dominican Republic",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Samaná"
    },
    {
     "Country": "Dominican Republic",
     "Region": "Greater Antilles, Caribbean",
     "Province": "San Cristóbal"
    },
    {
     "Country": "Dominican Republic",
     "Region": "Greater Antilles, Caribbean",
     "Province": "San José de Ocoa"
    },
    {
     "Country": "Dominican Republic",
     "Region": "Greater Antilles, Caribbean",
     "Province": "San Juan"
    },
    {
     "Country": "Dominican Republic",
     "Region": "Greater Antilles, Caribbean",
     "Province": "San Pedro de Macorís"
    },
    {
     "Country": "Dominican Republic",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Sánchez Ramírez"
    },
    {
     "Country": "Dominican Republic",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Santiago"
    },
    {
     "Country": "Dominican Republic",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Santiago Rodríguez"
    },
    {
     "Country": "Dominican Republic",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Santo Domingo"
    },
    {
     "Country": "Dominican Republic",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Valverde"
    },
    {
     "Country": "Dominican Republic",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Distrito Nacional"
    },
    {
     "Country": "East Timor (Timor-Leste)",
     "Region": "South-East Asia",
     "Province": "Lautém"
    },
    {
     "Country": "East Timor (Timor-Leste)",
     "Region": "South-East Asia",
     "Province": "Baucau"
    },
    {
     "Country": "East Timor (Timor-Leste)",
     "Region": "South-East Asia",
     "Province": "Viqueque"
    },
    {
     "Country": "East Timor (Timor-Leste)",
     "Region": "South-East Asia",
     "Province": "Manatuto"
    },
    {
     "Country": "East Timor (Timor-Leste)",
     "Region": "South-East Asia",
     "Province": "Dili"
    },
    {
     "Country": "East Timor (Timor-Leste)",
     "Region": "South-East Asia",
     "Province": "Aileu"
    },
    {
     "Country": "East Timor (Timor-Leste)",
     "Region": "South-East Asia",
     "Province": "Manufahi"
    },
    {
     "Country": "East Timor (Timor-Leste)",
     "Region": "South-East Asia",
     "Province": "Liquiçá"
    },
    {
     "Country": "East Timor (Timor-Leste)",
     "Region": "South-East Asia",
     "Province": "Ermera"
    },
    {
     "Country": "East Timor (Timor-Leste)",
     "Region": "South-East Asia",
     "Province": "Ainaro"
    },
    {
     "Country": "East Timor (Timor-Leste)",
     "Region": "South-East Asia",
     "Province": "Bobonaro"
    },
    {
     "Country": "East Timor (Timor-Leste)",
     "Region": "South-East Asia",
     "Province": "Cova Lima"
    },
    {
     "Country": "East Timor (Timor-Leste)",
     "Region": "South-East Asia",
     "Province": "Oecusse-Ambeno (SAR)"
    },
    {
     "Country": "East Timor (Timor-Leste)",
     "Region": "South-East Asia",
     "Province": "Atauro"
    },
    {
     "Country": "Ecuador",
     "Region": "North West South America",
     "Province": " Azuay"
    },
    {
     "Country": "Ecuador",
     "Region": "North West South America",
     "Province": " Bolívar"
    },
    {
     "Country": "Ecuador",
     "Region": "North West South America",
     "Province": " Cañar"
    },
    {
     "Country": "Ecuador",
     "Region": "North West South America",
     "Province": " Carchi"
    },
    {
     "Country": "Ecuador",
     "Region": "North West South America",
     "Province": " Chimborazo"
    },
    {
     "Country": "Ecuador",
     "Region": "North West South America",
     "Province": " Cotopaxi"
    },
    {
     "Country": "Ecuador",
     "Region": "North West South America",
     "Province": " El Oro"
    },
    {
     "Country": "Ecuador",
     "Region": "North West South America",
     "Province": " Esmeraldas"
    },
    {
     "Country": "Ecuador",
     "Region": "North West South America",
     "Province": " Galápagos"
    },
    {
     "Country": "Ecuador",
     "Region": "North West South America",
     "Province": " Guayas"
    },
    {
     "Country": "Ecuador",
     "Region": "North West South America",
     "Province": " Imbabura"
    },
    {
     "Country": "Ecuador",
     "Region": "North West South America",
     "Province": " Loja"
    },
    {
     "Country": "Ecuador",
     "Region": "North West South America",
     "Province": " Los Ríos"
    },
    {
     "Country": "Ecuador",
     "Region": "North West South America",
     "Province": " Manabí"
    },
    {
     "Country": "Ecuador",
     "Region": "North West South America",
     "Province": " Morona Santiago"
    },
    {
     "Country": "Ecuador",
     "Region": "North West South America",
     "Province": " Napo"
    },
    {
     "Country": "Ecuador",
     "Region": "North West South America",
     "Province": " Orellana"
    },
    {
     "Country": "Ecuador",
     "Region": "North West South America",
     "Province": " Pastaza"
    },
    {
     "Country": "Ecuador",
     "Region": "North West South America",
     "Province": " Pichincha"
    },
    {
     "Country": "Ecuador",
     "Region": "North West South America",
     "Province": " Santa Elena"
    },
    {
     "Country": "Ecuador",
     "Region": "North West South America",
     "Province": " Santo Domingo de los Tsáchilas"
    },
    {
     "Country": "Ecuador",
     "Region": "North West South America",
     "Province": " Sucumbíos"
    },
    {
     "Country": "Ecuador",
     "Region": "North West South America",
     "Province": " Tungurahua"
    },
    {
     "Country": "Ecuador",
     "Region": "North West South America",
     "Province": " Zamora Chinchipe"
    },
    {
     "Country": "Ecuador",
     "Region": "North West South America",
     "Province": "Ecuador"
    },
    {
     "Country": "Egypt",
     "Region": "Africa, Middle East",
     "Province": " Alexandria"
    },
    {
     "Country": "Egypt",
     "Region": "Africa, Middle East",
     "Province": " Aswan"
    },
    {
     "Country": "Egypt",
     "Region": "Africa, Middle East",
     "Province": " Asyut"
    },
    {
     "Country": "Egypt",
     "Region": "Africa, Middle East",
     "Province": " Beheira"
    },
    {
     "Country": "Egypt",
     "Region": "Africa, Middle East",
     "Province": " Beni Suef"
    },
    {
     "Country": "Egypt",
     "Region": "Africa, Middle East",
     "Province": " Cairo"
    },
    {
     "Country": "Egypt",
     "Region": "Africa, Middle East",
     "Province": " Dakahlia"
    },
    {
     "Country": "Egypt",
     "Region": "Africa, Middle East",
     "Province": " Damietta"
    },
    {
     "Country": "Egypt",
     "Region": "Africa, Middle East",
     "Province": " Faiyum"
    },
    {
     "Country": "Egypt",
     "Region": "Africa, Middle East",
     "Province": " Gharbia"
    },
    {
     "Country": "Egypt",
     "Region": "Africa, Middle East",
     "Province": " Giza"
    },
    {
     "Country": "Egypt",
     "Region": "Africa, Middle East",
     "Province": " Ismailia"
    },
    {
     "Country": "Egypt",
     "Region": "Africa, Middle East",
     "Province": " Kafr El Sheikh"
    },
    {
     "Country": "Egypt",
     "Region": "Africa, Middle East",
     "Province": " Luxor"
    },
    {
     "Country": "Egypt",
     "Region": "Africa, Middle East",
     "Province": " Matrouh"
    },
    {
     "Country": "Egypt",
     "Region": "Africa, Middle East",
     "Province": " Minya"
    },
    {
     "Country": "Egypt",
     "Region": "Africa, Middle East",
     "Province": " Monufia"
    },
    {
     "Country": "Egypt",
     "Region": "Africa, Middle East",
     "Province": " New Valley"
    },
    {
     "Country": "Egypt",
     "Region": "Africa, Middle East",
     "Province": " North Sinai"
    },
    {
     "Country": "Egypt",
     "Region": "Africa, Middle East",
     "Province": " Port Said"
    },
    {
     "Country": "Egypt",
     "Region": "Africa, Middle East",
     "Province": " Qalyubia"
    },
    {
     "Country": "Egypt",
     "Region": "Africa, Middle East",
     "Province": " Qena"
    },
    {
     "Country": "Egypt",
     "Region": "Africa, Middle East",
     "Province": " Red Sea"
    },
    {
     "Country": "Egypt",
     "Region": "Africa, Middle East",
     "Province": " Sharqia"
    },
    {
     "Country": "Egypt",
     "Region": "Africa, Middle East",
     "Province": " Sohag"
    },
    {
     "Country": "Egypt",
     "Region": "Africa, Middle East",
     "Province": " South Sinai"
    },
    {
     "Country": "Egypt",
     "Region": "Africa, Middle East",
     "Province": " Suez"
    },
    {
     "Country": "El Salvador",
     "Region": "Central America",
     "Province": "Ahuachapán"
    },
    {
     "Country": "El Salvador",
     "Region": "Central America",
     "Province": "Cabañas"
    },
    {
     "Country": "El Salvador",
     "Region": "Central America",
     "Province": "Chalatenango"
    },
    {
     "Country": "El Salvador",
     "Region": "Central America",
     "Province": "Cuscatlán"
    },
    {
     "Country": "El Salvador",
     "Region": "Central America",
     "Province": "La Libertad"
    },
    {
     "Country": "El Salvador",
     "Region": "Central America",
     "Province": "La Paz"
    },
    {
     "Country": "El Salvador",
     "Region": "Central America",
     "Province": "La Unión"
    },
    {
     "Country": "El Salvador",
     "Region": "Central America",
     "Province": "Morazán"
    },
    {
     "Country": "El Salvador",
     "Region": "Central America",
     "Province": "San Miguel"
    },
    {
     "Country": "El Salvador",
     "Region": "Central America",
     "Province": "San Salvador"
    },
    {
     "Country": "El Salvador",
     "Region": "Central America",
     "Province": "San Vicente"
    },
    {
     "Country": "El Salvador",
     "Region": "Central America",
     "Province": "Santa Ana"
    },
    {
     "Country": "El Salvador",
     "Region": "Central America",
     "Province": "Sonsonate"
    },
    {
     "Country": "El Salvador",
     "Region": "Central America",
     "Province": "Usulután"
    },
    {
     "Country": "Equatorial Guinea",
     "Region": "Central Africa",
     "Province": "Annobón"
    },
    {
     "Country": "Equatorial Guinea",
     "Region": "Central Africa",
     "Province": "Bioko Norte"
    },
    {
     "Country": "Equatorial Guinea",
     "Region": "Central Africa",
     "Province": "Bioko Sur"
    },
    {
     "Country": "Equatorial Guinea",
     "Region": "Central Africa",
     "Province": "Centro Sur"
    },
    {
     "Country": "Equatorial Guinea",
     "Region": "Central Africa",
     "Province": "Kié-Ntem"
    },
    {
     "Country": "Equatorial Guinea",
     "Region": "Central Africa",
     "Province": "Litoral"
    },
    {
     "Country": "Equatorial Guinea",
     "Region": "Central Africa",
     "Province": "Wele-Nzas"
    },
    {
     "Country": "Equatorial Guinea",
     "Region": "Central Africa",
     "Province": "Djibloho"
    },
    {
     "Country": "Eritrea",
     "Region": "Eastern Africa",
     "Province": "Maekel"
    },
    {
     "Country": "Eritrea",
     "Region": "Eastern Africa",
     "Province": "Anseba"
    },
    {
     "Country": "Eritrea",
     "Region": "Eastern Africa",
     "Province": "Gash-Barka"
    },
    {
     "Country": "Eritrea",
     "Region": "Eastern Africa",
     "Province": "Gash-Barka"
    },
    {
     "Country": "Eritrea",
     "Region": "Eastern Africa",
     "Province": "Debub"
    },
    {
     "Country": "Eritrea",
     "Region": "Eastern Africa",
     "Province": "Semienawi Keyih Bahri"
    },
    {
     "Country": "Eritrea",
     "Region": "Eastern Africa",
     "Province": "Northern Red Sea"
    },
    {
     "Country": "Eritrea",
     "Region": "Eastern Africa",
     "Province": "Debubawi Keyih Bahri"
    },
    {
     "Country": "Estonia",
     "Region": "Northern Europe",
     "Province": "Harju County"
    },
    {
     "Country": "Estonia",
     "Region": "Northern Europe",
     "Province": "Hiiu County"
    },
    {
     "Country": "Estonia",
     "Region": "Northern Europe",
     "Province": "Ida-Viru County"
    },
    {
     "Country": "Estonia",
     "Region": "Northern Europe",
     "Province": "Jõgeva County"
    },
    {
     "Country": "Estonia",
     "Region": "Northern Europe",
     "Province": "Järva County"
    },
    {
     "Country": "Estonia",
     "Region": "Northern Europe",
     "Province": "Lääne County"
    },
    {
     "Country": "Estonia",
     "Region": "Northern Europe",
     "Province": "Lääne-Viru County"
    },
    {
     "Country": "Estonia",
     "Region": "Northern Europe",
     "Province": "Põlva County"
    },
    {
     "Country": "Estonia",
     "Region": "Northern Europe",
     "Province": "Pärnu County"
    },
    {
     "Country": "Estonia",
     "Region": "Northern Europe",
     "Province": "Rapla County"
    },
    {
     "Country": "Estonia",
     "Region": "Northern Europe",
     "Province": "Saare County"
    },
    {
     "Country": "Estonia",
     "Region": "Northern Europe",
     "Province": "Tartu County"
    },
    {
     "Country": "Estonia",
     "Region": "Northern Europe",
     "Province": "Valga County"
    },
    {
     "Country": "Estonia",
     "Region": "Northern Europe",
     "Province": "Viljandi County"
    },
    {
     "Country": "Estonia",
     "Region": "Northern Europe",
     "Province": "Võru County"
    },
    {
     "Country": "Ethiopia",
     "Region": "Eastern Africa",
     "Province": "Addis Ababa (city)"
    },
    {
     "Country": "Ethiopia",
     "Region": "Eastern Africa",
     "Province": "Afar Region"
    },
    {
     "Country": "Ethiopia",
     "Region": "Eastern Africa",
     "Province": "Amhara Region"
    },
    {
     "Country": "Ethiopia",
     "Region": "Eastern Africa",
     "Province": "Benishangul-Gumuz Region"
    },
    {
     "Country": "Ethiopia",
     "Region": "Eastern Africa",
     "Province": "Central Ethiopia Regional State"
    },
    {
     "Country": "Ethiopia",
     "Region": "Eastern Africa",
     "Province": "Dire Dawa (city)"
    },
    {
     "Country": "Ethiopia",
     "Region": "Eastern Africa",
     "Province": "Gambela Region"
    },
    {
     "Country": "Ethiopia",
     "Region": "Eastern Africa",
     "Province": "Harari Region"
    },
    {
     "Country": "Ethiopia",
     "Region": "Eastern Africa",
     "Province": "Oromia Region"
    },
    {
     "Country": "Ethiopia",
     "Region": "Eastern Africa",
     "Province": "Sidama Region"
    },
    {
     "Country": "Ethiopia",
     "Region": "Eastern Africa",
     "Province": "Somali Region"
    },
    {
     "Country": "Ethiopia",
     "Region": "Eastern Africa",
     "Province": "South Ethiopia Regional State"
    },
    {
     "Country": "Ethiopia",
     "Region": "Eastern Africa",
     "Province": "South West Ethiopia Peoples' Region"
    },
    {
     "Country": "Ethiopia",
     "Region": "Eastern Africa",
     "Province": "Tigray Region"
    },
    {
     "Country": "Falkland Islands",
     "Region": "Southern South America",
     "Province": "-"
    },
    {
     "Country": "Faroe Islands",
     "Region": "Northern Europe",
     "Province": "Tórshavn"
    },
    {
     "Country": "Faroe Islands",
     "Region": "Northern Europe",
     "Province": "Klaksvík"
    },
    {
     "Country": "Faroe Islands",
     "Region": "Northern Europe",
     "Province": "Runavík"
    },
    {
     "Country": "Faroe Islands",
     "Region": "Northern Europe",
     "Province": "Eystur"
    },
    {
     "Country": "Faroe Islands",
     "Region": "Northern Europe",
     "Province": "Vágar"
    },
    {
     "Country": "Faroe Islands",
     "Region": "Northern Europe",
     "Province": "Sunda"
    },
    {
     "Country": "Faroe Islands",
     "Region": "Northern Europe",
     "Province": "Tvøroyri"
    },
    {
     "Country": "Faroe Islands",
     "Region": "Northern Europe",
     "Province": "Fuglafjørður"
    },
    {
     "Country": "Faroe Islands",
     "Region": "Northern Europe",
     "Province": "Vágur"
    },
    {
     "Country": "Faroe Islands",
     "Region": "Northern Europe",
     "Province": "Nes"
    },
    {
     "Country": "Faroe Islands",
     "Region": "Northern Europe",
     "Province": "Vestmanna"
    },
    {
     "Country": "Faroe Islands",
     "Region": "Northern Europe",
     "Province": "Sørvágur"
    },
    {
     "Country": "Faroe Islands",
     "Region": "Northern Europe",
     "Province": "Sjóvar"
    },
    {
     "Country": "Faroe Islands",
     "Region": "Northern Europe",
     "Province": "Eiði"
    },
    {
     "Country": "Faroe Islands",
     "Region": "Northern Europe",
     "Province": "Hvalba"
    },
    {
     "Country": "Faroe Islands",
     "Region": "Northern Europe",
     "Province": "Kvívík"
    },
    {
     "Country": "Faroe Islands",
     "Region": "Northern Europe",
     "Province": "Sandur"
    },
    {
     "Country": "Faroe Islands",
     "Region": "Northern Europe",
     "Province": "Skopun"
    },
    {
     "Country": "Faroe Islands",
     "Region": "Northern Europe",
     "Province": "Hvannasund"
    },
    {
     "Country": "Faroe Islands",
     "Region": "Northern Europe",
     "Province": "Sumba"
    },
    {
     "Country": "Faroe Islands",
     "Region": "Northern Europe",
     "Province": "Viðareiði"
    },
    {
     "Country": "Faroe Islands",
     "Region": "Northern Europe",
     "Province": "Porkeri"
    },
    {
     "Country": "Faroe Islands",
     "Region": "Northern Europe",
     "Province": "Kunoy"
    },
    {
     "Country": "Faroe Islands",
     "Region": "Northern Europe",
     "Province": "Skálavík"
    },
    {
     "Country": "Faroe Islands",
     "Region": "Northern Europe",
     "Province": "Húsavík"
    },
    {
     "Country": "Faroe Islands",
     "Region": "Northern Europe",
     "Province": "Hov"
    },
    {
     "Country": "Faroe Islands",
     "Region": "Northern Europe",
     "Province": "Fámjin"
    },
    {
     "Country": "Faroe Islands",
     "Region": "Northern Europe",
     "Province": "Skúvoy"
    },
    {
     "Country": "Faroe Islands",
     "Region": "Northern Europe",
     "Province": "Fugloy"
    },
    {
     "Country": "Fiji",
     "Region": "Melanesia, Oceania",
     "Province": "Ba"
    },
    {
     "Country": "Fiji",
     "Region": "Melanesia, Oceania",
     "Province": "Bua"
    },
    {
     "Country": "Fiji",
     "Region": "Melanesia, Oceania",
     "Province": "Cakaudrove"
    },
    {
     "Country": "Fiji",
     "Region": "Melanesia, Oceania",
     "Province": "Kadavu"
    },
    {
     "Country": "Fiji",
     "Region": "Melanesia, Oceania",
     "Province": "Lau"
    },
    {
     "Country": "Fiji",
     "Region": "Melanesia, Oceania",
     "Province": "Lomaiviti"
    },
    {
     "Country": "Fiji",
     "Region": "Melanesia, Oceania",
     "Province": "Macuata"
    },
    {
     "Country": "Fiji",
     "Region": "Melanesia, Oceania",
     "Province": "Nadroga-Navosa"
    },
    {
     "Country": "Fiji",
     "Region": "Melanesia, Oceania",
     "Province": "Naitasiri"
    },
    {
     "Country": "Fiji",
     "Region": "Melanesia, Oceania",
     "Province": "Namosi"
    },
    {
     "Country": "Fiji",
     "Region": "Melanesia, Oceania",
     "Province": "Ra"
    },
    {
     "Country": "Fiji",
     "Region": "Melanesia, Oceania",
     "Province": "Rewa"
    },
    {
     "Country": "Fiji",
     "Region": "Melanesia, Oceania",
     "Province": "Serua"
    },
    {
     "Country": "Fiji",
     "Region": "Melanesia, Oceania",
     "Province": "Tailevu"
    },
    {
     "Country": "Finland",
     "Region": "Northern Europe",
     "Province": "Lapland"
    },
    {
     "Country": "Finland",
     "Region": "Northern Europe",
     "Province": "North Ostrobothnia"
    },
    {
     "Country": "Finland",
     "Region": "Northern Europe",
     "Province": "Kainuu"
    },
    {
     "Country": "Finland",
     "Region": "Northern Europe",
     "Province": "North Karelia"
    },
    {
     "Country": "Finland",
     "Region": "Northern Europe",
     "Province": "North Savo"
    },
    {
     "Country": "Finland",
     "Region": "Northern Europe",
     "Province": "South Savo"
    },
    {
     "Country": "Finland",
     "Region": "Northern Europe",
     "Province": "South Karelia"
    },
    {
     "Country": "Finland",
     "Region": "Northern Europe",
     "Province": "Central Finland"
    },
    {
     "Country": "Finland",
     "Region": "Northern Europe",
     "Province": "South Ostrobothnia"
    },
    {
     "Country": "Finland",
     "Region": "Northern Europe",
     "Province": "Ostrobothnia"
    },
    {
     "Country": "Finland",
     "Region": "Northern Europe",
     "Province": "Central Ostrobothnia"
    },
    {
     "Country": "Finland",
     "Region": "Northern Europe",
     "Province": "Pirkanmaa"
    },
    {
     "Country": "Finland",
     "Region": "Northern Europe",
     "Province": "Satakunta"
    },
    {
     "Country": "Finland",
     "Region": "Northern Europe",
     "Province": "Päijät-Häme"
    },
    {
     "Country": "Finland",
     "Region": "Northern Europe",
     "Province": "Kanta-Häme"
    },
    {
     "Country": "Finland",
     "Region": "Northern Europe",
     "Province": "Kymenlaakso"
    },
    {
     "Country": "Finland",
     "Region": "Northern Europe",
     "Province": "Uusimaa"
    },
    {
     "Country": "Finland",
     "Region": "Northern Europe",
     "Province": "Southwest Finland"
    },
    {
     "Country": "Finland",
     "Region": "Northern Europe",
     "Province": "Åland"
    },
    {
     "Country": "France",
     "Region": "Western Europe",
     "Province": "Alsace"
    },
    {
     "Country": "France",
     "Region": "Western Europe",
     "Province": "Aquitaine"
    },
    {
     "Country": "France",
     "Region": "Western Europe",
     "Province": "Auvergne"
    },
    {
     "Country": "France",
     "Region": "Western Europe",
     "Province": "Brittany"
    },
    {
     "Country": "France",
     "Region": "Western Europe",
     "Province": "Burgundy"
    },
    {
     "Country": "France",
     "Region": "Western Europe",
     "Province": "Centre-Val de Loire"
    },
    {
     "Country": "France",
     "Region": "Western Europe",
     "Province": "Champagne-Ardenne"
    },
    {
     "Country": "France",
     "Region": "Western Europe",
     "Province": "Corsica"
    },
    {
     "Country": "France",
     "Region": "Western Europe",
     "Province": "Franche-Comté"
    },
    {
     "Country": "France",
     "Region": "Western Europe",
     "Province": "Île-de-France"
    },
    {
     "Country": "France",
     "Region": "Western Europe",
     "Province": "Languedoc-Roussillon"
    },
    {
     "Country": "France",
     "Region": "Western Europe",
     "Province": "Limousin"
    },
    {
     "Country": "France",
     "Region": "Western Europe",
     "Province": "Lorraine"
    },
    {
     "Country": "France",
     "Region": "Western Europe",
     "Province": "Lower Normandy"
    },
    {
     "Country": "France",
     "Region": "Western Europe",
     "Province": "Midi-Pyrénées"
    },
    {
     "Country": "France",
     "Region": "Western Europe",
     "Province": "Nord-Pas-de-Calais"
    },
    {
     "Country": "France",
     "Region": "Western Europe",
     "Province": "Pays de la Loire"
    },
    {
     "Country": "France",
     "Region": "Western Europe",
     "Province": "Picardy"
    },
    {
     "Country": "France",
     "Region": "Western Europe",
     "Province": "Poitou-Charentes"
    },
    {
     "Country": "France",
     "Region": "Western Europe",
     "Province": "Provence-Alpes-Côte d'Azur (PACA)"
    },
    {
     "Country": "France",
     "Region": "Western Europe",
     "Province": "Rhône-Alpes"
    },
    {
     "Country": "France",
     "Region": "Western Europe",
     "Province": "Upper Normandy"
    },
    {
     "Country": "French Guiana",
     "Region": "Northern South America",
     "Province": "Awala-Yalimapo"
    },
    {
     "Country": "French Guiana",
     "Region": "Northern South America",
     "Province": "Mana"
    },
    {
     "Country": "French Guiana",
     "Region": "Northern South America",
     "Province": "Saint-Laurent-du-Maroni"
    },
    {
     "Country": "French Guiana",
     "Region": "Northern South America",
     "Province": "Apatou"
    },
    {
     "Country": "French Guiana",
     "Region": "Northern South America",
     "Province": "Grand-Santi"
    },
    {
     "Country": "French Guiana",
     "Region": "Northern South America",
     "Province": "Papaïchton"
    },
    {
     "Country": "French Guiana",
     "Region": "Northern South America",
     "Province": "Saül"
    },
    {
     "Country": "French Guiana",
     "Region": "Northern South America",
     "Province": "Maripasoula"
    },
    {
     "Country": "French Guiana",
     "Region": "Northern South America",
     "Province": "Camopi"
    },
    {
     "Country": "French Guiana",
     "Region": "Northern South America",
     "Province": "Saint-Georges"
    },
    {
     "Country": "French Guiana",
     "Region": "Northern South America",
     "Province": "Ouanary"
    },
    {
     "Country": "French Guiana",
     "Region": "Northern South America",
     "Province": "Régina"
    },
    {
     "Country": "French Guiana",
     "Region": "Northern South America",
     "Province": "Roura"
    },
    {
     "Country": "French Guiana",
     "Region": "Northern South America",
     "Province": "Saint-Élie"
    },
    {
     "Country": "French Guiana",
     "Region": "Northern South America",
     "Province": "Iracoubo"
    },
    {
     "Country": "French Guiana",
     "Region": "Northern South America",
     "Province": "Sinnamary"
    },
    {
     "Country": "French Guiana",
     "Region": "Northern South America",
     "Province": "Kourou"
    },
    {
     "Country": "French Guiana",
     "Region": "Northern South America",
     "Province": "Macouria"
    },
    {
     "Country": "French Guiana",
     "Region": "Northern South America",
     "Province": "Montsinéry-Tonnegrande"
    },
    {
     "Country": "French Guiana",
     "Region": "Northern South America",
     "Province": "Matoury"
    },
    {
     "Country": "French Guiana",
     "Region": "Northern South America",
     "Province": "Cayenne"
    },
    {
     "Country": "French Guiana",
     "Region": "Northern South America",
     "Province": "Remire-Montjoly"
    },
    {
     "Country": "French Polynesia",
     "Region": "Polynesia, Oceania",
     "Province": "Windward Islands"
    },
    {
     "Country": "French Polynesia",
     "Region": "Polynesia, Oceania",
     "Province": "Leeward Islands"
    },
    {
     "Country": "French Polynesia",
     "Region": "Polynesia, Oceania",
     "Province": "Marquesas Islands"
    },
    {
     "Country": "French Polynesia",
     "Region": "Polynesia, Oceania",
     "Province": "Austral Islands"
    },
    {
     "Country": "French Polynesia",
     "Region": "Polynesia, Oceania",
     "Province": "Tuamotu-Gambier"
    },
    {
     "Country": "French Polynesia",
     "Region": "Polynesia, Oceania",
     "Province": "French Polynesia"
    },
    {
     "Country": "French Southern Territories",
     "Region": "Southern Indian Ocean",
     "Province": "Adélie Land"
    },
    {
     "Country": "French Southern Territories",
     "Region": "Southern Indian Ocean",
     "Province": "Crozet Islands"
    },
    {
     "Country": "French Southern Territories",
     "Region": "Southern Indian Ocean",
     "Province": "Kerguelen Islands"
    },
    {
     "Country": "French Southern Territories",
     "Region": "Southern Indian Ocean",
     "Province": "Saint Paul and Amsterdam Islands"
    },
    {
     "Country": "French Southern Territories",
     "Region": "Southern Indian Ocean",
     "Province": "Scattered Islandsa"
    },
    {
     "Country": "Gabon",
     "Region": "Central Africa",
     "Province": "Estuaire"
    },
    {
     "Country": "Gabon",
     "Region": "Central Africa",
     "Province": "Haut-Ogooué"
    },
    {
     "Country": "Gabon",
     "Region": "Central Africa",
     "Province": "Moyen-Ogooué"
    },
    {
     "Country": "Gabon",
     "Region": "Central Africa",
     "Province": "Ngounié"
    },
    {
     "Country": "Gabon",
     "Region": "Central Africa",
     "Province": "Nyanga"
    },
    {
     "Country": "Gabon",
     "Region": "Central Africa",
     "Province": "Ogooué-Ivindo"
    },
    {
     "Country": "Gabon",
     "Region": "Central Africa",
     "Province": "Ogooué-Lolo"
    },
    {
     "Country": "Gabon",
     "Region": "Central Africa",
     "Province": "Ogooué-Maritime"
    },
    {
     "Country": "Gabon",
     "Region": "Central Africa",
     "Province": "Woleu-Ntem"
    },
    {
     "Country": "Georgia",
     "Region": "Caucasus",
     "Province": "Tbilisi"
    },
    {
     "Country": "Georgia",
     "Region": "Caucasus",
     "Province": "Imereti"
    },
    {
     "Country": "Georgia",
     "Region": "Caucasus",
     "Province": "Adjara"
    },
    {
     "Country": "Georgia",
     "Region": "Caucasus",
     "Province": "Kvemo Kartli"
    },
    {
     "Country": "Georgia",
     "Region": "Caucasus",
     "Province": "Samegrelo-Zemo Svaneti"
    },
    {
     "Country": "Georgia",
     "Region": "Caucasus",
     "Province": "Kakheti"
    },
    {
     "Country": "Georgia",
     "Region": "Caucasus",
     "Province": "Shida Kartli"
    },
    {
     "Country": "Georgia",
     "Region": "Caucasus",
     "Province": "Abkhazia"
    },
    {
     "Country": "Georgia",
     "Region": "Caucasus",
     "Province": "Samtskhe-Javakheti"
    },
    {
     "Country": "Georgia",
     "Region": "Caucasus",
     "Province": "Guria"
    },
    {
     "Country": "Georgia",
     "Region": "Caucasus",
     "Province": "Mtskheta-Mtianeti"
    },
    {
     "Country": "Georgia",
     "Region": "Caucasus",
     "Province": "Racha-Lechkhumi and Kvemo Svaneti"
    },
    {
     "Country": "Germany",
     "Region": "Western Europe",
     "Province": " Baden-Württemberg"
    },
    {
     "Country": "Germany",
     "Region": "Western Europe",
     "Province": " Bavaria"
    },
    {
     "Country": "Germany",
     "Region": "Western Europe",
     "Province": "(Bayern)"
    },
    {
     "Country": "Germany",
     "Region": "Western Europe",
     "Province": " Berlin"
    },
    {
     "Country": "Germany",
     "Region": "Western Europe",
     "Province": " Brandenburg"
    },
    {
     "Country": "Germany",
     "Region": "Western Europe",
     "Province": " Bremen"
    },
    {
     "Country": "Germany",
     "Region": "Western Europe",
     "Province": " Hamburg"
    },
    {
     "Country": "Germany",
     "Region": "Western Europe",
     "Province": " Hesse"
    },
    {
     "Country": "Germany",
     "Region": "Western Europe",
     "Province": "(Hessen)"
    },
    {
     "Country": "Germany",
     "Region": "Western Europe",
     "Province": " Lower Saxony"
    },
    {
     "Country": "Germany",
     "Region": "Western Europe",
     "Province": "(Niedersachsen)"
    },
    {
     "Country": "Germany",
     "Region": "Western Europe",
     "Province": " Mecklenburg-Vorpommern"
    },
    {
     "Country": "Germany",
     "Region": "Western Europe",
     "Province": " North Rhine-Westphalia"
    },
    {
     "Country": "Germany",
     "Region": "Western Europe",
     "Province": "(Nordrhein-Westfalen)"
    },
    {
     "Country": "Germany",
     "Region": "Western Europe",
     "Province": " Rhineland-Palatinate"
    },
    {
     "Country": "Germany",
     "Region": "Western Europe",
     "Province": "(Rheinland-Pfalz)"
    },
    {
     "Country": "Germany",
     "Region": "Western Europe",
     "Province": " Saarland"
    },
    {
     "Country": "Germany",
     "Region": "Western Europe",
     "Province": " Saxony"
    },
    {
     "Country": "Germany",
     "Region": "Western Europe",
     "Province": "(Sachsen)"
    },
    {
     "Country": "Germany",
     "Region": "Western Europe",
     "Province": " Saxony-Anhalt"
    },
    {
     "Country": "Germany",
     "Region": "Western Europe",
     "Province": "(Sachsen-Anhalt)"
    },
    {
     "Country": "Germany",
     "Region": "Western Europe",
     "Province": " Schleswig-Holstein"
    },
    {
     "Country": "Germany",
     "Region": "Western Europe",
     "Province": " Thuringia"
    },
    {
     "Country": "Germany",
     "Region": "Western Europe",
     "Province": "(Thüringen)"
    },
    {
     "Country": "Ghana",
     "Region": "West Africa",
     "Province": "Ashanti"
    },
    {
     "Country": "Ghana",
     "Region": "West Africa",
     "Province": "Bono"
    },
    {
     "Country": "Ghana",
     "Region": "West Africa",
     "Province": "Bono East"
    },
    {
     "Country": "Ghana",
     "Region": "West Africa",
     "Province": "Ahafo"
    },
    {
     "Country": "Ghana",
     "Region": "West Africa",
     "Province": "Central"
    },
    {
     "Country": "Ghana",
     "Region": "West Africa",
     "Province": "Eastern"
    },
    {
     "Country": "Ghana",
     "Region": "West Africa",
     "Province": "Greater Accra"
    },
    {
     "Country": "Ghana",
     "Region": "West Africa",
     "Province": "Northern"
    },
    {
     "Country": "Ghana",
     "Region": "West Africa",
     "Province": "Savannah"
    },
    {
     "Country": "Ghana",
     "Region": "West Africa",
     "Province": "North East"
    },
    {
     "Country": "Ghana",
     "Region": "West Africa",
     "Province": "Upper East"
    },
    {
     "Country": "Ghana",
     "Region": "West Africa",
     "Province": "Upper West"
    },
    {
     "Country": "Ghana",
     "Region": "West Africa",
     "Province": "Volta"
    },
    {
     "Country": "Ghana",
     "Region": "West Africa",
     "Province": "Oti"
    },
    {
     "Country": "Ghana",
     "Region": "West Africa",
     "Province": "Western"
    },
    {
     "Country": "Ghana",
     "Region": "West Africa",
     "Province": "Western North"
    },
    {
     "Country": "Gibraltar",
     "Region": "Southern Europe",
     "Province": "Eastside"
    },
    {
     "Country": "Gibraltar",
     "Region": "Southern Europe",
     "Province": "North District"
    },
    {
     "Country": "Gibraltar",
     "Region": "Southern Europe",
     "Province": "Reclamation Areas"
    },
    {
     "Country": "Gibraltar",
     "Region": "Southern Europe",
     "Province": "Sandpits Area"
    },
    {
     "Country": "Gibraltar",
     "Region": "Southern Europe",
     "Province": "South District"
    },
    {
     "Country": "Gibraltar",
     "Region": "Southern Europe",
     "Province": "Town Area"
    },
    {
     "Country": "Gibraltar",
     "Region": "Southern Europe",
     "Province": "Upper Town"
    },
    {
     "Country": "Greece",
     "Region": "Southern Europe",
     "Province": "Attica"
    },
    {
     "Country": "Greece",
     "Region": "Southern Europe",
     "Province": "Central Greece"
    },
    {
     "Country": "Greece",
     "Region": "Southern Europe",
     "Province": "Central Macedonia"
    },
    {
     "Country": "Greece",
     "Region": "Southern Europe",
     "Province": "Crete"
    },
    {
     "Country": "Greece",
     "Region": "Southern Europe",
     "Province": "Eastern Macedonia and Thrace"
    },
    {
     "Country": "Greece",
     "Region": "Southern Europe",
     "Province": "Epirus"
    },
    {
     "Country": "Greece",
     "Region": "Southern Europe",
     "Province": "Ionian Islands"
    },
    {
     "Country": "Greece",
     "Region": "Southern Europe",
     "Province": "North Aegean"
    },
    {
     "Country": "Greece",
     "Region": "Southern Europe",
     "Province": "Peloponnese"
    },
    {
     "Country": "Greece",
     "Region": "Southern Europe",
     "Province": "South Aegean"
    },
    {
     "Country": "Greece",
     "Region": "Southern Europe",
     "Province": "Thessaly"
    },
    {
     "Country": "Greece",
     "Region": "Southern Europe",
     "Province": "Western Greece"
    },
    {
     "Country": "Greece",
     "Region": "Southern Europe",
     "Province": "Western Macedonia"
    },
    {
     "Country": "Greece",
     "Region": "Southern Europe",
     "Province": "Mount Athos"
    },
    {
     "Country": "Greenland",
     "Region": "North America",
     "Province": "Avannaata"
    },
    {
     "Country": "Greenland",
     "Region": "North America",
     "Province": "Kujalleq"
    },
    {
     "Country": "Greenland",
     "Region": "North America",
     "Province": "Qeqertalik"
    },
    {
     "Country": "Greenland",
     "Region": "North America",
     "Province": "Qeqqata"
    },
    {
     "Country": "Greenland",
     "Region": "North America",
     "Province": "Sermersooq"
    },
    {
     "Country": "Grenada",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Saint Andrew"
    },
    {
     "Country": "Grenada",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Saint David"
    },
    {
     "Country": "Grenada",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Saint George"
    },
    {
     "Country": "Grenada",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Saint John"
    },
    {
     "Country": "Grenada",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Saint Mark"
    },
    {
     "Country": "Grenada",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Saint Patrick"
    },
    {
     "Country": "Grenada",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Carriacou and Petite Martinique."
    },
    {
     "Country": "Grenada",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Carriacou"
    },
    {
     "Country": "Grenada",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Petite Martinique"
    },
    {
     "Country": "Grenada",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Grenada"
    },
    {
     "Country": "Guadeloupe",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Les Abymes"
    },
    {
     "Country": "Guadeloupe",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Anse-Bertrand"
    },
    {
     "Country": "Guadeloupe",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Baie-Mahault"
    },
    {
     "Country": "Guadeloupe",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Baillif"
    },
    {
     "Country": "Guadeloupe",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Basse-Terre"
    },
    {
     "Country": "Guadeloupe",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Bouillante"
    },
    {
     "Country": "Guadeloupe",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Capesterre-Belle-Eau"
    },
    {
     "Country": "Guadeloupe",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Capesterre-de-Marie-Galante"
    },
    {
     "Country": "Guadeloupe",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Deshaies"
    },
    {
     "Country": "Guadeloupe",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "La Désirade"
    },
    {
     "Country": "Guadeloupe",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Le Gosier"
    },
    {
     "Country": "Guadeloupe",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Gourbeyre"
    },
    {
     "Country": "Guadeloupe",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Goyave"
    },
    {
     "Country": "Guadeloupe",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Grand-Bourg"
    },
    {
     "Country": "Guadeloupe",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Lamentin"
    },
    {
     "Country": "Guadeloupe",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Morne-à-l'Eau"
    },
    {
     "Country": "Guadeloupe",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Le Moule"
    },
    {
     "Country": "Guadeloupe",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Petit-Bourg"
    },
    {
     "Country": "Guadeloupe",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Petit-Canal"
    },
    {
     "Country": "Guadeloupe",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Pointe-à-Pitre"
    },
    {
     "Country": "Guadeloupe",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Pointe-Noire"
    },
    {
     "Country": "Guadeloupe",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Port-Louis"
    },
    {
     "Country": "Guadeloupe",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Saint-Claude"
    },
    {
     "Country": "Guadeloupe",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Saint-François"
    },
    {
     "Country": "Guadeloupe",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Saint-Louis"
    },
    {
     "Country": "Guadeloupe",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Sainte-Anne"
    },
    {
     "Country": "Guadeloupe",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Sainte-Rose"
    },
    {
     "Country": "Guadeloupe",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Terre-de-Bas"
    },
    {
     "Country": "Guadeloupe",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Terre-de-Haut"
    },
    {
     "Country": "Guadeloupe",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Trois-Rivières"
    },
    {
     "Country": "Guadeloupe",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Vieux-Fort"
    },
    {
     "Country": "Guadeloupe",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Vieux-Habitants"
    },
    {
     "Country": "Guam",
     "Region": "Micronesia, Oceania",
     "Province": "Agana Heights"
    },
    {
     "Country": "Guam",
     "Region": "Micronesia, Oceania",
     "Province": "Asan-Maina"
    },
    {
     "Country": "Guam",
     "Region": "Micronesia, Oceania",
     "Province": "Barrigada"
    },
    {
     "Country": "Guam",
     "Region": "Micronesia, Oceania",
     "Province": "Chalan Pago-Ordot"
    },
    {
     "Country": "Guam",
     "Region": "Micronesia, Oceania",
     "Province": "Dededo"
    },
    {
     "Country": "Guam",
     "Region": "Micronesia, Oceania",
     "Province": "Hågat (formerly Agat)"
    },
    {
     "Country": "Guam",
     "Region": "Micronesia, Oceania",
     "Province": "Hagåtña"
    },
    {
     "Country": "Guam",
     "Region": "Micronesia, Oceania",
     "Province": "Humåtak (formerly Umatac)"
    },
    {
     "Country": "Guam",
     "Region": "Micronesia, Oceania",
     "Province": "Inalåhan (formerly Inarajan)"
    },
    {
     "Country": "Guam",
     "Region": "Micronesia, Oceania",
     "Province": "Malesso' (formerly Merizo)"
    },
    {
     "Country": "Guam",
     "Region": "Micronesia, Oceania",
     "Province": "Mangilao"
    },
    {
     "Country": "Guam",
     "Region": "Micronesia, Oceania",
     "Province": "Mongmong-Toto-Maite"
    },
    {
     "Country": "Guam",
     "Region": "Micronesia, Oceania",
     "Province": "Piti"
    },
    {
     "Country": "Guam",
     "Region": "Micronesia, Oceania",
     "Province": "Sånta Rita-Sumai (formerly Santa Rita)"
    },
    {
     "Country": "Guam",
     "Region": "Micronesia, Oceania",
     "Province": "Sinajana"
    },
    {
     "Country": "Guam",
     "Region": "Micronesia, Oceania",
     "Province": "Talo'fo'fo (formerly Talofofo)"
    },
    {
     "Country": "Guam",
     "Region": "Micronesia, Oceania",
     "Province": "Tamuning"
    },
    {
     "Country": "Guam",
     "Region": "Micronesia, Oceania",
     "Province": "Yigo"
    },
    {
     "Country": "Guam",
     "Region": "Micronesia, Oceania",
     "Province": "Yona"
    },
    {
     "Country": "Guatemala",
     "Region": "Central America",
     "Province": "Alta Verapaz"
    },
    {
     "Country": "Guatemala",
     "Region": "Central America",
     "Province": "Baja Verapaz"
    },
    {
     "Country": "Guatemala",
     "Region": "Central America",
     "Province": "Chimaltenango"
    },
    {
     "Country": "Guatemala",
     "Region": "Central America",
     "Province": "Chiquimula"
    },
    {
     "Country": "Guatemala",
     "Region": "Central America",
     "Province": "El Progreso"
    },
    {
     "Country": "Guatemala",
     "Region": "Central America",
     "Province": "Escuintla"
    },
    {
     "Country": "Guatemala",
     "Region": "Central America",
     "Province": "Guatemala Department"
    },
    {
     "Country": "Guatemala",
     "Region": "Central America",
     "Province": "Huehuetenango"
    },
    {
     "Country": "Guatemala",
     "Region": "Central America",
     "Province": "Izabal"
    },
    {
     "Country": "Guatemala",
     "Region": "Central America",
     "Province": "Jalapa"
    },
    {
     "Country": "Guatemala",
     "Region": "Central America",
     "Province": "Jutiapa"
    },
    {
     "Country": "Guatemala",
     "Region": "Central America",
     "Province": "Petén"
    },
    {
     "Country": "Guatemala",
     "Region": "Central America",
     "Province": "Quetzaltenango"
    },
    {
     "Country": "Guatemala",
     "Region": "Central America",
     "Province": "Quiché"
    },
    {
     "Country": "Guatemala",
     "Region": "Central America",
     "Province": "Retalhuleu"
    },
    {
     "Country": "Guatemala",
     "Region": "Central America",
     "Province": "Sacatepéquez"
    },
    {
     "Country": "Guatemala",
     "Region": "Central America",
     "Province": "San Marcos"
    },
    {
     "Country": "Guatemala",
     "Region": "Central America",
     "Province": "Santa Rosa"
    },
    {
     "Country": "Guatemala",
     "Region": "Central America",
     "Province": "Sololá"
    },
    {
     "Country": "Guatemala",
     "Region": "Central America",
     "Province": "Suchitepéquez"
    },
    {
     "Country": "Guatemala",
     "Region": "Central America",
     "Province": "Totonicapán"
    },
    {
     "Country": "Guatemala",
     "Region": "Central America",
     "Province": "Zacapa"
    },
    {
     "Country": "Guinea",
     "Region": "West Africa",
     "Province": "Boké"
    },
    {
     "Country": "Guinea",
     "Region": "West Africa",
     "Province": "Conakry"
    },
    {
     "Country": "Guinea",
     "Region": "West Africa",
     "Province": "Faranah"
    },
    {
     "Country": "Guinea",
     "Region": "West Africa",
     "Province": "Kankan"
    },
    {
     "Country": "Guinea",
     "Region": "West Africa",
     "Province": "Kindia"
    },
    {
     "Country": "Guinea",
     "Region": "West Africa",
     "Province": "Labé"
    },
    {
     "Country": "Guinea",
     "Region": "West Africa",
     "Province": "Mamou"
    },
    {
     "Country": "Guinea",
     "Region": "West Africa",
     "Province": "Nzérékoré"
    },
    {
     "Country": "Guinea-Bissau",
     "Region": "West Africa",
     "Province": "Bafatá"
    },
    {
     "Country": "Guinea-Bissau",
     "Region": "West Africa",
     "Province": "Biombo"
    },
    {
     "Country": "Guinea-Bissau",
     "Region": "West Africa",
     "Province": "Bissau"
    },
    {
     "Country": "Guinea-Bissau",
     "Region": "West Africa",
     "Province": "Bolama"
    },
    {
     "Country": "Guinea-Bissau",
     "Region": "West Africa",
     "Province": "Cacheu"
    },
    {
     "Country": "Guinea-Bissau",
     "Region": "West Africa",
     "Province": "Gabú"
    },
    {
     "Country": "Guinea-Bissau",
     "Region": "West Africa",
     "Province": "Oio"
    },
    {
     "Country": "Guinea-Bissau",
     "Region": "West Africa",
     "Province": "Quinara"
    },
    {
     "Country": "Guinea-Bissau",
     "Region": "West Africa",
     "Province": "Tombali"
    },
    {
     "Country": "Guyana",
     "Region": "North Eastern South America",
     "Province": "Barima-Waini"
    },
    {
     "Country": "Guyana",
     "Region": "North Eastern South America",
     "Province": "Pomeroon-Supenaam"
    },
    {
     "Country": "Guyana",
     "Region": "North Eastern South America",
     "Province": "Essequibo Islands-West Demerara"
    },
    {
     "Country": "Guyana",
     "Region": "North Eastern South America",
     "Province": "Demerara-Mahaica"
    },
    {
     "Country": "Guyana",
     "Region": "North Eastern South America",
     "Province": "Mahaica-Berbice"
    },
    {
     "Country": "Guyana",
     "Region": "North Eastern South America",
     "Province": "East Berbice-Corentyne"
    },
    {
     "Country": "Guyana",
     "Region": "North Eastern South America",
     "Province": "Cuyuni-Mazaruni"
    },
    {
     "Country": "Guyana",
     "Region": "North Eastern South America",
     "Province": "Potaro-Siparuni"
    },
    {
     "Country": "Guyana",
     "Region": "North Eastern South America",
     "Province": "Upper Takutu-Upper Essequibo"
    },
    {
     "Country": "Guyana",
     "Region": "North Eastern South America",
     "Province": "Upper Demerara-Berbice"
    },
    {
     "Country": "Guyana",
     "Region": "North Eastern South America",
     "Province": "Guyana"
    },
    {
     "Country": "Haiti",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Artibonite"
    },
    {
     "Country": "Haiti",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Centre"
    },
    {
     "Country": "Haiti",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Grand'Anse"
    },
    {
     "Country": "Haiti",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Nippes"
    },
    {
     "Country": "Haiti",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Nord"
    },
    {
     "Country": "Haiti",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Nord-Est"
    },
    {
     "Country": "Haiti",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Nord-Ouest"
    },
    {
     "Country": "Haiti",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Ouest"
    },
    {
     "Country": "Haiti",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Sud-Est"
    },
    {
     "Country": "Haiti",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Sud"
    },
    {
     "Country": "Honduras",
     "Region": "Central America",
     "Province": "La Ceiba"
    },
    {
     "Country": "Honduras",
     "Region": "Central America",
     "Province": "Choluteca"
    },
    {
     "Country": "Honduras",
     "Region": "Central America",
     "Province": "Trujillo"
    },
    {
     "Country": "Honduras",
     "Region": "Central America",
     "Province": "Comayagua"
    },
    {
     "Country": "Honduras",
     "Region": "Central America",
     "Province": "Santa Rosa de Copán"
    },
    {
     "Country": "Honduras",
     "Region": "Central America",
     "Province": "San Pedro Sula"
    },
    {
     "Country": "Honduras",
     "Region": "Central America",
     "Province": "Yuscarán"
    },
    {
     "Country": "Honduras",
     "Region": "Central America",
     "Province": "Tegucigalpa"
    },
    {
     "Country": "Honduras",
     "Region": "Central America",
     "Province": "Puerto Lempira"
    },
    {
     "Country": "Honduras",
     "Region": "Central America",
     "Province": "La Esperanza"
    },
    {
     "Country": "Honduras",
     "Region": "Central America",
     "Province": "Roatan"
    },
    {
     "Country": "Honduras",
     "Region": "Central America",
     "Province": "La Paz"
    },
    {
     "Country": "Honduras",
     "Region": "Central America",
     "Province": "Gracias"
    },
    {
     "Country": "Honduras",
     "Region": "Central America",
     "Province": "Nueva Ocotepeque"
    },
    {
     "Country": "Honduras",
     "Region": "Central America",
     "Province": "Juticalpa"
    },
    {
     "Country": "Honduras",
     "Region": "Central America",
     "Province": "Santa Bárbara"
    },
    {
     "Country": "Honduras",
     "Region": "Central America",
     "Province": "Nacaome"
    },
    {
     "Country": "Honduras",
     "Region": "Central America",
     "Province": "Yoro"
    },
    {
     "Country": "Hong Kong",
     "Region": "Eastern Asia",
     "Province": "Islands"
    },
    {
     "Country": "Hong Kong",
     "Region": "Eastern Asia",
     "Province": "Kwai Tsing"
    },
    {
     "Country": "Hong Kong",
     "Region": "Eastern Asia",
     "Province": "North"
    },
    {
     "Country": "Hong Kong",
     "Region": "Eastern Asia",
     "Province": "Sai Kung"
    },
    {
     "Country": "Hong Kong",
     "Region": "Eastern Asia",
     "Province": "Sha Tin"
    },
    {
     "Country": "Hong Kong",
     "Region": "Eastern Asia",
     "Province": "Tai Po"
    },
    {
     "Country": "Hong Kong",
     "Region": "Eastern Asia",
     "Province": "Tsuen Wan"
    },
    {
     "Country": "Hong Kong",
     "Region": "Eastern Asia",
     "Province": "Tuen Mun"
    },
    {
     "Country": "Hong Kong",
     "Region": "Eastern Asia",
     "Province": "Yuen Long"
    },
    {
     "Country": "Hong Kong",
     "Region": "Eastern Asia",
     "Province": "Kowloon City"
    },
    {
     "Country": "Hong Kong",
     "Region": "Eastern Asia",
     "Province": "Kwun Tong"
    },
    {
     "Country": "Hong Kong",
     "Region": "Eastern Asia",
     "Province": "Sham Shui Po"
    },
    {
     "Country": "Hong Kong",
     "Region": "Eastern Asia",
     "Province": "Wong Tai Sin"
    },
    {
     "Country": "Hong Kong",
     "Region": "Eastern Asia",
     "Province": "Yau Tsim Mong"
    },
    {
     "Country": "Hong Kong",
     "Region": "Eastern Asia",
     "Province": "Central and Western"
    },
    {
     "Country": "Hong Kong",
     "Region": "Eastern Asia",
     "Province": "Eastern"
    },
    {
     "Country": "Hong Kong",
     "Region": "Eastern Asia",
     "Province": "Southern"
    },
    {
     "Country": "Hong Kong",
     "Region": "Eastern Asia",
     "Province": "Wan Chai"
    },
    {
     "Country": "Hungary",
     "Region": "Eastern Europe",
     "Province": "Miskolc"
    },
    {
     "Country": "Hungary",
     "Region": "Eastern Europe",
     "Province": "Debrecen"
    },
    {
     "Country": "Hungary",
     "Region": "Eastern Europe",
     "Province": "Szeged"
    },
    {
     "Country": "Hungary",
     "Region": "Eastern Europe",
     "Province": "Budapest (Budapest)"
    },
    {
     "Country": "Hungary",
     "Region": "Eastern Europe",
     "Province": "Budapest"
    },
    {
     "Country": "Hungary",
     "Region": "Eastern Europe",
     "Province": "Székesfehérvár"
    },
    {
     "Country": "Hungary",
     "Region": "Eastern Europe",
     "Province": "Győr"
    },
    {
     "Country": "Hungary",
     "Region": "Eastern Europe",
     "Province": "Pécs"
    },
    {
     "Country": "Iceland",
     "Region": "Northern Europe",
     "Province": "Höfuðborgarsvæðið"
    },
    {
     "Country": "Iceland",
     "Region": "Northern Europe",
     "Province": "Suðurnes"
    },
    {
     "Country": "Iceland",
     "Region": "Northern Europe",
     "Province": "Vesturland"
    },
    {
     "Country": "Iceland",
     "Region": "Northern Europe",
     "Province": "Vestfirðir"
    },
    {
     "Country": "Iceland",
     "Region": "Northern Europe",
     "Province": "Norðurland vestra"
    },
    {
     "Country": "Iceland",
     "Region": "Northern Europe",
     "Province": "Norðurland eystra"
    },
    {
     "Country": "Iceland",
     "Region": "Northern Europe",
     "Province": "Austurland"
    },
    {
     "Country": "Iceland",
     "Region": "Northern Europe",
     "Province": "Suðurland"
    },
    {
     "Country": "Iceland",
     "Region": "Northern Europe",
     "Province": "Ísland"
    },
    {
     "Country": "India",
     "Region": "South-Central Asia",
     "Province": " Andhra Pradesh"
    },
    {
     "Country": "India",
     "Region": "South-Central Asia",
     "Province": " Arunachal Pradesh"
    },
    {
     "Country": "India",
     "Region": "South-Central Asia",
     "Province": " Assam"
    },
    {
     "Country": "India",
     "Region": "South-Central Asia",
     "Province": " Bihar"
    },
    {
     "Country": "India",
     "Region": "South-Central Asia",
     "Province": " Chhattisgarh"
    },
    {
     "Country": "India",
     "Region": "South-Central Asia",
     "Province": " Goa"
    },
    {
     "Country": "India",
     "Region": "South-Central Asia",
     "Province": " Gujarat"
    },
    {
     "Country": "India",
     "Region": "South-Central Asia",
     "Province": " Haryana"
    },
    {
     "Country": "India",
     "Region": "South-Central Asia",
     "Province": " Himachal Pradesh"
    },
    {
     "Country": "India",
     "Region": "South-Central Asia",
     "Province": " Jharkhand"
    },
    {
     "Country": "India",
     "Region": "South-Central Asia",
     "Province": " Karnataka"
    },
    {
     "Country": "India",
     "Region": "South-Central Asia",
     "Province": " Kerala"
    },
    {
     "Country": "India",
     "Region": "South-Central Asia",
     "Province": " Madhya Pradesh"
    },
    {
     "Country": "India",
     "Region": "South-Central Asia",
     "Province": " Maharashtra"
    },
    {
     "Country": "India",
     "Region": "South-Central Asia",
     "Province": " Manipur"
    },
    {
     "Country": "India",
     "Region": "South-Central Asia",
     "Province": " Meghalaya"
    },
    {
     "Country": "India",
     "Region": "South-Central Asia",
     "Province": " Mizoram"
    },
    {
     "Country": "India",
     "Region": "South-Central Asia",
     "Province": " Nagaland"
    },
    {
     "Country": "India",
     "Region": "South-Central Asia",
     "Province": " Odisha"
    },
    {
     "Country": "India",
     "Region": "South-Central Asia",
     "Province": " Punjab"
    },
    {
     "Country": "India",
     "Region": "South-Central Asia",
     "Province": " Rajasthan"
    },
    {
     "Country": "India",
     "Region": "South-Central Asia",
     "Province": " Sikkim"
    },
    {
     "Country": "India",
     "Region": "South-Central Asia",
     "Province": " Tamil Nadu"
    },
    {
     "Country": "India",
     "Region": "South-Central Asia",
     "Province": " Telangana"
    },
    {
     "Country": "India",
     "Region": "South-Central Asia",
     "Province": " Tripura"
    },
    {
     "Country": "India",
     "Region": "South-Central Asia",
     "Province": " Uttar Pradesh"
    },
    {
     "Country": "India",
     "Region": "South-Central Asia",
     "Province": " Uttarakhand"
    },
    {
     "Country": "India",
     "Region": "South-Central Asia",
     "Province": " West Bengal"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Aceh"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "North Sumatra"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Sumatera Utara"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "West Sumatra"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Sumatera Barat"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Riau"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Jambi"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "South Sumatra"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Sumatera Selatan"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Bengkulu"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Lampung"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Bangka Belitung Islands"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Kepulauan Bangka Belitung"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Riau Islands"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Kepulauan Riau"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Special Capital Region of Jakarta"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Daerah Khusus Ibukota Jakarta"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "West Java"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Jawa Barat"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Central Java"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Jawa Tengah"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Special Region of Yogyakarta"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Daerah Istimewa Yogyakarta"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "East Java"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Jawa Timur"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Banten"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Bali"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "West Nusa Tenggara"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Nusa Tenggara Barat"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "East Nusa Tenggara"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Nusa Tenggara Timur"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "West Kalimantan"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Kalimantan Barat"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Central Kalimantan"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Kalimantan Tengah"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "South Kalimantan"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Kalimantan Selatan"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "East Kalimantan"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Kalimantan Timur"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "North Kalimantan"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Kalimantan Utara"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "North Sulawesi"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Sulawesi Utara"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Central Sulawesi"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Sulawesi Tengah"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "South Sulawesi"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Sulawesi Selatan"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Southeast Sulawesi"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Sulawesi Tenggara"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Gorontalo"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "West Sulawesi"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Sulawesi Barat"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Maluku"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "North Maluku"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Maluku Utara"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "West Papua"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Papua Barat"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Southwest Papua"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Papua Barat Daya"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Papua"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "South Papua"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Papua Selatan"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Central Papua"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Papua Tengah"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Highland Papua"
    },
    {
     "Country": "Indonesia",
     "Region": "Maritime South-East Asia",
     "Province": "Papua Pegunungan"
    },
    {
     "Country": "Iran (Islamic Republic of)",
     "Region": "South-Central Asia",
     "Province": " Arabistan (Khuzestan)"
    },
    {
     "Country": "Iran (Islamic Republic of)",
     "Region": "South-Central Asia",
     "Province": " Astarabad (Gorgan)"
    },
    {
     "Country": "Iran (Islamic Republic of)",
     "Region": "South-Central Asia",
     "Province": " Damavand"
    },
    {
     "Country": "Iran (Islamic Republic of)",
     "Region": "South-Central Asia",
     "Province": " Gerrus (Bijar)"
    },
    {
     "Country": "Iran (Islamic Republic of)",
     "Region": "South-Central Asia",
     "Province": " Gilan"
    },
    {
     "Country": "Iran (Islamic Republic of)",
     "Region": "South-Central Asia",
     "Province": " Golpayegan"
    },
    {
     "Country": "Iran (Islamic Republic of)",
     "Region": "South-Central Asia",
     "Province": " Hamadan"
    },
    {
     "Country": "Iran (Islamic Republic of)",
     "Region": "South-Central Asia",
     "Province": " Iraq (Arak)"
    },
    {
     "Country": "Iran (Islamic Republic of)",
     "Region": "South-Central Asia",
     "Province": " Isfahan"
    },
    {
     "Country": "Iran (Islamic Republic of)",
     "Region": "South-Central Asia",
     "Province": " Kashan"
    },
    {
     "Country": "Iran (Islamic Republic of)",
     "Region": "South-Central Asia",
     "Province": " Khamseh (Zanjan)"
    },
    {
     "Country": "Iran (Islamic Republic of)",
     "Region": "South-Central Asia",
     "Province": " Kermanshahan (Kermanshah)"
    },
    {
     "Country": "Iran (Islamic Republic of)",
     "Region": "South-Central Asia",
     "Province": " Kurdistan"
    },
    {
     "Country": "Iran (Islamic Republic of)",
     "Region": "South-Central Asia",
     "Province": " Luristan"
    },
    {
     "Country": "Iran (Islamic Republic of)",
     "Region": "South-Central Asia",
     "Province": " Malayer"
    },
    {
     "Country": "Iran (Islamic Republic of)",
     "Region": "South-Central Asia",
     "Province": " Mazandaran"
    },
    {
     "Country": "Iran (Islamic Republic of)",
     "Region": "South-Central Asia",
     "Province": " Qazvin"
    },
    {
     "Country": "Iran (Islamic Republic of)",
     "Region": "South-Central Asia",
     "Province": " Qom"
    },
    {
     "Country": "Iran (Islamic Republic of)",
     "Region": "South-Central Asia",
     "Province": " Saveh"
    },
    {
     "Country": "Iran (Islamic Republic of)",
     "Region": "South-Central Asia",
     "Province": " Semnan and Damghan"
    },
    {
     "Country": "Iran (Islamic Republic of)",
     "Region": "South-Central Asia",
     "Province": " Shahrud and Bastam"
    },
    {
     "Country": "Iran (Islamic Republic of)",
     "Region": "South-Central Asia",
     "Province": " Yazd"
    },
    {
     "Country": "Iran (Islamic Republic of)",
     "Region": "South-Central Asia",
     "Province": "Tehran"
    },
    {
     "Country": "Iraq",
     "Region": "Middle East, Western Asia",
     "Province": "Al-Anbar"
    },
    {
     "Country": "Iraq",
     "Region": "Middle East, Western Asia",
     "Province": "Babil"
    },
    {
     "Country": "Iraq",
     "Region": "Middle East, Western Asia",
     "Province": "Baghdad"
    },
    {
     "Country": "Iraq",
     "Region": "Middle East, Western Asia",
     "Province": "Basra"
    },
    {
     "Country": "Iraq",
     "Region": "Middle East, Western Asia",
     "Province": "Dhi Qar"
    },
    {
     "Country": "Iraq",
     "Region": "Middle East, Western Asia",
     "Province": "Al-Qādisiyyah"
    },
    {
     "Country": "Iraq",
     "Region": "Middle East, Western Asia",
     "Province": "Diyala"
    },
    {
     "Country": "Iraq",
     "Region": "Middle East, Western Asia",
     "Province": "Duhok"
    },
    {
     "Country": "Iraq",
     "Region": "Middle East, Western Asia",
     "Province": "Erbil"
    },
    {
     "Country": "Iraq",
     "Region": "Middle East, Western Asia",
     "Province": "Karbala"
    },
    {
     "Country": "Iraq",
     "Region": "Middle East, Western Asia",
     "Province": "Kirkuk"
    },
    {
     "Country": "Iraq",
     "Region": "Middle East, Western Asia",
     "Province": "Maysan"
    },
    {
     "Country": "Iraq",
     "Region": "Middle East, Western Asia",
     "Province": "Muthanna"
    },
    {
     "Country": "Iraq",
     "Region": "Middle East, Western Asia",
     "Province": "Najaf"
    },
    {
     "Country": "Iraq",
     "Region": "Middle East, Western Asia",
     "Province": "Ninawa"
    },
    {
     "Country": "Iraq",
     "Region": "Middle East, Western Asia",
     "Province": "Salah Al-Din"
    },
    {
     "Country": "Iraq",
     "Region": "Middle East, Western Asia",
     "Province": "Sulaymaniyah"
    },
    {
     "Country": "Iraq",
     "Region": "Middle East, Western Asia",
     "Province": "Wasit"
    },
    {
     "Country": "Ireland",
     "Region": "Northern Europe",
     "Province": "Connacht"
    },
    {
     "Country": "Ireland",
     "Region": "Northern Europe",
     "Province": "Leinster"
    },
    {
     "Country": "Ireland",
     "Region": "Northern Europe",
     "Province": "Munster"
    },
    {
     "Country": "Ireland",
     "Region": "Northern Europe",
     "Province": "Ulster"
    },
    {
     "Country": "Israel",
     "Region": "Middle East, Western Asia",
     "Province": "Haifa"
    },
    {
     "Country": "Israel",
     "Region": "Middle East, Western Asia",
     "Province": "Jerusalem"
    },
    {
     "Country": "Israel",
     "Region": "Middle East, Western Asia",
     "Province": "Tel Aviv"
    },
    {
     "Country": "Israel",
     "Region": "Middle East, Western Asia",
     "Province": "southern Sharon"
    },
    {
     "Country": "Israel",
     "Region": "Middle East, Western Asia",
     "Province": "Galilee"
    },
    {
     "Country": "Israel",
     "Region": "Middle East, Western Asia",
     "Province": "Shfela and Arabah"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Agrigento"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Alessandria"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Ancona"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Aosta"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Arezzo"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Ascoli Piceno"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Asti"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Avellino"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Bari"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Barletta-Andria-Trani"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Belluno"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Benevento"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Bergamo"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Biella"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Bologna"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Brescia"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Brindisi"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Cagliari"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Caltanissetta"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Campobasso"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Caserta"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Catania"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Catanzaro"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Chieti"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Como"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Cosenza"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Cremona"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Crotone"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Cuneo"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Enna"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Fermo"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Ferrara"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Florence"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Foggia"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Forlì-Cesena"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Frosinone"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Genoa"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Gorizia"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Grosseto"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Imperia"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Isernia"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "L'Aquila"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "La Spezia"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Latina"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Lecce"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Lecco"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Livorno"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Lodi"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Lucca"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Macerata"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Mantua"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Massa-Carrara"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Matera"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Messina"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Milan"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Modena"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Monza and Brianza"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Naples"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Novara"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Nuoro"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Oristano"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Padua"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Palermo"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Parma"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Pavia"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Perugia"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Pesaro and Urbino"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Pescara"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Piacenza"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Pisa"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Pistoia"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Pordenone"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Potenza"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Prato"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Ragusa"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Ravenna"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Reggio Calabria"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Reggio Emilia"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Rieti"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Rimini"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Rome"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Rovigo"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Salerno"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Sassari"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Savona"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Siena"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Sondrio"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "South Sardinia"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "South Tyrol"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Syracuse"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Taranto"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Teramo"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Terni"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Trapani"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Trento"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Treviso"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Trieste"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Turin"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Udine"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Varese"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Venice"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Verbano-Cusio-Ossola"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Vercelli"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Verona"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Vibo Valentia"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Vicenza"
    },
    {
     "Country": "Italy",
     "Region": "Southern Europe",
     "Province": "Viterbo"
    },
    {
     "Country": "Ivory Coast",
     "Region": "West Africa",
     "Province": "Abidjan"
    },
    {
     "Country": "Ivory Coast",
     "Region": "West Africa",
     "Province": "Bas-Sassandra"
    },
    {
     "Country": "Ivory Coast",
     "Region": "West Africa",
     "Province": "San-Pédro"
    },
    {
     "Country": "Ivory Coast",
     "Region": "West Africa",
     "Province": "Comoé"
    },
    {
     "Country": "Ivory Coast",
     "Region": "West Africa",
     "Province": "Denguélé"
    },
    {
     "Country": "Ivory Coast",
     "Region": "West Africa",
     "Province": "Gôh-Djiboua"
    },
    {
     "Country": "Ivory Coast",
     "Region": "West Africa",
     "Province": "Lacs"
    },
    {
     "Country": "Ivory Coast",
     "Region": "West Africa",
     "Province": "Lagunes"
    },
    {
     "Country": "Ivory Coast",
     "Region": "West Africa",
     "Province": "Montagnes"
    },
    {
     "Country": "Ivory Coast",
     "Region": "West Africa",
     "Province": "Sassandra-Marahoué"
    },
    {
     "Country": "Ivory Coast",
     "Region": "West Africa",
     "Province": "Savanes"
    },
    {
     "Country": "Ivory Coast",
     "Region": "West Africa",
     "Province": "Vallée du Bandama"
    },
    {
     "Country": "Ivory Coast",
     "Region": "West Africa",
     "Province": "Woroba"
    },
    {
     "Country": "Ivory Coast",
     "Region": "West Africa",
     "Province": "Yamoussoukro"
    },
    {
     "Country": "Ivory Coast",
     "Region": "West Africa",
     "Province": "Zanzan"
    },
    {
     "Country": "Jamaica",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Hanover"
    },
    {
     "Country": "Jamaica",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Saint Elizabeth"
    },
    {
     "Country": "Jamaica",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Saint James"
    },
    {
     "Country": "Jamaica",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Trelawny"
    },
    {
     "Country": "Jamaica",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Westmoreland"
    },
    {
     "Country": "Jamaica",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Clarendon"
    },
    {
     "Country": "Jamaica",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Manchester"
    },
    {
     "Country": "Jamaica",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Saint Ann"
    },
    {
     "Country": "Jamaica",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Saint Catherine"
    },
    {
     "Country": "Jamaica",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Saint Mary"
    },
    {
     "Country": "Jamaica",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Kingston Parish"
    },
    {
     "Country": "Jamaica",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Portland"
    },
    {
     "Country": "Jamaica",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Saint Andrew"
    },
    {
     "Country": "Jamaica",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Saint Thomas"
    },
    {
     "Country": "Jamaica",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Jamaica"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Aichi"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Akita"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Aomori"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Chiba"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Ehime"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Fukui"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Fukuoka"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Fukushima"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Gifu"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Gunma"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Hiroshima"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Hokkaido"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Hyōgo"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Ibaraki"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Ishikawa"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Iwate"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Kagawa"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Kagoshima"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Kanagawa"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Kōchi"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Kumamoto"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Kyōto"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Mie"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Miyagi"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Miyazaki"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Nagano"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Nagasaki"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Nara"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Niigata"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Ōita"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Okayama"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Okinawa"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Ōsaka"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Saga"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Saitama"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Shiga"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Shimane"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Shizuoka"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Tochigi"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Tokushima"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Tōkyō"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Tottori"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Toyama"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Wakayama"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Yamagata"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Yamaguchi"
    },
    {
     "Country": "Japan",
     "Region": "Eastern Asia",
     "Province": " Yamanashi"
    },
    {
     "Country": "Jordan",
     "Region": "Middle East, Western Asia",
     "Province": "Irbid"
    },
    {
     "Country": "Jordan",
     "Region": "Middle East, Western Asia",
     "Province": "Ajloun"
    },
    {
     "Country": "Jordan",
     "Region": "Middle East, Western Asia",
     "Province": "Jerash"
    },
    {
     "Country": "Jordan",
     "Region": "Middle East, Western Asia",
     "Province": "Mafraq"
    },
    {
     "Country": "Jordan",
     "Region": "Middle East, Western Asia",
     "Province": "Central Region"
    },
    {
     "Country": "Jordan",
     "Region": "Middle East, Western Asia",
     "Province": "Balqa"
    },
    {
     "Country": "Jordan",
     "Region": "Middle East, Western Asia",
     "Province": "Amman"
    },
    {
     "Country": "Jordan",
     "Region": "Middle East, Western Asia",
     "Province": "Zarqa"
    },
    {
     "Country": "Jordan",
     "Region": "Middle East, Western Asia",
     "Province": "Madaba"
    },
    {
     "Country": "Jordan",
     "Region": "Middle East, Western Asia",
     "Province": "South Region"
    },
    {
     "Country": "Jordan",
     "Region": "Middle East, Western Asia",
     "Province": "Karak"
    },
    {
     "Country": "Jordan",
     "Region": "Middle East, Western Asia",
     "Province": "Tafilah"
    },
    {
     "Country": "Jordan",
     "Region": "Middle East, Western Asia",
     "Province": "Ma'an"
    },
    {
     "Country": "Jordan",
     "Region": "Middle East, Western Asia",
     "Province": "Aqaba"
    },
    {
     "Country": "Kazakhstan",
     "Region": "Central Asia",
     "Province": "Abai "
    },
    {
     "Country": "Kazakhstan",
     "Region": "Central Asia",
     "Province": "Akmola "
    },
    {
     "Country": "Kazakhstan",
     "Region": "Central Asia",
     "Province": "Aktobe "
    },
    {
     "Country": "Kazakhstan",
     "Region": "Central Asia",
     "Province": "Almaty"
    },
    {
     "Country": "Kazakhstan",
     "Region": "Central Asia",
     "Province": "Almaty "
    },
    {
     "Country": "Kazakhstan",
     "Region": "Central Asia",
     "Province": "Astana"
    },
    {
     "Country": "Kazakhstan",
     "Region": "Central Asia",
     "Province": "Atyrau "
    },
    {
     "Country": "Kazakhstan",
     "Region": "Central Asia",
     "Province": "Baikonur"
    },
    {
     "Country": "Kazakhstan",
     "Region": "Central Asia",
     "Province": "East Kazakhstan "
    },
    {
     "Country": "Kazakhstan",
     "Region": "Central Asia",
     "Province": "Jambyl "
    },
    {
     "Country": "Kazakhstan",
     "Region": "Central Asia",
     "Province": "Jetisu "
    },
    {
     "Country": "Kazakhstan",
     "Region": "Central Asia",
     "Province": "Karaganda "
    },
    {
     "Country": "Kazakhstan",
     "Region": "Central Asia",
     "Province": "Kostanay "
    },
    {
     "Country": "Kazakhstan",
     "Region": "Central Asia",
     "Province": "Kyzylorda "
    },
    {
     "Country": "Kazakhstan",
     "Region": "Central Asia",
     "Province": "Mangystau "
    },
    {
     "Country": "Kazakhstan",
     "Region": "Central Asia",
     "Province": "North Kazakhstan "
    },
    {
     "Country": "Kazakhstan",
     "Region": "Central Asia",
     "Province": "Pavlodar "
    },
    {
     "Country": "Kazakhstan",
     "Region": "Central Asia",
     "Province": "Shymkent"
    },
    {
     "Country": "Kazakhstan",
     "Region": "Central Asia",
     "Province": "Turkistan "
    },
    {
     "Country": "Kazakhstan",
     "Region": "Central Asia",
     "Province": "Ulytau "
    },
    {
     "Country": "Kazakhstan",
     "Region": "Central Asia",
     "Province": "West Kazakhstan "
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Mombasa"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Kwale"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Kilifi"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Tana River"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Lamu"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Taita-Taveta"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Garissa"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Wajir"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Mandera"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Marsabit"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Isiolo"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Meru"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Tharaka-Nithi"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Embu"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Kitui"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Machakos"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Makueni"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Nyandarua"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Nyeri"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Kirinyaga"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Murang'a"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Kiambu"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Turkana"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "West Pokot"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Samburu"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Trans Nzoia"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Uasin Gishu"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Elgeyo-Marakwet"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Nandi"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Baringo"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Laikipia"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Nakuru"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Narok"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Kajiado"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Kericho"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Bomet"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Kakamega"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Vihiga"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Bungoma"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Busia"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Siaya"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Kisumu"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Homa Bay"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Migori"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Kisii"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Nyamira"
    },
    {
     "Country": "Kenya",
     "Region": "Eastern Africa",
     "Province": "Nairobi"
    },
    {
     "Country": "Kiribati",
     "Region": "Micronesia, Oceania",
     "Province": " Banaba"
    },
    {
     "Country": "Kiribati",
     "Region": "Micronesia, Oceania",
     "Province": " Betio Town Council (BTC) of South Tarawa"
    },
    {
     "Country": "Kiribati",
     "Region": "Micronesia, Oceania",
     "Province": " Eutan Tarawa Council (ETC) of North Tarawa"
    },
    {
     "Country": "Kiribati",
     "Region": "Micronesia, Oceania",
     "Province": " Teinainano Urban Council (TUC) of South Tarawa"
    },
    {
     "Country": "Kiribati",
     "Region": "Micronesia, Oceania",
     "Province": " Abaiang"
    },
    {
     "Country": "Kiribati",
     "Region": "Micronesia, Oceania",
     "Province": " Butaritari"
    },
    {
     "Country": "Kiribati",
     "Region": "Micronesia, Oceania",
     "Province": " Makin"
    },
    {
     "Country": "Kiribati",
     "Region": "Micronesia, Oceania",
     "Province": " Marakei"
    },
    {
     "Country": "Kiribati",
     "Region": "Micronesia, Oceania",
     "Province": " Abemama"
    },
    {
     "Country": "Kiribati",
     "Region": "Micronesia, Oceania",
     "Province": " Aranuka"
    },
    {
     "Country": "Kiribati",
     "Region": "Micronesia, Oceania",
     "Province": " Kuria"
    },
    {
     "Country": "Kiribati",
     "Region": "Micronesia, Oceania",
     "Province": " Maiana"
    },
    {
     "Country": "Kiribati",
     "Region": "Micronesia, Oceania",
     "Province": " Arorae"
    },
    {
     "Country": "Kiribati",
     "Region": "Micronesia, Oceania",
     "Province": " Beru"
    },
    {
     "Country": "Kiribati",
     "Region": "Micronesia, Oceania",
     "Province": " Nikunau"
    },
    {
     "Country": "Kiribati",
     "Region": "Micronesia, Oceania",
     "Province": " Nonouti"
    },
    {
     "Country": "Kiribati",
     "Region": "Micronesia, Oceania",
     "Province": " North Tabiteuea (Tabiteuea)"
    },
    {
     "Country": "Kiribati",
     "Region": "Micronesia, Oceania",
     "Province": " Onotoa"
    },
    {
     "Country": "Kiribati",
     "Region": "Micronesia, Oceania",
     "Province": " South Tabiteuea (Tabiteuea)"
    },
    {
     "Country": "Kiribati",
     "Region": "Micronesia, Oceania",
     "Province": " Tamana"
    },
    {
     "Country": "Kiribati",
     "Region": "Micronesia, Oceania",
     "Province": " Canton"
    },
    {
     "Country": "Kiribati",
     "Region": "Micronesia, Oceania",
     "Province": " Kiritimati"
    },
    {
     "Country": "Kiribati",
     "Region": "Micronesia, Oceania",
     "Province": " Tabuaeran"
    },
    {
     "Country": "Kiribati",
     "Region": "Micronesia, Oceania",
     "Province": " Teraina"
    },
    {
     "Country": "Korea, Democratic People's Rep. (North Korea)",
     "Region": "Eastern Asia",
     "Province": "Chagang"
    },
    {
     "Country": "Korea, Democratic People's Rep. (North Korea)",
     "Region": "Eastern Asia",
     "Province": "North Hamgyong"
    },
    {
     "Country": "Korea, Democratic People's Rep. (North Korea)",
     "Region": "Eastern Asia",
     "Province": "South Hamgyong"
    },
    {
     "Country": "Korea, Democratic People's Rep. (North Korea)",
     "Region": "Eastern Asia",
     "Province": "North Hwanghae"
    },
    {
     "Country": "Korea, Democratic People's Rep. (North Korea)",
     "Region": "Eastern Asia",
     "Province": "South Hwanghae"
    },
    {
     "Country": "Korea, Democratic People's Rep. (North Korea)",
     "Region": "Eastern Asia",
     "Province": "Kangwon"
    },
    {
     "Country": "Korea, Democratic People's Rep. (North Korea)",
     "Region": "Eastern Asia",
     "Province": "North Pyongan"
    },
    {
     "Country": "Korea, Democratic People's Rep. (North Korea)",
     "Region": "Eastern Asia",
     "Province": "South Pyongan"
    },
    {
     "Country": "Korea, Democratic People's Rep. (North Korea)",
     "Region": "Eastern Asia",
     "Province": "Ryanggang"
    },
    {
     "Country": "Korea, Republic of (South Korea)",
     "Region": "Eastern Asia",
     "Province": " North Chungcheong"
    },
    {
     "Country": "Korea, Republic of (South Korea)",
     "Region": "Eastern Asia",
     "Province": " South Chungcheong"
    },
    {
     "Country": "Korea, Republic of (South Korea)",
     "Region": "Eastern Asia",
     "Province": " Gangwon"
    },
    {
     "Country": "Korea, Republic of (South Korea)",
     "Region": "Eastern Asia",
     "Province": " Gyeonggi"
    },
    {
     "Country": "Korea, Republic of (South Korea)",
     "Region": "Eastern Asia",
     "Province": " North Gyeongsang"
    },
    {
     "Country": "Korea, Republic of (South Korea)",
     "Region": "Eastern Asia",
     "Province": " South Gyeongsang"
    },
    {
     "Country": "Korea, Republic of (South Korea)",
     "Region": "Eastern Asia",
     "Province": "Jeonbuk"
    },
    {
     "Country": "Korea, Republic of (South Korea)",
     "Region": "Eastern Asia",
     "Province": " South Jeolla"
    },
    {
     "Country": "Korea, Republic of (South Korea)",
     "Region": "Eastern Asia",
     "Province": " Jeju"
    },
    {
     "Country": "Kosovo",
     "Region": "Southern Europe",
     "Province": " Ferizaj"
    },
    {
     "Country": "Kosovo",
     "Region": "Southern Europe",
     "Province": " Gjakova"
    },
    {
     "Country": "Kosovo",
     "Region": "Southern Europe",
     "Province": " Gjilan"
    },
    {
     "Country": "Kuwait",
     "Region": "Middle East, Western Asia",
     "Province": "Ahmadi "
    },
    {
     "Country": "Kuwait",
     "Region": "Middle East, Western Asia",
     "Province": "Al-Asimah "
    },
    {
     "Country": "Kuwait",
     "Region": "Middle East, Western Asia",
     "Province": "Farwaniya "
    },
    {
     "Country": "Kuwait",
     "Region": "Middle East, Western Asia",
     "Province": "Hawalli "
    },
    {
     "Country": "Kuwait",
     "Region": "Middle East, Western Asia",
     "Province": "Jahra "
    },
    {
     "Country": "Kuwait",
     "Region": "Middle East, Western Asia",
     "Province": "Mubarak Al-Kabeer "
    },
    {
     "Country": "Kyrgyzstan",
     "Region": "Central Asia",
     "Province": " Bishkek City"
    },
    {
     "Country": "Kyrgyzstan",
     "Region": "Central Asia",
     "Province": " Batken Region"
    },
    {
     "Country": "Kyrgyzstan",
     "Region": "Central Asia",
     "Province": " Chüy Region"
    },
    {
     "Country": "Kyrgyzstan",
     "Region": "Central Asia",
     "Province": " Jalal-Abad Region"
    },
    {
     "Country": "Kyrgyzstan",
     "Region": "Central Asia",
     "Province": " Naryn Region"
    },
    {
     "Country": "Kyrgyzstan",
     "Region": "Central Asia",
     "Province": " Osh Region"
    },
    {
     "Country": "Kyrgyzstan",
     "Region": "Central Asia",
     "Province": " Talas Region"
    },
    {
     "Country": "Kyrgyzstan",
     "Region": "Central Asia",
     "Province": " Issyk-Kul Region"
    },
    {
     "Country": "Kyrgyzstan",
     "Region": "Central Asia",
     "Province": " Osh City"
    },
    {
     "Country": "Lao, People's Democratic Republic",
     "Region": "South-East Asia",
     "Province": "Attapeu "
    },
    {
     "Country": "Lao, People's Democratic Republic",
     "Region": "South-East Asia",
     "Province": "Bokeo "
    },
    {
     "Country": "Lao, People's Democratic Republic",
     "Region": "South-East Asia",
     "Province": "Bolikhamxai "
    },
    {
     "Country": "Lao, People's Democratic Republic",
     "Region": "South-East Asia",
     "Province": "Champasak "
    },
    {
     "Country": "Lao, People's Democratic Republic",
     "Region": "South-East Asia",
     "Province": "Houaphanh "
    },
    {
     "Country": "Lao, People's Democratic Republic",
     "Region": "South-East Asia",
     "Province": "Khammouane "
    },
    {
     "Country": "Lao, People's Democratic Republic",
     "Region": "South-East Asia",
     "Province": "Luang Namtha "
    },
    {
     "Country": "Lao, People's Democratic Republic",
     "Region": "South-East Asia",
     "Province": "Luang Prabang "
    },
    {
     "Country": "Lao, People's Democratic Republic",
     "Region": "South-East Asia",
     "Province": "Oudomxay "
    },
    {
     "Country": "Lao, People's Democratic Republic",
     "Region": "South-East Asia",
     "Province": "Phongsaly "
    },
    {
     "Country": "Lao, People's Democratic Republic",
     "Region": "South-East Asia",
     "Province": "Salavan "
    },
    {
     "Country": "Lao, People's Democratic Republic",
     "Region": "South-East Asia",
     "Province": "Savannakhet "
    },
    {
     "Country": "Lao, People's Democratic Republic",
     "Region": "South-East Asia",
     "Province": "Vientiane "
    },
    {
     "Country": "Lao, People's Democratic Republic",
     "Region": "South-East Asia",
     "Province": "Vientiane Prefecture"
    },
    {
     "Country": "Lao, People's Democratic Republic",
     "Region": "South-East Asia",
     "Province": "Sainyabuli "
    },
    {
     "Country": "Lao, People's Democratic Republic",
     "Region": "South-East Asia",
     "Province": "Sekong "
    },
    {
     "Country": "Lao, People's Democratic Republic",
     "Region": "South-East Asia",
     "Province": "Xaisomboun "
    },
    {
     "Country": "Lao, People's Democratic Republic",
     "Region": "South-East Asia",
     "Province": "Xiangkhouang "
    },
    {
     "Country": "Latvia",
     "Region": "Northern Europe",
     "Province": "Rīga"
    },
    {
     "Country": "Latvia",
     "Region": "Northern Europe",
     "Province": "Pierīga"
    },
    {
     "Country": "Latvia",
     "Region": "Northern Europe",
     "Province": "Kurzeme"
    },
    {
     "Country": "Latvia",
     "Region": "Northern Europe",
     "Province": "Latgale"
    },
    {
     "Country": "Latvia",
     "Region": "Northern Europe",
     "Province": "Zemgale"
    },
    {
     "Country": "Latvia",
     "Region": "Northern Europe",
     "Province": "Vidzeme"
    },
    {
     "Country": "Latvia",
     "Region": "Northern Europe",
     "Province": "Latvija"
    },
    {
     "Country": "Lebanon",
     "Region": "Middle East, Western Asia",
     "Province": "Akkar"
    },
    {
     "Country": "Lebanon",
     "Region": "Middle East, Western Asia",
     "Province": "Baalbek-Hermel"
    },
    {
     "Country": "Lebanon",
     "Region": "Middle East, Western Asia",
     "Province": "Beirut"
    },
    {
     "Country": "Lebanon",
     "Region": "Middle East, Western Asia",
     "Province": "Beqaa"
    },
    {
     "Country": "Lebanon",
     "Region": "Middle East, Western Asia",
     "Province": "Keserwan-Jbeil"
    },
    {
     "Country": "Lebanon",
     "Region": "Middle East, Western Asia",
     "Province": "Mount Lebanon"
    },
    {
     "Country": "Lebanon",
     "Region": "Middle East, Western Asia",
     "Province": "Nabatieh"
    },
    {
     "Country": "Lebanon",
     "Region": "Middle East, Western Asia",
     "Province": "North"
    },
    {
     "Country": "Lebanon",
     "Region": "Middle East, Western Asia",
     "Province": "South"
    },
    {
     "Country": "Lesotho",
     "Region": "Southern Africa",
     "Province": "Berea"
    },
    {
     "Country": "Lesotho",
     "Region": "Southern Africa",
     "Province": "Butha-Buthe"
    },
    {
     "Country": "Lesotho",
     "Region": "Southern Africa",
     "Province": "Leribe"
    },
    {
     "Country": "Lesotho",
     "Region": "Southern Africa",
     "Province": "Mafeteng"
    },
    {
     "Country": "Lesotho",
     "Region": "Southern Africa",
     "Province": "Maseru"
    },
    {
     "Country": "Lesotho",
     "Region": "Southern Africa",
     "Province": "Mohale's Hoek"
    },
    {
     "Country": "Lesotho",
     "Region": "Southern Africa",
     "Province": "Mokhotlong"
    },
    {
     "Country": "Lesotho",
     "Region": "Southern Africa",
     "Province": "Qacha's Nek"
    },
    {
     "Country": "Lesotho",
     "Region": "Southern Africa",
     "Province": "Quthing"
    },
    {
     "Country": "Lesotho",
     "Region": "Southern Africa",
     "Province": "Thaba-Tseka"
    },
    {
     "Country": "Liberia",
     "Region": "West Africa",
     "Province": " Bomi"
    },
    {
     "Country": "Liberia",
     "Region": "West Africa",
     "Province": " Bong"
    },
    {
     "Country": "Liberia",
     "Region": "West Africa",
     "Province": " Gbarpolu"
    },
    {
     "Country": "Liberia",
     "Region": "West Africa",
     "Province": " Grand Bassa"
    },
    {
     "Country": "Liberia",
     "Region": "West Africa",
     "Province": " Grand Cape Mount"
    },
    {
     "Country": "Liberia",
     "Region": "West Africa",
     "Province": " Grand Gedeh"
    },
    {
     "Country": "Liberia",
     "Region": "West Africa",
     "Province": " Grand Kru"
    },
    {
     "Country": "Liberia",
     "Region": "West Africa",
     "Province": " Lofa"
    },
    {
     "Country": "Liberia",
     "Region": "West Africa",
     "Province": " Margibi"
    },
    {
     "Country": "Liberia",
     "Region": "West Africa",
     "Province": " Maryland"
    },
    {
     "Country": "Liberia",
     "Region": "West Africa",
     "Province": " Montserrado"
    },
    {
     "Country": "Liberia",
     "Region": "West Africa",
     "Province": " Nimba"
    },
    {
     "Country": "Liberia",
     "Region": "West Africa",
     "Province": " Rivercess"
    },
    {
     "Country": "Liberia",
     "Region": "West Africa",
     "Province": " River Gee"
    },
    {
     "Country": "Liberia",
     "Region": "West Africa",
     "Province": " Sinoe"
    },
    {
     "Country": "Libya",
     "Region": "Northern Africa",
     "Province": "Al Butnan"
    },
    {
     "Country": "Libya",
     "Region": "Northern Africa",
     "Province": "Darnah"
    },
    {
     "Country": "Libya",
     "Region": "Northern Africa",
     "Province": "Al Jabal al Akhdar"
    },
    {
     "Country": "Libya",
     "Region": "Northern Africa",
     "Province": "Al Marj"
    },
    {
     "Country": "Libya",
     "Region": "Northern Africa",
     "Province": "Banghazi"
    },
    {
     "Country": "Libya",
     "Region": "Northern Africa",
     "Province": "Al Wahat"
    },
    {
     "Country": "Libya",
     "Region": "Northern Africa",
     "Province": "Al Kufrah"
    },
    {
     "Country": "Libya",
     "Region": "Northern Africa",
     "Province": "Surt"
    },
    {
     "Country": "Libya",
     "Region": "Northern Africa",
     "Province": "Misrata"
    },
    {
     "Country": "Libya",
     "Region": "Northern Africa",
     "Province": "Marqab"
    },
    {
     "Country": "Libya",
     "Region": "Northern Africa",
     "Province": "Tarabulus"
    },
    {
     "Country": "Libya",
     "Region": "Northern Africa",
     "Province": "Al Jafarah"
    },
    {
     "Country": "Libya",
     "Region": "Northern Africa",
     "Province": "Az Zawiyah"
    },
    {
     "Country": "Libya",
     "Region": "Northern Africa",
     "Province": "An Nuqat al Khams"
    },
    {
     "Country": "Libya",
     "Region": "Northern Africa",
     "Province": "Al Jabal al Gharbi"
    },
    {
     "Country": "Libya",
     "Region": "Northern Africa",
     "Province": "Nalut"
    },
    {
     "Country": "Libya",
     "Region": "Northern Africa",
     "Province": "Al Jufrah"
    },
    {
     "Country": "Libya",
     "Region": "Northern Africa",
     "Province": "Wadi ash Shati'"
    },
    {
     "Country": "Libya",
     "Region": "Northern Africa",
     "Province": "Sabha"
    },
    {
     "Country": "Libya",
     "Region": "Northern Africa",
     "Province": "Wadi al Hayat"
    },
    {
     "Country": "Libya",
     "Region": "Northern Africa",
     "Province": "Ghat"
    },
    {
     "Country": "Libya",
     "Region": "Northern Africa",
     "Province": "Murzuq"
    },
    {
     "Country": "Liechtenstein",
     "Region": "Western Europe",
     "Province": "Ruggell"
    },
    {
     "Country": "Liechtenstein",
     "Region": "Western Europe",
     "Province": "Schellenberg"
    },
    {
     "Country": "Liechtenstein",
     "Region": "Western Europe",
     "Province": "Hinterschellenberg"
    },
    {
     "Country": "Liechtenstein",
     "Region": "Western Europe",
     "Province": "Gamprin"
    },
    {
     "Country": "Liechtenstein",
     "Region": "Western Europe",
     "Province": "Bendern"
    },
    {
     "Country": "Liechtenstein",
     "Region": "Western Europe",
     "Province": "Eschen"
    },
    {
     "Country": "Liechtenstein",
     "Region": "Western Europe",
     "Province": "Nendeln"
    },
    {
     "Country": "Liechtenstein",
     "Region": "Western Europe",
     "Province": "Mauren"
    },
    {
     "Country": "Liechtenstein",
     "Region": "Western Europe",
     "Province": "Schaanwald"
    },
    {
     "Country": "Liechtenstein",
     "Region": "Western Europe",
     "Province": "Schaan"
    },
    {
     "Country": "Liechtenstein",
     "Region": "Western Europe",
     "Province": "Planken"
    },
    {
     "Country": "Liechtenstein",
     "Region": "Western Europe",
     "Province": "Vaduz"
    },
    {
     "Country": "Liechtenstein",
     "Region": "Western Europe",
     "Province": "Ebenholz, Mühleholz"
    },
    {
     "Country": "Liechtenstein",
     "Region": "Western Europe",
     "Province": "Triesenberg"
    },
    {
     "Country": "Liechtenstein",
     "Region": "Western Europe",
     "Province": "Gaflei, Malbun, Masescha, Rotenboden, Silum, Steg,"
    },
    {
     "Country": "Liechtenstein",
     "Region": "Western Europe",
     "Province": "Sücka, Wangerberg"
    },
    {
     "Country": "Liechtenstein",
     "Region": "Western Europe",
     "Province": "Triesen"
    },
    {
     "Country": "Liechtenstein",
     "Region": "Western Europe",
     "Province": "Lawena, Valüna"
    },
    {
     "Country": "Liechtenstein",
     "Region": "Western Europe",
     "Province": "Balzers"
    },
    {
     "Country": "Liechtenstein",
     "Region": "Western Europe",
     "Province": "Mäls"
    },
    {
     "Country": "Lithuania",
     "Region": "Northern Europe",
     "Province": "Alytus"
    },
    {
     "Country": "Lithuania",
     "Region": "Northern Europe",
     "Province": "Kaunas"
    },
    {
     "Country": "Lithuania",
     "Region": "Northern Europe",
     "Province": "Klaipėda"
    },
    {
     "Country": "Lithuania",
     "Region": "Northern Europe",
     "Province": "Marijampolė"
    },
    {
     "Country": "Lithuania",
     "Region": "Northern Europe",
     "Province": "Panevėžys"
    },
    {
     "Country": "Lithuania",
     "Region": "Northern Europe",
     "Province": "Šiauliai"
    },
    {
     "Country": "Lithuania",
     "Region": "Northern Europe",
     "Province": "Tauragė"
    },
    {
     "Country": "Lithuania",
     "Region": "Northern Europe",
     "Province": "Telšiai"
    },
    {
     "Country": "Lithuania",
     "Region": "Northern Europe",
     "Province": "Utena"
    },
    {
     "Country": "Lithuania",
     "Region": "Northern Europe",
     "Province": "Vilnius"
    },
    {
     "Country": "Luxembourg",
     "Region": "Western Europe",
     "Province": "Diekirch"
    },
    {
     "Country": "Luxembourg",
     "Region": "Western Europe",
     "Province": "Clervaux"
    },
    {
     "Country": "Luxembourg",
     "Region": "Western Europe",
     "Province": "Redange"
    },
    {
     "Country": "Luxembourg",
     "Region": "Western Europe",
     "Province": "Vianden"
    },
    {
     "Country": "Luxembourg",
     "Region": "Western Europe",
     "Province": "Wiltz"
    },
    {
     "Country": "Luxembourg",
     "Region": "Western Europe",
     "Province": "Grevenmacher"
    },
    {
     "Country": "Luxembourg",
     "Region": "Western Europe",
     "Province": "Echternach"
    },
    {
     "Country": "Luxembourg",
     "Region": "Western Europe",
     "Province": "Remich"
    },
    {
     "Country": "Luxembourg",
     "Region": "Western Europe",
     "Province": "Luxembourg"
    },
    {
     "Country": "Luxembourg",
     "Region": "Western Europe",
     "Province": "Capellen"
    },
    {
     "Country": "Luxembourg",
     "Region": "Western Europe",
     "Province": "Esch-sur-Alzette"
    },
    {
     "Country": "Luxembourg",
     "Region": "Western Europe",
     "Province": "Mersch"
    },
    {
     "Country": "Macau",
     "Region": "Eastern Asia",
     "Province": "Parish"
    },
    {
     "Country": "Macau",
     "Region": "Eastern Asia",
     "Province": "Nossa Senhora de Fátima"
    },
    {
     "Country": "Macau",
     "Region": "Eastern Asia",
     "Province": "Santo António"
    },
    {
     "Country": "Macau",
     "Region": "Eastern Asia",
     "Province": "São Lázaro"
    },
    {
     "Country": "Macau",
     "Region": "Eastern Asia",
     "Province": "São Lourenço"
    },
    {
     "Country": "Macau",
     "Region": "Eastern Asia",
     "Province": "Sé"
    },
    {
     "Country": "Macau",
     "Region": "Eastern Asia",
     "Province": "Nossa Senhora do Carmo"
    },
    {
     "Country": "Macau",
     "Region": "Eastern Asia",
     "Province": "São Francisco Xavier"
    },
    {
     "Country": "Macau",
     "Region": "Eastern Asia",
     "Province": "Zona do Aterro de Cotai"
    },
    {
     "Country": "Macau",
     "Region": "Eastern Asia",
     "Province": "Universidade de Macau"
    },
    {
     "Country": "Macau",
     "Region": "Eastern Asia",
     "Province": "Novos Aterros Urbanos de Macau"
    },
    {
     "Country": "Macau",
     "Region": "Eastern Asia",
     "Province": "Zona de Administração de Macau na Ilha Fronteiriça Artificial da Ponte Hong Kong–Zhuhai–Macau"
    },
    {
     "Country": "Macau",
     "Region": "Eastern Asia",
     "Province": "(the southern part of the reclaimed island at the western end of the Hong Kong–Zhuhai–Macau Bridge)"
    },
    {
     "Country": "Madagascar",
     "Region": "Eastern Africa",
     "Province": " Antananarivo "
    },
    {
     "Country": "Madagascar",
     "Region": "Eastern Africa",
     "Province": " Antsiranana "
    },
    {
     "Country": "Madagascar",
     "Region": "Eastern Africa",
     "Province": " Fianarantsoa "
    },
    {
     "Country": "Madagascar",
     "Region": "Eastern Africa",
     "Province": " Mahajanga "
    },
    {
     "Country": "Madagascar",
     "Region": "Eastern Africa",
     "Province": " Toamasina "
    },
    {
     "Country": "Madagascar",
     "Region": "Eastern Africa",
     "Province": " Toliara "
    },
    {
     "Country": "Malawi",
     "Region": "Eastern Africa",
     "Province": "Ailinglaplap Atoll"
    },
    {
     "Country": "Malawi",
     "Region": "Eastern Africa",
     "Province": "Ailuk Atoll"
    },
    {
     "Country": "Malawi",
     "Region": "Eastern Africa",
     "Province": "Arno Atoll"
    },
    {
     "Country": "Malawi",
     "Region": "Eastern Africa",
     "Province": "Aur Atoll"
    },
    {
     "Country": "Malawi",
     "Region": "Eastern Africa",
     "Province": "Ebon Atoll"
    },
    {
     "Country": "Malawi",
     "Region": "Eastern Africa",
     "Province": "Enewetok \/ Ujelang"
    },
    {
     "Country": "Malawi",
     "Region": "Eastern Africa",
     "Province": "Jabat Island"
    },
    {
     "Country": "Malawi",
     "Region": "Eastern Africa",
     "Province": "Jaluit Atoll"
    },
    {
     "Country": "Malawi",
     "Region": "Eastern Africa",
     "Province": "Kili \/ Bikini \/ Ejit"
    },
    {
     "Country": "Malawi",
     "Region": "Eastern Africa",
     "Province": "Kwajalein Atoll"
    },
    {
     "Country": "Malawi",
     "Region": "Eastern Africa",
     "Province": "Lae Atoll"
    },
    {
     "Country": "Malawi",
     "Region": "Eastern Africa",
     "Province": "Lib Island"
    },
    {
     "Country": "Malawi",
     "Region": "Eastern Africa",
     "Province": "Likiep Atoll"
    },
    {
     "Country": "Malawi",
     "Region": "Eastern Africa",
     "Province": "Majuro (capital)"
    },
    {
     "Country": "Malawi",
     "Region": "Eastern Africa",
     "Province": "Maloelap Atoll"
    },
    {
     "Country": "Malawi",
     "Region": "Eastern Africa",
     "Province": "Mejit Island"
    },
    {
     "Country": "Malawi",
     "Region": "Eastern Africa",
     "Province": "Mili Atoll"
    },
    {
     "Country": "Malawi",
     "Region": "Eastern Africa",
     "Province": "Namorik Atoll"
    },
    {
     "Country": "Malawi",
     "Region": "Eastern Africa",
     "Province": "Namu Atoll"
    },
    {
     "Country": "Malawi",
     "Region": "Eastern Africa",
     "Province": "Rongelap Atoll"
    },
    {
     "Country": "Malawi",
     "Region": "Eastern Africa",
     "Province": "Ujae Atoll"
    },
    {
     "Country": "Malawi",
     "Region": "Eastern Africa",
     "Province": "Utirik Atoll"
    },
    {
     "Country": "Malawi",
     "Region": "Eastern Africa",
     "Province": "Wotho Atoll"
    },
    {
     "Country": "Malawi",
     "Region": "Eastern Africa",
     "Province": "Wotje Atoll"
    },
    {
     "Country": "Malaysia",
     "Region": "Southeast Asia",
     "Province": "Johor"
    },
    {
     "Country": "Malaysia",
     "Region": "Southeast Asia",
     "Province": "Kedah"
    },
    {
     "Country": "Malaysia",
     "Region": "Southeast Asia",
     "Province": "Kelantan"
    },
    {
     "Country": "Malaysia",
     "Region": "Southeast Asia",
     "Province": "Malacca"
    },
    {
     "Country": "Malaysia",
     "Region": "Southeast Asia",
     "Province": "Negeri Sembilan"
    },
    {
     "Country": "Malaysia",
     "Region": "Southeast Asia",
     "Province": "Pahang"
    },
    {
     "Country": "Malaysia",
     "Region": "Southeast Asia",
     "Province": "Penang"
    },
    {
     "Country": "Malaysia",
     "Region": "Southeast Asia",
     "Province": "Perak"
    },
    {
     "Country": "Malaysia",
     "Region": "Southeast Asia",
     "Province": "Perlis"
    },
    {
     "Country": "Malaysia",
     "Region": "Southeast Asia",
     "Province": "Sabah"
    },
    {
     "Country": "Malaysia",
     "Region": "Southeast Asia",
     "Province": "Sarawak"
    },
    {
     "Country": "Malaysia",
     "Region": "Southeast Asia",
     "Province": "Selangor"
    },
    {
     "Country": "Malaysia",
     "Region": "Southeast Asia",
     "Province": "Terengganu"
    },
    {
     "Country": "Maldives",
     "Region": "South-Central Asia",
     "Province": "Malé City"
    },
    {
     "Country": "Maldives",
     "Region": "South-Central Asia",
     "Province": "Fuvahmulah City"
    },
    {
     "Country": "Maldives",
     "Region": "South-Central Asia",
     "Province": "Addu City"
    },
    {
     "Country": "Maldives",
     "Region": "South-Central Asia",
     "Province": "Kulhudhuffushi City"
    },
    {
     "Country": "Maldives",
     "Region": "South-Central Asia",
     "Province": "Thiladhunmathi Uthuruburi"
    },
    {
     "Country": "Maldives",
     "Region": "South-Central Asia",
     "Province": "Miladhunmadulu Uthuruburi"
    },
    {
     "Country": "Maldives",
     "Region": "South-Central Asia",
     "Province": "Miladhunmadulu Dhekunuburi"
    },
    {
     "Country": "Maldives",
     "Region": "South-Central Asia",
     "Province": "Maalhosmadulu Uthuruburi"
    },
    {
     "Country": "Maldives",
     "Region": "South-Central Asia",
     "Province": "Maalhosmadulu Dhekunuburi"
    },
    {
     "Country": "Maldives",
     "Region": "South-Central Asia",
     "Province": "Faadhippolhu"
    },
    {
     "Country": "Maldives",
     "Region": "South-Central Asia",
     "Province": "Malé Atholhu"
    },
    {
     "Country": "Maldives",
     "Region": "South-Central Asia",
     "Province": "Ari Atholhu Uthuruburi"
    },
    {
     "Country": "Maldives",
     "Region": "South-Central Asia",
     "Province": "Ari Atholhu Dhekunuburi"
    },
    {
     "Country": "Maldives",
     "Region": "South-Central Asia",
     "Province": "Felidhu Atholhu"
    },
    {
     "Country": "Maldives",
     "Region": "South-Central Asia",
     "Province": "Mulak Atholhu"
    },
    {
     "Country": "Maldives",
     "Region": "South-Central Asia",
     "Province": "Nilandhe Atholhu Uthuruburi"
    },
    {
     "Country": "Maldives",
     "Region": "South-Central Asia",
     "Province": "Nilandhe Atholhu Dhekunuburi"
    },
    {
     "Country": "Maldives",
     "Region": "South-Central Asia",
     "Province": "Kolhumadulu"
    },
    {
     "Country": "Maldives",
     "Region": "South-Central Asia",
     "Province": "Haddhunmathi"
    },
    {
     "Country": "Maldives",
     "Region": "South-Central Asia",
     "Province": "Huvadhu Atholhu Uthuruburi"
    },
    {
     "Country": "Maldives",
     "Region": "South-Central Asia",
     "Province": "Huvadhu Atholhu Dhekunuburi"
    },
    {
     "Country": "Mali",
     "Region": "West Africa",
     "Province": "Kayes"
    },
    {
     "Country": "Mali",
     "Region": "West Africa",
     "Province": "Koulikoro"
    },
    {
     "Country": "Mali",
     "Region": "West Africa",
     "Province": "Bamako"
    },
    {
     "Country": "Mali",
     "Region": "West Africa",
     "Province": "Sikasso"
    },
    {
     "Country": "Mali",
     "Region": "West Africa",
     "Province": "Ségou"
    },
    {
     "Country": "Mali",
     "Region": "West Africa",
     "Province": "Mopti"
    },
    {
     "Country": "Mali",
     "Region": "West Africa",
     "Province": "Tombouctou"
    },
    {
     "Country": "Mali",
     "Region": "West Africa",
     "Province": "Gao"
    },
    {
     "Country": "Mali",
     "Region": "West Africa",
     "Province": "Kidal"
    },
    {
     "Country": "Mali",
     "Region": "West Africa",
     "Province": "Taoudénit"
    },
    {
     "Country": "Mali",
     "Region": "West Africa",
     "Province": "Ménaka"
    },
    {
     "Country": "Malta",
     "Region": "Southern Europe",
     "Province": "San Ġwann (not part of the region)"
    },
    {
     "Country": "Malta",
     "Region": "Southern Europe",
     "Province": "Victoria"
    },
    {
     "Country": "Malta",
     "Region": "Southern Europe",
     "Province": "St. Paul's Bay"
    },
    {
     "Country": "Malta",
     "Region": "Southern Europe",
     "Province": "Tarxien"
    },
    {
     "Country": "Malta",
     "Region": "Southern Europe",
     "Province": "Qormi"
    },
    {
     "Country": "Malta",
     "Region": "Southern Europe",
     "Province": "Rabat"
    },
    {
     "Country": "Marshall Islands",
     "Region": "Micronesia, Oceania",
     "Province": "Ailinglaplap Atoll"
    },
    {
     "Country": "Marshall Islands",
     "Region": "Micronesia, Oceania",
     "Province": "Ailuk Atoll"
    },
    {
     "Country": "Marshall Islands",
     "Region": "Micronesia, Oceania",
     "Province": "Arno Atoll"
    },
    {
     "Country": "Marshall Islands",
     "Region": "Micronesia, Oceania",
     "Province": "Aur Atoll"
    },
    {
     "Country": "Marshall Islands",
     "Region": "Micronesia, Oceania",
     "Province": "Ebon Atoll"
    },
    {
     "Country": "Marshall Islands",
     "Region": "Micronesia, Oceania",
     "Province": "Enewetok \/ Ujelang"
    },
    {
     "Country": "Marshall Islands",
     "Region": "Micronesia, Oceania",
     "Province": "Jabat Island"
    },
    {
     "Country": "Marshall Islands",
     "Region": "Micronesia, Oceania",
     "Province": "Jaluit Atoll"
    },
    {
     "Country": "Marshall Islands",
     "Region": "Micronesia, Oceania",
     "Province": "Kili \/ Bikini \/ Ejit"
    },
    {
     "Country": "Marshall Islands",
     "Region": "Micronesia, Oceania",
     "Province": "Kwajalein Atoll"
    },
    {
     "Country": "Marshall Islands",
     "Region": "Micronesia, Oceania",
     "Province": "Lae Atoll"
    },
    {
     "Country": "Marshall Islands",
     "Region": "Micronesia, Oceania",
     "Province": "Lib Island"
    },
    {
     "Country": "Marshall Islands",
     "Region": "Micronesia, Oceania",
     "Province": "Likiep Atoll"
    },
    {
     "Country": "Marshall Islands",
     "Region": "Micronesia, Oceania",
     "Province": "Majuro (capital)"
    },
    {
     "Country": "Marshall Islands",
     "Region": "Micronesia, Oceania",
     "Province": "Maloelap Atoll"
    },
    {
     "Country": "Marshall Islands",
     "Region": "Micronesia, Oceania",
     "Province": "Mejit Island"
    },
    {
     "Country": "Marshall Islands",
     "Region": "Micronesia, Oceania",
     "Province": "Mili Atoll"
    },
    {
     "Country": "Marshall Islands",
     "Region": "Micronesia, Oceania",
     "Province": "Namorik Atoll"
    },
    {
     "Country": "Marshall Islands",
     "Region": "Micronesia, Oceania",
     "Province": "Namu Atoll"
    },
    {
     "Country": "Marshall Islands",
     "Region": "Micronesia, Oceania",
     "Province": "Rongelap Atoll"
    },
    {
     "Country": "Marshall Islands",
     "Region": "Micronesia, Oceania",
     "Province": "Ujae Atoll"
    },
    {
     "Country": "Marshall Islands",
     "Region": "Micronesia, Oceania",
     "Province": "Utirik Atoll"
    },
    {
     "Country": "Marshall Islands",
     "Region": "Micronesia, Oceania",
     "Province": "Wotho Atoll"
    },
    {
     "Country": "Marshall Islands",
     "Region": "Micronesia, Oceania",
     "Province": "Wotje Atoll"
    },
    {
     "Country": "Martinique",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "L'Ajoupa-Bouillon"
    },
    {
     "Country": "Martinique",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Les Anses-d'Arlet"
    },
    {
     "Country": "Martinique",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Basse-Pointe"
    },
    {
     "Country": "Martinique",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Bellefontaine"
    },
    {
     "Country": "Martinique",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Le Carbet"
    },
    {
     "Country": "Martinique",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Case-Pilote"
    },
    {
     "Country": "Martinique",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Le Diamant"
    },
    {
     "Country": "Martinique",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Ducos"
    },
    {
     "Country": "Martinique",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Fonds-Saint-Denis"
    },
    {
     "Country": "Martinique",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Fort-de-France"
    },
    {
     "Country": "Martinique",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Le François"
    },
    {
     "Country": "Martinique",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Grand'Rivière"
    },
    {
     "Country": "Martinique",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Gros-Morne"
    },
    {
     "Country": "Martinique",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Le Lamentin"
    },
    {
     "Country": "Martinique",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Le Lorrain"
    },
    {
     "Country": "Martinique",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Macouba"
    },
    {
     "Country": "Martinique",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Le Marigot"
    },
    {
     "Country": "Martinique",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Le Marin"
    },
    {
     "Country": "Martinique",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Le Morne-Rouge"
    },
    {
     "Country": "Martinique",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Le Morne-Vert"
    },
    {
     "Country": "Martinique",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Le Prêcheur"
    },
    {
     "Country": "Martinique",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Rivière-Pilote"
    },
    {
     "Country": "Martinique",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Rivière-Salée"
    },
    {
     "Country": "Martinique",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Le Robert"
    },
    {
     "Country": "Martinique",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Saint-Esprit"
    },
    {
     "Country": "Martinique",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Saint-Joseph"
    },
    {
     "Country": "Martinique",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Saint-Pierre"
    },
    {
     "Country": "Martinique",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Sainte-Anne"
    },
    {
     "Country": "Martinique",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Sainte-Luce"
    },
    {
     "Country": "Martinique",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Sainte-Marie"
    },
    {
     "Country": "Martinique",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Schœlcher"
    },
    {
     "Country": "Martinique",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "La Trinité"
    },
    {
     "Country": "Martinique",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Les Trois-Îlets"
    },
    {
     "Country": "Martinique",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Le Vauclin"
    },
    {
     "Country": "Mauritania",
     "Region": "West Africa",
     "Province": "Adrar"
    },
    {
     "Country": "Mauritania",
     "Region": "West Africa",
     "Province": "Assaba"
    },
    {
     "Country": "Mauritania",
     "Region": "West Africa",
     "Province": "Brakna"
    },
    {
     "Country": "Mauritania",
     "Region": "West Africa",
     "Province": "Dakhlet Nouadhibou"
    },
    {
     "Country": "Mauritania",
     "Region": "West Africa",
     "Province": "Gorgol"
    },
    {
     "Country": "Mauritania",
     "Region": "West Africa",
     "Province": "Guidimaka"
    },
    {
     "Country": "Mauritania",
     "Region": "West Africa",
     "Province": "Hodh Ech Chargui"
    },
    {
     "Country": "Mauritania",
     "Region": "West Africa",
     "Province": "Hodh El Gharbi"
    },
    {
     "Country": "Mauritania",
     "Region": "West Africa",
     "Province": "Inchiri"
    },
    {
     "Country": "Mauritania",
     "Region": "West Africa",
     "Province": "Nouakchott-Nord"
    },
    {
     "Country": "Mauritania",
     "Region": "West Africa",
     "Province": "Nouakchott-Ouest"
    },
    {
     "Country": "Mauritania",
     "Region": "West Africa",
     "Province": "Nouakchott-Sud"
    },
    {
     "Country": "Mauritania",
     "Region": "West Africa",
     "Province": "Tagant"
    },
    {
     "Country": "Mauritania",
     "Region": "West Africa",
     "Province": "Tiris Zemmour"
    },
    {
     "Country": "Mauritania",
     "Region": "West Africa",
     "Province": "Trarza"
    },
    {
     "Country": "Mauritius",
     "Region": "Eastern Africa",
     "Province": "Flacq"
    },
    {
     "Country": "Mauritius",
     "Region": "Eastern Africa",
     "Province": "Grand Port"
    },
    {
     "Country": "Mauritius",
     "Region": "Eastern Africa",
     "Province": "Moka"
    },
    {
     "Country": "Mauritius",
     "Region": "Eastern Africa",
     "Province": "Pamplemousses"
    },
    {
     "Country": "Mauritius",
     "Region": "Eastern Africa",
     "Province": "Plaines Wilhems"
    },
    {
     "Country": "Mauritius",
     "Region": "Eastern Africa",
     "Province": "Port Louis"
    },
    {
     "Country": "Mauritius",
     "Region": "Eastern Africa",
     "Province": "Rivière du Rempart"
    },
    {
     "Country": "Mauritius",
     "Region": "Eastern Africa",
     "Province": "Rivière Noire"
    },
    {
     "Country": "Mauritius",
     "Region": "Eastern Africa",
     "Province": "Savanne"
    },
    {
     "Country": "Mayotte",
     "Region": "Eastern Africa",
     "Province": "Dzaoudzi"
    },
    {
     "Country": "Mayotte",
     "Region": "Eastern Africa",
     "Province": "Pamandzi"
    },
    {
     "Country": "Mayotte",
     "Region": "Eastern Africa",
     "Province": "Mamoudzou"
    },
    {
     "Country": "Mayotte",
     "Region": "Eastern Africa",
     "Province": "Dembeni"
    },
    {
     "Country": "Mayotte",
     "Region": "Eastern Africa",
     "Province": "Bandrélé"
    },
    {
     "Country": "Mayotte",
     "Region": "Eastern Africa",
     "Province": "Kani-Kéli"
    },
    {
     "Country": "Mayotte",
     "Region": "Eastern Africa",
     "Province": "Bouéni"
    },
    {
     "Country": "Mayotte",
     "Region": "Eastern Africa",
     "Province": "Chirongui"
    },
    {
     "Country": "Mayotte",
     "Region": "Eastern Africa",
     "Province": "Sada"
    },
    {
     "Country": "Mayotte",
     "Region": "Eastern Africa",
     "Province": "Ouangani"
    },
    {
     "Country": "Mayotte",
     "Region": "Eastern Africa",
     "Province": "Chiconi"
    },
    {
     "Country": "Mayotte",
     "Region": "Eastern Africa",
     "Province": "Tsingoni"
    },
    {
     "Country": "Mayotte",
     "Region": "Eastern Africa",
     "Province": "M'Tsangamouji"
    },
    {
     "Country": "Mayotte",
     "Region": "Eastern Africa",
     "Province": "Acoua"
    },
    {
     "Country": "Mayotte",
     "Region": "Eastern Africa",
     "Province": "Mtsamboro"
    },
    {
     "Country": "Mayotte",
     "Region": "Eastern Africa",
     "Province": "Bandraboua"
    },
    {
     "Country": "Mayotte",
     "Region": "Eastern Africa",
     "Province": "Koungou"
    },
    {
     "Country": "Mexico",
     "Region": "North America",
     "Province": "Aguascalientes"
    },
    {
     "Country": "Mexico",
     "Region": "North America",
     "Province": "Baja California"
    },
    {
     "Country": "Mexico",
     "Region": "North America",
     "Province": "Baja California Sur"
    },
    {
     "Country": "Mexico",
     "Region": "North America",
     "Province": "Campeche"
    },
    {
     "Country": "Mexico",
     "Region": "North America",
     "Province": "Chiapas"
    },
    {
     "Country": "Mexico",
     "Region": "North America",
     "Province": "Chihuahua"
    },
    {
     "Country": "Mexico",
     "Region": "North America",
     "Province": "Coahuila"
    },
    {
     "Country": "Mexico",
     "Region": "North America",
     "Province": "Colima"
    },
    {
     "Country": "Mexico",
     "Region": "North America",
     "Province": "Durango"
    },
    {
     "Country": "Mexico",
     "Region": "North America",
     "Province": "Guanajuato"
    },
    {
     "Country": "Mexico",
     "Region": "North America",
     "Province": "Guerrero"
    },
    {
     "Country": "Mexico",
     "Region": "North America",
     "Province": "Hidalgo"
    },
    {
     "Country": "Mexico",
     "Region": "North America",
     "Province": "Jalisco"
    },
    {
     "Country": "Mexico",
     "Region": "North America",
     "Province": "México"
    },
    {
     "Country": "Mexico",
     "Region": "North America",
     "Province": "Mexico City"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Eot"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Ettal"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Fananu"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Fanapanges"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Fefen"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Fono"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Houk"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Kutu"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Losap"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Lukunoch"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Makur"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Moch"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Murilo"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Namoluk"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Nema"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Nomwin"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Oneop"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Onou"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Onoun"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Paata"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Parem"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Piherarh"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Piis-emmwar"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Piherarh"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Pollap"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Polle"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Polowat"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Ramanum"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Ruo"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Satawan"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Tsis"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Ta"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Tamatam"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Tol"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Tonoas"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Udot"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Uman"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Unanu"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Weno (Capital of Chuuk State)"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Wonei"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Total"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Kosrae"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Kosrae - Lelu"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Kapingamarangi"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Mwoakilloa"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Nukuoro"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Pingelap"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Pohnpei"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Sapwuahfik"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Eauripik"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Elato"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Fais"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Faraulap"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Ifalik"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Lamotrek"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Ngulu"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Satawal"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Ulithi"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Woleai"
    },
    {
     "Country": "Micronesia, Federal States of",
     "Region": "Micronesia, Oceania",
     "Province": "Yap"
    },
    {
     "Country": "Moldova, Republic of",
     "Region": "Eastern Europe",
     "Province": " Anenii Noi"
    },
    {
     "Country": "Moldova, Republic of",
     "Region": "Eastern Europe",
     "Province": " Basarabeasca"
    },
    {
     "Country": "Moldova, Republic of",
     "Region": "Eastern Europe",
     "Province": " Briceni"
    },
    {
     "Country": "Moldova, Republic of",
     "Region": "Eastern Europe",
     "Province": " Cahul"
    },
    {
     "Country": "Moldova, Republic of",
     "Region": "Eastern Europe",
     "Province": " Cantemir"
    },
    {
     "Country": "Moldova, Republic of",
     "Region": "Eastern Europe",
     "Province": " Călărași"
    },
    {
     "Country": "Moldova, Republic of",
     "Region": "Eastern Europe",
     "Province": " Căușeni"
    },
    {
     "Country": "Moldova, Republic of",
     "Region": "Eastern Europe",
     "Province": " Cimișlia"
    },
    {
     "Country": "Moldova, Republic of",
     "Region": "Eastern Europe",
     "Province": " Criuleni"
    },
    {
     "Country": "Moldova, Republic of",
     "Region": "Eastern Europe",
     "Province": " Dondușeni"
    },
    {
     "Country": "Moldova, Republic of",
     "Region": "Eastern Europe",
     "Province": " Drochia"
    },
    {
     "Country": "Moldova, Republic of",
     "Region": "Eastern Europe",
     "Province": " Dubăsari"
    },
    {
     "Country": "Moldova, Republic of",
     "Region": "Eastern Europe",
     "Province": " Edineț"
    },
    {
     "Country": "Moldova, Republic of",
     "Region": "Eastern Europe",
     "Province": " Fălești"
    },
    {
     "Country": "Moldova, Republic of",
     "Region": "Eastern Europe",
     "Province": " Florești"
    },
    {
     "Country": "Moldova, Republic of",
     "Region": "Eastern Europe",
     "Province": " Glodeni"
    },
    {
     "Country": "Moldova, Republic of",
     "Region": "Eastern Europe",
     "Province": " Hîncești"
    },
    {
     "Country": "Moldova, Republic of",
     "Region": "Eastern Europe",
     "Province": " Ialoveni"
    },
    {
     "Country": "Moldova, Republic of",
     "Region": "Eastern Europe",
     "Province": " Leova"
    },
    {
     "Country": "Moldova, Republic of",
     "Region": "Eastern Europe",
     "Province": " Nisporeni"
    },
    {
     "Country": "Moldova, Republic of",
     "Region": "Eastern Europe",
     "Province": " Ocnița"
    },
    {
     "Country": "Moldova, Republic of",
     "Region": "Eastern Europe",
     "Province": " Orhei"
    },
    {
     "Country": "Moldova, Republic of",
     "Region": "Eastern Europe",
     "Province": " Rezina"
    },
    {
     "Country": "Moldova, Republic of",
     "Region": "Eastern Europe",
     "Province": " Rîșcani"
    },
    {
     "Country": "Moldova, Republic of",
     "Region": "Eastern Europe",
     "Province": " Sîngerei"
    },
    {
     "Country": "Moldova, Republic of",
     "Region": "Eastern Europe",
     "Province": " Soroca"
    },
    {
     "Country": "Moldova, Republic of",
     "Region": "Eastern Europe",
     "Province": " Strășeni"
    },
    {
     "Country": "Moldova, Republic of",
     "Region": "Eastern Europe",
     "Province": " Șoldănești"
    },
    {
     "Country": "Moldova, Republic of",
     "Region": "Eastern Europe",
     "Province": " Ștefan Vodă"
    },
    {
     "Country": "Moldova, Republic of",
     "Region": "Eastern Europe",
     "Province": " Taraclia"
    },
    {
     "Country": "Moldova, Republic of",
     "Region": "Eastern Europe",
     "Province": " Telenești"
    },
    {
     "Country": "Moldova, Republic of",
     "Region": "Eastern Europe",
     "Province": " Ungheni"
    },
    {
     "Country": "Monaco",
     "Region": "Southern Europe",
     "Province": "Monaco-Ville"
    },
    {
     "Country": "Monaco",
     "Region": "Southern Europe",
     "Province": "La Condamine"
    },
    {
     "Country": "Monaco",
     "Region": "Southern Europe",
     "Province": "Fontvieille"
    },
    {
     "Country": "Monaco",
     "Region": "Southern Europe",
     "Province": "Larvotto"
    },
    {
     "Country": "Monaco",
     "Region": "Southern Europe",
     "Province": "Jardin Exotique"
    },
    {
     "Country": "Monaco",
     "Region": "Southern Europe",
     "Province": "Les Moneghetti"
    },
    {
     "Country": "Monaco",
     "Region": "Southern Europe",
     "Province": "Monte-Carlo"
    },
    {
     "Country": "Monaco",
     "Region": "Southern Europe",
     "Province": "La Rousse"
    },
    {
     "Country": "Mongolia",
     "Region": "Eastern Asia",
     "Province": " Arkhangai"
    },
    {
     "Country": "Mongolia",
     "Region": "Eastern Asia",
     "Province": " Bayankhongor"
    },
    {
     "Country": "Mongolia",
     "Region": "Eastern Asia",
     "Province": " Bayan-Ölgii"
    },
    {
     "Country": "Mongolia",
     "Region": "Eastern Asia",
     "Province": " Bulgan"
    },
    {
     "Country": "Mongolia",
     "Region": "Eastern Asia",
     "Province": " Darkhan-Uul"
    },
    {
     "Country": "Mongolia",
     "Region": "Eastern Asia",
     "Province": " Dornod"
    },
    {
     "Country": "Mongolia",
     "Region": "Eastern Asia",
     "Province": " Dornogovi"
    },
    {
     "Country": "Mongolia",
     "Region": "Eastern Asia",
     "Province": " Dundgobi"
    },
    {
     "Country": "Mongolia",
     "Region": "Eastern Asia",
     "Province": " Govi-Altai"
    },
    {
     "Country": "Mongolia",
     "Region": "Eastern Asia",
     "Province": " Govisümber"
    },
    {
     "Country": "Mongolia",
     "Region": "Eastern Asia",
     "Province": " Khentii"
    },
    {
     "Country": "Mongolia",
     "Region": "Eastern Asia",
     "Province": " Khovd"
    },
    {
     "Country": "Mongolia",
     "Region": "Eastern Asia",
     "Province": " Khövsgöl"
    },
    {
     "Country": "Mongolia",
     "Region": "Eastern Asia",
     "Province": " Orkhon"
    },
    {
     "Country": "Mongolia",
     "Region": "Eastern Asia",
     "Province": " Ömnögovi"
    },
    {
     "Country": "Mongolia",
     "Region": "Eastern Asia",
     "Province": " Övörkhangai"
    },
    {
     "Country": "Mongolia",
     "Region": "Eastern Asia",
     "Province": " Selenge"
    },
    {
     "Country": "Mongolia",
     "Region": "Eastern Asia",
     "Province": " Sükhbaatar"
    },
    {
     "Country": "Mongolia",
     "Region": "Eastern Asia",
     "Province": " Töv"
    },
    {
     "Country": "Mongolia",
     "Region": "Eastern Asia",
     "Province": " Uvs"
    },
    {
     "Country": "Mongolia",
     "Region": "Eastern Asia",
     "Province": " Zavkhan"
    },
    {
     "Country": "Mongolia",
     "Region": "Eastern Asia",
     "Province": " Ulaanbaatar"
    },
    {
     "Country": "Montenegro",
     "Region": "Southern Europe",
     "Province": "Andrijevica"
    },
    {
     "Country": "Montenegro",
     "Region": "Southern Europe",
     "Province": "Bar"
    },
    {
     "Country": "Montenegro",
     "Region": "Southern Europe",
     "Province": "Berane"
    },
    {
     "Country": "Montenegro",
     "Region": "Southern Europe",
     "Province": "Bijelo Polje"
    },
    {
     "Country": "Montenegro",
     "Region": "Southern Europe",
     "Province": "Budva"
    },
    {
     "Country": "Montenegro",
     "Region": "Southern Europe",
     "Province": "Cetinje"
    },
    {
     "Country": "Montenegro",
     "Region": "Southern Europe",
     "Province": "Danilovgrad"
    },
    {
     "Country": "Montenegro",
     "Region": "Southern Europe",
     "Province": "Gusinje"
    },
    {
     "Country": "Montenegro",
     "Region": "Southern Europe",
     "Province": "Herceg Novi"
    },
    {
     "Country": "Montenegro",
     "Region": "Southern Europe",
     "Province": "Kolašin"
    },
    {
     "Country": "Montenegro",
     "Region": "Southern Europe",
     "Province": "Kotor"
    },
    {
     "Country": "Montenegro",
     "Region": "Southern Europe",
     "Province": "Mojkovac"
    },
    {
     "Country": "Montenegro",
     "Region": "Southern Europe",
     "Province": "Nikšić"
    },
    {
     "Country": "Montenegro",
     "Region": "Southern Europe",
     "Province": "Petnjica"
    },
    {
     "Country": "Montenegro",
     "Region": "Southern Europe",
     "Province": "Plav"
    },
    {
     "Country": "Montenegro",
     "Region": "Southern Europe",
     "Province": "Pljevlja"
    },
    {
     "Country": "Montenegro",
     "Region": "Southern Europe",
     "Province": "Plužine"
    },
    {
     "Country": "Montenegro",
     "Region": "Southern Europe",
     "Province": "Podgorica"
    },
    {
     "Country": "Montenegro",
     "Region": "Southern Europe",
     "Province": "Rožaje"
    },
    {
     "Country": "Montenegro",
     "Region": "Southern Europe",
     "Province": "Šavnik"
    },
    {
     "Country": "Montenegro",
     "Region": "Southern Europe",
     "Province": "Tivat"
    },
    {
     "Country": "Montenegro",
     "Region": "Southern Europe",
     "Province": "Tuzi"
    },
    {
     "Country": "Montenegro",
     "Region": "Southern Europe",
     "Province": "Ulcinj"
    },
    {
     "Country": "Montenegro",
     "Region": "Southern Europe",
     "Province": "Žabljak"
    },
    {
     "Country": "Montenegro",
     "Region": "Southern Europe",
     "Province": "Zeta"
    },
    {
     "Country": "Montserrat",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Baker Hill"
    },
    {
     "Country": "Montserrat",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Banks"
    },
    {
     "Country": "Montserrat",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Barzeys"
    },
    {
     "Country": "Montserrat",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Blakes"
    },
    {
     "Country": "Montserrat",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Brades"
    },
    {
     "Country": "Montserrat",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Carr's Bay"
    },
    {
     "Country": "Montserrat",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Cavalla Hill"
    },
    {
     "Country": "Montserrat",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Cheap End"
    },
    {
     "Country": "Montserrat",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Cudjoe Head"
    },
    {
     "Country": "Montserrat",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Davy Hill"
    },
    {
     "Country": "Montserrat",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Dick Hill"
    },
    {
     "Country": "Montserrat",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Drummonds"
    },
    {
     "Country": "Montserrat",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Flemmings"
    },
    {
     "Country": "Montserrat",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Fogarty"
    },
    {
     "Country": "Montserrat",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Frith"
    },
    {
     "Country": "Montserrat",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Garibaldi Hill"
    },
    {
     "Country": "Montserrat",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Gerald's"
    },
    {
     "Country": "Montserrat",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Hope"
    },
    {
     "Country": "Montserrat",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Jack Boy Hill"
    },
    {
     "Country": "Montserrat",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Judy Piece"
    },
    {
     "Country": "Montserrat",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Katy Hill"
    },
    {
     "Country": "Montserrat",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Lawyers Mountain"
    },
    {
     "Country": "Montserrat",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Little Bay"
    },
    {
     "Country": "Montserrat",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Lookout"
    },
    {
     "Country": "Montserrat",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Manjack"
    },
    {
     "Country": "Montserrat",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Mongo Hill"
    },
    {
     "Country": "Montserrat",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "New Windward Estate"
    },
    {
     "Country": "Montserrat",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Nixons"
    },
    {
     "Country": "Montserrat",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Old Towne"
    },
    {
     "Country": "Montserrat",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Olveston"
    },
    {
     "Country": "Montserrat",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Peaceful Cottage"
    },
    {
     "Country": "Montserrat",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Salem"
    },
    {
     "Country": "Montserrat",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Shinlands"
    },
    {
     "Country": "Montserrat",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "St. John's"
    },
    {
     "Country": "Montserrat",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "St. Peter's"
    },
    {
     "Country": "Montserrat",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Sweeney's"
    },
    {
     "Country": "Montserrat",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Woodlands"
    },
    {
     "Country": "Montserrat",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Yellow Hill"
    },
    {
     "Country": "Morocco",
     "Region": "Northern Africa",
     "Province": "Tanger-Tétouan-Al Hoceïma"
    },
    {
     "Country": "Morocco",
     "Region": "Northern Africa",
     "Province": "L'Oriental"
    },
    {
     "Country": "Morocco",
     "Region": "Northern Africa",
     "Province": "Fès-Meknès"
    },
    {
     "Country": "Morocco",
     "Region": "Northern Africa",
     "Province": " Rabat-Salé-Kénitra"
    },
    {
     "Country": "Morocco",
     "Region": "Northern Africa",
     "Province": " Béni Mellal-Khénifra"
    },
    {
     "Country": "Morocco",
     "Region": "Northern Africa",
     "Province": "Casablanca-Settat"
    },
    {
     "Country": "Morocco",
     "Region": "Northern Africa",
     "Province": " Marrakech-Safi"
    },
    {
     "Country": "Morocco",
     "Region": "Northern Africa",
     "Province": "Drâa-Tafilalet"
    },
    {
     "Country": "Morocco",
     "Region": "Northern Africa",
     "Province": " Souss-Massa"
    },
    {
     "Country": "Morocco",
     "Region": "Northern Africa",
     "Province": "Guelmim-Oued Noun"
    },
    {
     "Country": "Morocco",
     "Region": "Northern Africa",
     "Province": " Laâyoune-Sakia El Hamra"
    },
    {
     "Country": "Morocco",
     "Region": "Northern Africa",
     "Province": "Dakhla-Oued Ed-Dahab"
    },
    {
     "Country": "Mozambique",
     "Region": "Eastern Africa",
     "Province": "Cabo Delgado"
    },
    {
     "Country": "Mozambique",
     "Region": "Eastern Africa",
     "Province": "Gaza"
    },
    {
     "Country": "Mozambique",
     "Region": "Eastern Africa",
     "Province": "Inhambane"
    },
    {
     "Country": "Mozambique",
     "Region": "Eastern Africa",
     "Province": "Manica"
    },
    {
     "Country": "Mozambique",
     "Region": "Eastern Africa",
     "Province": "Maputo City"
    },
    {
     "Country": "Mozambique",
     "Region": "Eastern Africa",
     "Province": "Maputo"
    },
    {
     "Country": "Mozambique",
     "Region": "Eastern Africa",
     "Province": "Nampula"
    },
    {
     "Country": "Mozambique",
     "Region": "Eastern Africa",
     "Province": "Niassa"
    },
    {
     "Country": "Mozambique",
     "Region": "Eastern Africa",
     "Province": "Sofala"
    },
    {
     "Country": "Mozambique",
     "Region": "Eastern Africa",
     "Province": "Tete"
    },
    {
     "Country": "Mozambique",
     "Region": "Eastern Africa",
     "Province": "Zambezia"
    },
    {
     "Country": "Myanmar, Burma",
     "Region": "Southeast Asia",
     "Province": "Ayeyarwady Region"
    },
    {
     "Country": "Myanmar, Burma",
     "Region": "Southeast Asia",
     "Province": "Bago Region"
    },
    {
     "Country": "Myanmar, Burma",
     "Region": "Southeast Asia",
     "Province": "Chin State"
    },
    {
     "Country": "Myanmar, Burma",
     "Region": "Southeast Asia",
     "Province": "Kachin State"
    },
    {
     "Country": "Myanmar, Burma",
     "Region": "Southeast Asia",
     "Province": "Kayah State"
    },
    {
     "Country": "Myanmar, Burma",
     "Region": "Southeast Asia",
     "Province": "Kayin State"
    },
    {
     "Country": "Myanmar, Burma",
     "Region": "Southeast Asia",
     "Province": "Magway Region"
    },
    {
     "Country": "Myanmar, Burma",
     "Region": "Southeast Asia",
     "Province": "Mandalay Region"
    },
    {
     "Country": "Myanmar, Burma",
     "Region": "Southeast Asia",
     "Province": "Mon State"
    },
    {
     "Country": "Myanmar, Burma",
     "Region": "Southeast Asia",
     "Province": "Naypyidaw Union Territory"
    },
    {
     "Country": "Myanmar, Burma",
     "Region": "Southeast Asia",
     "Province": "Rakhine State"
    },
    {
     "Country": "Myanmar, Burma",
     "Region": "Southeast Asia",
     "Province": "Sagaing Region"
    },
    {
     "Country": "Myanmar, Burma",
     "Region": "Southeast Asia",
     "Province": "Shan State"
    },
    {
     "Country": "Myanmar, Burma",
     "Region": "Southeast Asia",
     "Province": "Tanintharyi Region"
    },
    {
     "Country": "Myanmar, Burma",
     "Region": "Southeast Asia",
     "Province": "Yangon Region"
    },
    {
     "Country": "Namibia",
     "Region": "Southern Africa",
     "Province": "Erongo"
    },
    {
     "Country": "Namibia",
     "Region": "Southern Africa",
     "Province": "Hardap"
    },
    {
     "Country": "Namibia",
     "Region": "Southern Africa",
     "Province": "Kavango East"
    },
    {
     "Country": "Namibia",
     "Region": "Southern Africa",
     "Province": "Kavango West"
    },
    {
     "Country": "Namibia",
     "Region": "Southern Africa",
     "Province": "Khomas"
    },
    {
     "Country": "Namibia",
     "Region": "Southern Africa",
     "Province": "Kunene"
    },
    {
     "Country": "Namibia",
     "Region": "Southern Africa",
     "Province": "Ohangwena"
    },
    {
     "Country": "Namibia",
     "Region": "Southern Africa",
     "Province": "Omaheke"
    },
    {
     "Country": "Namibia",
     "Region": "Southern Africa",
     "Province": "Omusati"
    },
    {
     "Country": "Namibia",
     "Region": "Southern Africa",
     "Province": "Oshana"
    },
    {
     "Country": "Namibia",
     "Region": "Southern Africa",
     "Province": "Oshikoto"
    },
    {
     "Country": "Namibia",
     "Region": "Southern Africa",
     "Province": "Otjozondjupa"
    },
    {
     "Country": "Namibia",
     "Region": "Southern Africa",
     "Province": "Zambezi"
    },
    {
     "Country": "Namibia",
     "Region": "Southern Africa",
     "Province": "Karas"
    },
    {
     "Country": "Nauru",
     "Region": "Micronesia, Oceania",
     "Province": "Aiwo"
    },
    {
     "Country": "Nauru",
     "Region": "Micronesia, Oceania",
     "Province": "Anabar"
    },
    {
     "Country": "Nauru",
     "Region": "Micronesia, Oceania",
     "Province": "Anetan"
    },
    {
     "Country": "Nauru",
     "Region": "Micronesia, Oceania",
     "Province": "Boe"
    },
    {
     "Country": "Nauru",
     "Region": "Micronesia, Oceania",
     "Province": "Buada"
    },
    {
     "Country": "Nauru",
     "Region": "Micronesia, Oceania",
     "Province": "Meneng"
    },
    {
     "Country": "Nauru",
     "Region": "Micronesia, Oceania",
     "Province": "Ubenide"
    },
    {
     "Country": "Nauru",
     "Region": "Micronesia, Oceania",
     "Province": "Yaren"
    },
    {
     "Country": "Nepal",
     "Region": "South-Central Asia",
     "Province": "Koshi"
    },
    {
     "Country": "Nepal",
     "Region": "South-Central Asia",
     "Province": "Madhesh"
    },
    {
     "Country": "Nepal",
     "Region": "South-Central Asia",
     "Province": "Bagmati"
    },
    {
     "Country": "Nepal",
     "Region": "South-Central Asia",
     "Province": "Gandaki"
    },
    {
     "Country": "Nepal",
     "Region": "South-Central Asia",
     "Province": "Lumbini"
    },
    {
     "Country": "Nepal",
     "Region": "South-Central Asia",
     "Province": "Karnali"
    },
    {
     "Country": "Nepal",
     "Region": "South-Central Asia",
     "Province": "Sudurpashchim"
    },
    {
     "Country": "Netherlands",
     "Region": "Western Europe",
     "Province": "Drenthe"
    },
    {
     "Country": "Netherlands",
     "Region": "Western Europe",
     "Province": "Flevoland"
    },
    {
     "Country": "Netherlands",
     "Region": "Western Europe",
     "Province": "Friesland"
    },
    {
     "Country": "Netherlands",
     "Region": "Western Europe",
     "Province": "Gelderland"
    },
    {
     "Country": "Netherlands",
     "Region": "Western Europe",
     "Province": "Groningen"
    },
    {
     "Country": "Netherlands",
     "Region": "Western Europe",
     "Province": "Limburg"
    },
    {
     "Country": "Netherlands",
     "Region": "Western Europe",
     "Province": "North Brabant"
    },
    {
     "Country": "Netherlands",
     "Region": "Western Europe",
     "Province": "North Holland"
    },
    {
     "Country": "Netherlands",
     "Region": "Western Europe",
     "Province": "Overijssel"
    },
    {
     "Country": "Netherlands",
     "Region": "Western Europe",
     "Province": "South Holland"
    },
    {
     "Country": "Netherlands",
     "Region": "Western Europe",
     "Province": "Utrecht"
    },
    {
     "Country": "Netherlands",
     "Region": "Western Europe",
     "Province": "Zeeland"
    },
    {
     "Country": "Netherlands",
     "Region": "Western Europe",
     "Province": "Netherlands"
    },
    {
     "Country": "Netherlands Antilles",
     "Region": "Caribbean",
     "Province": "Curaçao"
    },
    {
     "Country": "Netherlands Antilles",
     "Region": "Caribbean",
     "Province": "Bonaire"
    },
    {
     "Country": "Netherlands Antilles",
     "Region": "Caribbean",
     "Province": "Aruba"
    },
    {
     "Country": "Netherlands Antilles",
     "Region": "Caribbean",
     "Province": "Sint Maarten"
    },
    {
     "Country": "Netherlands Antilles",
     "Region": "Caribbean",
     "Province": "Sint Eustatius"
    },
    {
     "Country": "Netherlands Antilles",
     "Region": "Caribbean",
     "Province": "Saba"
    },
    {
     "Country": "Netherlands Antilles",
     "Region": "Caribbean",
     "Province": "Netherlands Antilles"
    },
    {
     "Country": "New Caledonia",
     "Region": "Melanesia, Oceania",
     "Province": "Thio"
    },
    {
     "Country": "New Caledonia",
     "Region": "Melanesia, Oceania",
     "Province": "Yaté"
    },
    {
     "Country": "New Caledonia",
     "Region": "Melanesia, Oceania",
     "Province": "L'Île-des-Pins"
    },
    {
     "Country": "New Caledonia",
     "Region": "Melanesia, Oceania",
     "Province": "Le Mont-Dore"
    },
    {
     "Country": "New Caledonia",
     "Region": "Melanesia, Oceania",
     "Province": "Nouméa"
    },
    {
     "Country": "New Caledonia",
     "Region": "Melanesia, Oceania",
     "Province": "Dumbéa"
    },
    {
     "Country": "New Caledonia",
     "Region": "Melanesia, Oceania",
     "Province": "Païta"
    },
    {
     "Country": "New Caledonia",
     "Region": "Melanesia, Oceania",
     "Province": "Boulouparis"
    },
    {
     "Country": "New Caledonia",
     "Region": "Melanesia, Oceania",
     "Province": "La Foa"
    },
    {
     "Country": "New Caledonia",
     "Region": "Melanesia, Oceania",
     "Province": "Sarraméa"
    },
    {
     "Country": "New Caledonia",
     "Region": "Melanesia, Oceania",
     "Province": "Farino"
    },
    {
     "Country": "New Caledonia",
     "Region": "Melanesia, Oceania",
     "Province": "Moindou"
    },
    {
     "Country": "New Caledonia",
     "Region": "Melanesia, Oceania",
     "Province": "Bourail"
    },
    {
     "Country": "New Caledonia",
     "Region": "Melanesia, Oceania",
     "Province": "Poya"
    },
    {
     "Country": "New Caledonia",
     "Region": "Melanesia, Oceania",
     "Province": "Pouembout"
    },
    {
     "Country": "New Caledonia",
     "Region": "Melanesia, Oceania",
     "Province": "Koné"
    },
    {
     "Country": "New Caledonia",
     "Region": "Melanesia, Oceania",
     "Province": "Voh"
    },
    {
     "Country": "New Caledonia",
     "Region": "Melanesia, Oceania",
     "Province": "Kaala-Gomen"
    },
    {
     "Country": "New Caledonia",
     "Region": "Melanesia, Oceania",
     "Province": "Koumac"
    },
    {
     "Country": "New Caledonia",
     "Region": "Melanesia, Oceania",
     "Province": "Poum"
    },
    {
     "Country": "New Caledonia",
     "Region": "Melanesia, Oceania",
     "Province": "Belep"
    },
    {
     "Country": "New Caledonia",
     "Region": "Melanesia, Oceania",
     "Province": "Ouégoa"
    },
    {
     "Country": "New Caledonia",
     "Region": "Melanesia, Oceania",
     "Province": "Pouébo"
    },
    {
     "Country": "New Caledonia",
     "Region": "Melanesia, Oceania",
     "Province": "Hienghène"
    },
    {
     "Country": "New Caledonia",
     "Region": "Melanesia, Oceania",
     "Province": "Touho"
    },
    {
     "Country": "New Caledonia",
     "Region": "Melanesia, Oceania",
     "Province": "Poindimié"
    },
    {
     "Country": "New Caledonia",
     "Region": "Melanesia, Oceania",
     "Province": "Ponérihouen"
    },
    {
     "Country": "New Caledonia",
     "Region": "Melanesia, Oceania",
     "Province": "Houaïlou"
    },
    {
     "Country": "New Caledonia",
     "Region": "Melanesia, Oceania",
     "Province": "Kouaoua"
    },
    {
     "Country": "New Caledonia",
     "Region": "Melanesia, Oceania",
     "Province": "Canala"
    },
    {
     "Country": "New Caledonia",
     "Region": "Melanesia, Oceania",
     "Province": "Ouvéa"
    },
    {
     "Country": "New Caledonia",
     "Region": "Melanesia, Oceania",
     "Province": "Lifou"
    },
    {
     "Country": "New Caledonia",
     "Region": "Melanesia, Oceania",
     "Province": "Maré"
    },
    {
     "Country": "New Zealand",
     "Region": "Oceania; Australia",
     "Province": "Auckland"
    },
    {
     "Country": "New Zealand",
     "Region": "Oceania; Australia",
     "Province": "New Plymouth"
    },
    {
     "Country": "New Zealand",
     "Region": "Oceania; Australia",
     "Province": "Hawke's Bay"
    },
    {
     "Country": "New Zealand",
     "Region": "Oceania; Australia",
     "Province": "Wellington"
    },
    {
     "Country": "New Zealand",
     "Region": "Oceania; Australia",
     "Province": "Nelson"
    },
    {
     "Country": "New Zealand",
     "Region": "Oceania; Australia",
     "Province": "Marlborough"
    },
    {
     "Country": "New Zealand",
     "Region": "Oceania; Australia",
     "Province": "Westland"
    },
    {
     "Country": "New Zealand",
     "Region": "Oceania; Australia",
     "Province": "Canterbury"
    },
    {
     "Country": "New Zealand",
     "Region": "Oceania; Australia",
     "Province": "Otago"
    },
    {
     "Country": "New Zealand",
     "Region": "Oceania; Australia",
     "Province": "Southland"
    },
    {
     "Country": "Nicaragua",
     "Region": "Central America",
     "Province": "Boaco"
    },
    {
     "Country": "Nicaragua",
     "Region": "Central America",
     "Province": "Carazo"
    },
    {
     "Country": "Nicaragua",
     "Region": "Central America",
     "Province": "Chinandega"
    },
    {
     "Country": "Nicaragua",
     "Region": "Central America",
     "Province": "Chontales"
    },
    {
     "Country": "Nicaragua",
     "Region": "Central America",
     "Province": "Estelí"
    },
    {
     "Country": "Nicaragua",
     "Region": "Central America",
     "Province": "Granada"
    },
    {
     "Country": "Nicaragua",
     "Region": "Central America",
     "Province": "Jinotega"
    },
    {
     "Country": "Nicaragua",
     "Region": "Central America",
     "Province": "León"
    },
    {
     "Country": "Nicaragua",
     "Region": "Central America",
     "Province": "Madriz"
    },
    {
     "Country": "Nicaragua",
     "Region": "Central America",
     "Province": "Managua"
    },
    {
     "Country": "Nicaragua",
     "Region": "Central America",
     "Province": "Masaya"
    },
    {
     "Country": "Nicaragua",
     "Region": "Central America",
     "Province": "Matagalpa"
    },
    {
     "Country": "Nicaragua",
     "Region": "Central America",
     "Province": "Nueva Segovia"
    },
    {
     "Country": "Nicaragua",
     "Region": "Central America",
     "Province": "Rivas"
    },
    {
     "Country": "Nicaragua",
     "Region": "Central America",
     "Province": "Río San Juan"
    },
    {
     "Country": "Nicaragua",
     "Region": "Central America",
     "Province": "North Caribbean Coast Autonomous Region"
    },
    {
     "Country": "Nicaragua",
     "Region": "Central America",
     "Province": "South Caribbean Coast Autonomous Region"
    },
    {
     "Country": "Niger",
     "Region": "West Africa",
     "Province": "Agadez"
    },
    {
     "Country": "Niger",
     "Region": "West Africa",
     "Province": "Diffa"
    },
    {
     "Country": "Niger",
     "Region": "West Africa",
     "Province": "Dosso"
    },
    {
     "Country": "Niger",
     "Region": "West Africa",
     "Province": "Maradi"
    },
    {
     "Country": "Niger",
     "Region": "West Africa",
     "Province": "Niamey*"
    },
    {
     "Country": "Niger",
     "Region": "West Africa",
     "Province": "Tahoua"
    },
    {
     "Country": "Niger",
     "Region": "West Africa",
     "Province": "Tillabéri"
    },
    {
     "Country": "Niger",
     "Region": "West Africa",
     "Province": "Zinder"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Abeokuta"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Abeokuta"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Adamawa"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Adamawa"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Adamawa"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Bauchi"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Bauchi"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Bauchi"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Benin"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Benin"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Benin"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Benin"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Benue"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Benue"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Benue"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Benue"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Benue"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Bornu"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Bornu"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Bornu"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Bornu"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Bornu"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Calabar"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Calabar"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Calabar"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Calabar"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Calabar"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Calabar"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Calabar"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Calabar"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Cameroons"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Cameroons"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Cameroons"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Cameroons"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Ijebu"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Ilorin"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Ilorin"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Ilorin"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Kabba"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Kabba"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Kabba"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Kabba"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Kano"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Kano"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Katsina"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Niger"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Niger"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Niger"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Niger"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Ogoja"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Ogoja"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Ogoja"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Ogoja"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Ogoja"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Ondo"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Ondo"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Ondo"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Ondo"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Onitsha"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Onitsha"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Onitsha"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Onitsha"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Onitsha"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Owerri"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Owerri"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Owerri"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Owerri"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Owerri"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Oyo"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Oyo"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Oyo"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Plateau"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Plateau"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Plateau"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Plateau"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Plateau"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Rivers"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Rivers"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Rivers"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Rivers"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Sokoto"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Sokoto"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Sokoto"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Warri"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Warri"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Warri"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Warri"
    },
    {
     "Country": "Nigeria",
     "Region": "West Africa",
     "Province": "Zaria"
    },
    {
     "Country": "Niue",
     "Region": "Polynesia, Oceania",
     "Province": "Makefu"
    },
    {
     "Country": "Niue",
     "Region": "Polynesia, Oceania",
     "Province": "Tuapa"
    },
    {
     "Country": "Niue",
     "Region": "Polynesia, Oceania",
     "Province": "Namukulu"
    },
    {
     "Country": "Niue",
     "Region": "Polynesia, Oceania",
     "Province": "Hikutavake"
    },
    {
     "Country": "Niue",
     "Region": "Polynesia, Oceania",
     "Province": "Toi"
    },
    {
     "Country": "Niue",
     "Region": "Polynesia, Oceania",
     "Province": "Mutalau"
    },
    {
     "Country": "Niue",
     "Region": "Polynesia, Oceania",
     "Province": "Lakepa"
    },
    {
     "Country": "Niue",
     "Region": "Polynesia, Oceania",
     "Province": "Liku"
    },
    {
     "Country": "Niue",
     "Region": "Polynesia, Oceania",
     "Province": "Hakupu"
    },
    {
     "Country": "Niue",
     "Region": "Polynesia, Oceania",
     "Province": "Vaiea"
    },
    {
     "Country": "Niue",
     "Region": "Polynesia, Oceania",
     "Province": "Avatele"
    },
    {
     "Country": "Niue",
     "Region": "Polynesia, Oceania",
     "Province": "Tamakautoga"
    },
    {
     "Country": "Niue",
     "Region": "Polynesia, Oceania",
     "Province": "Alofi South"
    },
    {
     "Country": "Niue",
     "Region": "Polynesia, Oceania",
     "Province": "Alofi North"
    },
    {
     "Country": "Niue",
     "Region": "Polynesia, Oceania",
     "Province": "Niue"
    },
    {
     "Country": "North Macedonia",
     "Region": "Balkan Peninsula, Southern Europe",
     "Province": "Mavrovo"
    },
    {
     "Country": "North Macedonia",
     "Region": "Balkan Peninsula, Southern Europe",
     "Province": "Galičica"
    },
    {
     "Country": "North Macedonia",
     "Region": "Balkan Peninsula, Southern Europe",
     "Province": "Pelister"
    },
    {
     "Country": "North Macedonia",
     "Region": "Balkan Peninsula, Southern Europe",
     "Province": "Šar Mountains"
    },
    {
     "Country": "Northern Mariana Islands",
     "Region": "Micronesia, Oceania",
     "Province": "Farallon de Pajaros"
    },
    {
     "Country": "Northern Mariana Islands",
     "Region": "Micronesia, Oceania",
     "Province": "Asuncion"
    },
    {
     "Country": "Northern Mariana Islands",
     "Region": "Micronesia, Oceania",
     "Province": "Agrihan"
    },
    {
     "Country": "Northern Mariana Islands",
     "Region": "Micronesia, Oceania",
     "Province": "Pagan"
    },
    {
     "Country": "Northern Mariana Islands",
     "Region": "Micronesia, Oceania",
     "Province": "Alamagan"
    },
    {
     "Country": "Northern Mariana Islands",
     "Region": "Micronesia, Oceania",
     "Province": "Guguan"
    },
    {
     "Country": "Northern Mariana Islands",
     "Region": "Micronesia, Oceania",
     "Province": "Sarigan"
    },
    {
     "Country": "Northern Mariana Islands",
     "Region": "Micronesia, Oceania",
     "Province": "Anatahan"
    },
    {
     "Country": "Northern Mariana Islands",
     "Region": "Micronesia, Oceania",
     "Province": "Farallon de Medinilla"
    },
    {
     "Country": "Northern Mariana Islands",
     "Region": "Micronesia, Oceania",
     "Province": "Saipan"
    },
    {
     "Country": "Northern Mariana Islands",
     "Region": "Micronesia, Oceania",
     "Province": "Tinian"
    },
    {
     "Country": "Northern Mariana Islands",
     "Region": "Micronesia, Oceania",
     "Province": "Aguijan"
    },
    {
     "Country": "Northern Mariana Islands",
     "Region": "Micronesia, Oceania",
     "Province": "Rota"
    },
    {
     "Country": "Norway",
     "Region": "Northern Europe",
     "Province": "Trøndelag"
    },
    {
     "Country": "Norway",
     "Region": "Northern Europe",
     "Province": "Western Norway (Vestlandet)"
    },
    {
     "Country": "Norway",
     "Region": "Northern Europe",
     "Province": "Møre og Romsdal"
    },
    {
     "Country": "Norway",
     "Region": "Northern Europe",
     "Province": "Vestland"
    },
    {
     "Country": "Norway",
     "Region": "Northern Europe",
     "Province": "Rogaland"
    },
    {
     "Country": "Norway",
     "Region": "Northern Europe",
     "Province": "Southern Norway (Sørlandet\/Agder)"
    },
    {
     "Country": "Norway",
     "Region": "Northern Europe",
     "Province": "Agder"
    },
    {
     "Country": "Norway",
     "Region": "Northern Europe",
     "Province": "Eastern Norway (Østlandet\/Austlandet)"
    },
    {
     "Country": "Norway",
     "Region": "Northern Europe",
     "Province": "Vestfold"
    },
    {
     "Country": "Norway",
     "Region": "Northern Europe",
     "Province": "Telemark"
    },
    {
     "Country": "Norway",
     "Region": "Northern Europe",
     "Province": "Buskerud"
    },
    {
     "Country": "Norway",
     "Region": "Northern Europe",
     "Province": "Akershus"
    },
    {
     "Country": "Norway",
     "Region": "Northern Europe",
     "Province": "Østfold"
    },
    {
     "Country": "Norway",
     "Region": "Northern Europe",
     "Province": "Innlandet"
    },
    {
     "Country": "Norway",
     "Region": "Northern Europe",
     "Province": "Oslo"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Nizwa"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Samail"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Bahla"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Adam"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Al Hamra"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Manah"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Izki"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Bidbid"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Ibri"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Yanqul"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Dhank"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Sohar"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Shinas"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Liwa"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Saham"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Al Khaburah"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Suwayq"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Nakhal"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Wadi Al Maawil"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Al Awabi"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Al Musanaah"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Barka"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Rustaq"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Al Buraimi"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Mahdah"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "As Sunaynah"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Haima"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Duqm"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Mahout"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Al Jazer"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Ibra"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Al-Mudhaibi"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Bidiya"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Wadi Bani Khaled"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Dema Wa Thaieen"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Al Qabil"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Masirah"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Sur"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Jalan Bani Bu Hassan"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Jalan Bani Bu Ali"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Al Kamil Wal Wafi"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Salalah"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Taqah"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Mirbat"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Thumrait"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Sadah"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Rakhyut"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Dhalkut"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Muqshin"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Shalim and the Hallaniyat Islands"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Al-Mazyona"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Muscat"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Muttrah"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Bawshar"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Seeb"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Al Amarat"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Qurayyat"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Khasab"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Bukha"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Daba Al Bayah"
    },
    {
     "Country": "Oman",
     "Region": "Middle East",
     "Province": "Madha"
    },
    {
     "Country": "Pakistan",
     "Region": "South-Central Asia",
     "Province": "Azad Jammu and Kashmir"
    },
    {
     "Country": "Pakistan",
     "Region": "South-Central Asia",
     "Province": "Balochistan"
    },
    {
     "Country": "Pakistan",
     "Region": "South-Central Asia",
     "Province": "Gilgit-Baltistan"
    },
    {
     "Country": "Pakistan",
     "Region": "South-Central Asia",
     "Province": "Islamabad Capital Territory"
    },
    {
     "Country": "Pakistan",
     "Region": "South-Central Asia",
     "Province": "Khyber Pakhtunkhwa"
    },
    {
     "Country": "Pakistan",
     "Region": "South-Central Asia",
     "Province": "Punjab"
    },
    {
     "Country": "Pakistan",
     "Region": "South-Central Asia",
     "Province": "Sindh"
    },
    {
     "Country": "Palau",
     "Region": "Micronesia, Oceania",
     "Province": "North of Babeldaob"
    },
    {
     "Country": "Palau",
     "Region": "Micronesia, Oceania",
     "Province": "Kayangel"
    },
    {
     "Country": "Palau",
     "Region": "Micronesia, Oceania",
     "Province": "Babeldaob"
    },
    {
     "Country": "Palau",
     "Region": "Micronesia, Oceania",
     "Province": " Aimeliik"
    },
    {
     "Country": "Palau",
     "Region": "Micronesia, Oceania",
     "Province": " Airai"
    },
    {
     "Country": "Palau",
     "Region": "Micronesia, Oceania",
     "Province": " Melekeok"
    },
    {
     "Country": "Palau",
     "Region": "Micronesia, Oceania",
     "Province": " Ngaraard"
    },
    {
     "Country": "Palau",
     "Region": "Micronesia, Oceania",
     "Province": " Ngarchelong"
    },
    {
     "Country": "Palau",
     "Region": "Micronesia, Oceania",
     "Province": " Ngardmau"
    },
    {
     "Country": "Palau",
     "Region": "Micronesia, Oceania",
     "Province": " Ngeremlengui"
    },
    {
     "Country": "Palau",
     "Region": "Micronesia, Oceania",
     "Province": " Ngatpang"
    },
    {
     "Country": "Palau",
     "Region": "Micronesia, Oceania",
     "Province": " Ngchesar"
    },
    {
     "Country": "Palau",
     "Region": "Micronesia, Oceania",
     "Province": " Ngiwal"
    },
    {
     "Country": "Palau",
     "Region": "Micronesia, Oceania",
     "Province": "Southwest of Babeldaob"
    },
    {
     "Country": "Palau",
     "Region": "Micronesia, Oceania",
     "Province": " Angaur"
    },
    {
     "Country": "Palau",
     "Region": "Micronesia, Oceania",
     "Province": " Koror"
    },
    {
     "Country": "Palau",
     "Region": "Micronesia, Oceania",
     "Province": " Peleliu"
    },
    {
     "Country": "Palau",
     "Region": "Micronesia, Oceania",
     "Province": "Southwest Islands"
    },
    {
     "Country": "Palau",
     "Region": "Micronesia, Oceania",
     "Province": " Hatohobei"
    },
    {
     "Country": "Palau",
     "Region": "Micronesia, Oceania",
     "Province": " Sonsorol"
    },
    {
     "Country": "Palestinian",
     "Region": "Middle East, Western Asia",
     "Province": "Gaza Strip"
    },
    {
     "Country": "Palestinian",
     "Region": "Middle East, Western Asia",
     "Province": "West Bank"
    },
    {
     "Country": "Palestinian",
     "Region": "Middle East, Western Asia",
     "Province": "West Jerusalem"
    },
    {
     "Country": "Palestinian",
     "Region": "Middle East, Western Asia",
     "Province": "Golan Heights"
    },
    {
     "Country": "Palestinian",
     "Region": "Middle East, Western Asia",
     "Province": "Israel (Green Line border)"
    },
    {
     "Country": "Panama",
     "Region": "Central America",
     "Province": "Balboa"
    },
    {
     "Country": "Panama",
     "Region": "Central America",
     "Province": "Chepo"
    },
    {
     "Country": "Panama",
     "Region": "Central America",
     "Province": "Chimán"
    },
    {
     "Country": "Panama",
     "Region": "Central America",
     "Province": "Panamá"
    },
    {
     "Country": "Panama",
     "Region": "Central America",
     "Province": "San Miguelito"
    },
    {
     "Country": "Panama",
     "Region": "Central America",
     "Province": "Taboga"
    },
    {
     "Country": "Papua New Guinea",
     "Region": "Maritime Southeast Asia, Melanesia, Oceania",
     "Province": "Southern"
    },
    {
     "Country": "Papua New Guinea",
     "Region": "Maritime Southeast Asia, Melanesia, Oceania",
     "Province": "Highlands"
    },
    {
     "Country": "Papua New Guinea",
     "Region": "Maritime Southeast Asia, Melanesia, Oceania",
     "Province": "Highlands"
    },
    {
     "Country": "Papua New Guinea",
     "Region": "Maritime Southeast Asia, Melanesia, Oceania",
     "Province": "Islands"
    },
    {
     "Country": "Papua New Guinea",
     "Region": "Maritime Southeast Asia, Melanesia, Oceania",
     "Province": "Momase"
    },
    {
     "Country": "Papua New Guinea",
     "Region": "Maritime Southeast Asia, Melanesia, Oceania",
     "Province": "Highlands"
    },
    {
     "Country": "Papua New Guinea",
     "Region": "Maritime Southeast Asia, Melanesia, Oceania",
     "Province": "Southern"
    },
    {
     "Country": "Papua New Guinea",
     "Region": "Maritime Southeast Asia, Melanesia, Oceania",
     "Province": "Momase"
    },
    {
     "Country": "Papua New Guinea",
     "Region": "Maritime Southeast Asia, Melanesia, Oceania",
     "Province": "Islands"
    },
    {
     "Country": "Papua New Guinea",
     "Region": "Maritime Southeast Asia, Melanesia, Oceania",
     "Province": "Southern"
    },
    {
     "Country": "Papua New Guinea",
     "Region": "Maritime Southeast Asia, Melanesia, Oceania",
     "Province": "Momase"
    },
    {
     "Country": "Papua New Guinea",
     "Region": "Maritime Southeast Asia, Melanesia, Oceania",
     "Province": "Islands"
    },
    {
     "Country": "Papua New Guinea",
     "Region": "Maritime Southeast Asia, Melanesia, Oceania",
     "Province": "Southern"
    },
    {
     "Country": "Papua New Guinea",
     "Region": "Maritime Southeast Asia, Melanesia, Oceania",
     "Province": "Islands"
    },
    {
     "Country": "Paraguay",
     "Region": "Central South America",
     "Province": "Asunción"
    },
    {
     "Country": "Paraguay",
     "Region": "Central South America",
     "Province": "Concepción"
    },
    {
     "Country": "Paraguay",
     "Region": "Central South America",
     "Province": "San Pedro"
    },
    {
     "Country": "Paraguay",
     "Region": "Central South America",
     "Province": "Caacupé"
    },
    {
     "Country": "Paraguay",
     "Region": "Central South America",
     "Province": "Villarrica"
    },
    {
     "Country": "Paraguay",
     "Region": "Central South America",
     "Province": "Coronel Oviedo"
    },
    {
     "Country": "Paraguay",
     "Region": "Central South America",
     "Province": "Caazapá"
    },
    {
     "Country": "Paraguay",
     "Region": "Central South America",
     "Province": "Encarnación"
    },
    {
     "Country": "Paraguay",
     "Region": "Central South America",
     "Province": "San Juan Bautista"
    },
    {
     "Country": "Paraguay",
     "Region": "Central South America",
     "Province": "Paraguarí"
    },
    {
     "Country": "Paraguay",
     "Region": "Central South America",
     "Province": "Ciudad del Este"
    },
    {
     "Country": "Paraguay",
     "Region": "Central South America",
     "Province": "Areguá"
    },
    {
     "Country": "Paraguay",
     "Region": "Central South America",
     "Province": "Pilar"
    },
    {
     "Country": "Paraguay",
     "Region": "Central South America",
     "Province": "Pedro Juan Caballero"
    },
    {
     "Country": "Paraguay",
     "Region": "Central South America",
     "Province": "Salto del Guairá"
    },
    {
     "Country": "Paraguay",
     "Region": "Central South America",
     "Province": "Villa Hayes"
    },
    {
     "Country": "Paraguay",
     "Region": "Central South America",
     "Province": "Fuerte Olimpo"
    },
    {
     "Country": "Paraguay",
     "Region": "Central South America",
     "Province": "Filadelfia"
    },
    {
     "Country": "Paraguay",
     "Region": "Central South America",
     "Province": "Asunción"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Chachapoyas"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Bagua"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Bongará"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Condorcanqui"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Luya"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Rodríguez de Mendoza"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Utcubamba"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Huaraz"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Aija"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Antonio Raymondi"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Asunción"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Bolognesi"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Carhuaz"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Carlos Fermín Fitzcarrald"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Casma"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Corongo"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Huari"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Huarmey"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Huaylas"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Mariscal Luzuriaga"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Ocros"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Pallasca"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Pomabamba"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Recuay"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Santa"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Sihuas"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Yungay"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Abancay"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Andahuaylas"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Antabamba"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Aymaraes"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Cotabambas"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Chincheros"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Grau"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Arequipa"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Camaná"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Caravelí"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Castilla"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Caylloma"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Condesuyos"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Islay"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "La Unión"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Huamanga"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Cangallo"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Huanca Sancos"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Huanta"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "La Mar"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Lucanas"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Parinacochas"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Páucar del Sara Sara"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Sucre"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Víctor Fajardo"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Vilcas Huamán"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Cajamarca"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Cajabamba"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Celendín"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Chota"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Contumazá"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Cutervo"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Hualgayoc"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Jaén"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "San Ignacio"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "San Marcos"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "San Miguel"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "San Pablo"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Santa Cruz"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Callao"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Cusco"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Acomayo"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Anta"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Calca"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Canas"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Canchis"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Chumbivilcas"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Espinar"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "La Convención"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Paruro"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Paucartambo"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Quispicanchi"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Urubamba"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Huancavelica"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Acobamba"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Angaraes"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Castrovirreyna"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Churcampa"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Huaytará"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Tayacaja"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Huánuco"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Ambo"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Dos de Mayo"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Huacaybamba"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Huamalíes"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Leoncio Prado"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Marañón"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Pachitea"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Puerto Inca"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Lauricocha"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Yarowilca"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Ica"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Chincha"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Nazca"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Palpa"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Pisco"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Huancayo"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Concepción"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Chanchamayo"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Jauja"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Junín"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Satipo"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Tarma"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Yauli"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Chupaca"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Trujillo"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Ascope"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Bolívar"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Chepén"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Julcán"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Otuzco"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Pacasmayo"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Pataz"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Sánchez Carrión"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Santiago de Chuco"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Gran Chimú"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Virú"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Chiclayo"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Ferreñafe"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Lambayeque"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Lima"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Huaura"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Barranca"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Cajatambo"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Canta"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Cañete"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Huaral"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Huarochirí"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Oyón"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Yauyos"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Maynas"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Alto Amazonas"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Loreto"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Mariscal Ramón Castilla"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Putumayo"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Requena"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Ucayali"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Datem del Marañón"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Tambopata"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Manú"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Tahuamanu"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Mariscal Nieto"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "General Sánchez Cerro"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Ilo"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Pasco"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Daniel Alcídes Carrión"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Oxapampa"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Piura"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Ayabaca"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Huancabamba"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Morropón"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Paita"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Sullana"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Talara"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Sechura"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Puno"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Azángaro"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Carabaya"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Chucuito"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "El Collao"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Huancané"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Lampa"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Melgar"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Moho"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "San Antonio de Putina"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "San Román"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Sandia"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Yunguyo"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Moyobamba"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Bellavista"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "El Dorado"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Huallaga"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Lamas"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Mariscal Cáceres"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Picota"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Rioja"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "San Martín"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Tocache"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Tacna"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Candarave"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Jorge Basadre"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Tarata"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Tumbes"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Contralmirante Villar"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Zarumilla"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Coronel Portillo"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Atalaya"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Padre Abad"
    },
    {
     "Country": "Peru",
     "Region": "Western South America",
     "Province": "Purús"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Abra"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Agusan del Norte"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Agusan del Sur"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Aklan"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Albay"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Antique"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Apayao"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Aurora"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Basilan"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Bataan"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Batanes"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Batangas"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Benguet"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Biliran"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Bohol"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Bukidnon"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Bulacan"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Cagayan"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Camarines Norte"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Camarines Sur"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Camiguin"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Capiz"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Catanduanes"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Cavite"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Cebu"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Cotabato"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Davao de Oro"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Davao del Norte"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Davao del Sur"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Davao Occidental"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Davao Oriental"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Dinagat Islands"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Eastern Samar"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Guimaras"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Ifugao"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Ilocos Norte"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Ilocos Sur"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Iloilo"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Isabela"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Kalinga"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "La Union"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Laguna"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Lanao del Norte"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Lanao del Sur"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Leyte"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Maguindanao del Norte"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Maguindanao del Sur"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Marinduque"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Masbate"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Misamis Occidental"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Misamis Oriental"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Mountain Province"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Negros Occidental"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Negros Oriental"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Northern Samar"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Nueva Ecija"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Nueva Vizcaya"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Occidental Mindoro"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Oriental Mindoro"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Palawan"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Pampanga"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Pangasinan"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Quezon"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Quirino"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Rizal"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Romblon"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Samar"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Sarangani"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Siquijor"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Sorsogon"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "South Cotabato"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Southern Leyte"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Sultan Kudarat"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Sulu"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Surigao del Norte"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Surigao del Sur"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Tarlac"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Tawi-Tawi"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Zambales"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Zamboanga del Norte"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Zamboanga del Sur"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Zamboanga Sibugay"
    },
    {
     "Country": "Philippines",
     "Region": "Southeast Asia",
     "Province": "Metro Manila"
    },
    {
     "Country": "Pitcairn Island",
     "Region": "Polynesia, Oceania",
     "Province": "Ducie Island"
    },
    {
     "Country": "Pitcairn Island",
     "Region": "Polynesia, Oceania",
     "Province": "Henderson Island"
    },
    {
     "Country": "Pitcairn Island",
     "Region": "Polynesia, Oceania",
     "Province": "Oeno Island"
    },
    {
     "Country": "Pitcairn Island",
     "Region": "Polynesia, Oceania",
     "Province": "Pitcairn Island"
    },
    {
     "Country": "Pitcairn Island",
     "Region": "Polynesia, Oceania",
     "Province": "Pitcairn Islands"
    },
    {
     "Country": "Poland",
     "Region": "Eastern Europe",
     "Province": "Lower Silesian"
    },
    {
     "Country": "Poland",
     "Region": "Eastern Europe",
     "Province": "Kuyavian-Pomeranian"
    },
    {
     "Country": "Poland",
     "Region": "Eastern Europe",
     "Province": "Lublin"
    },
    {
     "Country": "Poland",
     "Region": "Eastern Europe",
     "Province": "Lubusz"
    },
    {
     "Country": "Poland",
     "Region": "Eastern Europe",
     "Province": "Łódź"
    },
    {
     "Country": "Poland",
     "Region": "Eastern Europe",
     "Province": "Lesser Poland"
    },
    {
     "Country": "Poland",
     "Region": "Eastern Europe",
     "Province": "Masovian"
    },
    {
     "Country": "Poland",
     "Region": "Eastern Europe",
     "Province": "Opole"
    },
    {
     "Country": "Poland",
     "Region": "Eastern Europe",
     "Province": "Subcarpathian"
    },
    {
     "Country": "Poland",
     "Region": "Eastern Europe",
     "Province": "Podlaskie"
    },
    {
     "Country": "Poland",
     "Region": "Eastern Europe",
     "Province": "Pomeranian"
    },
    {
     "Country": "Poland",
     "Region": "Eastern Europe",
     "Province": "Silesian"
    },
    {
     "Country": "Poland",
     "Region": "Eastern Europe",
     "Province": "Holy Cross"
    },
    {
     "Country": "Poland",
     "Region": "Eastern Europe",
     "Province": "Warmian-Masurian"
    },
    {
     "Country": "Poland",
     "Region": "Eastern Europe",
     "Province": "Greater Poland"
    },
    {
     "Country": "Poland",
     "Region": "Eastern Europe",
     "Province": "West Pomeranian"
    },
    {
     "Country": "Portugal",
     "Region": "Southern Europe",
     "Province": "Alentejo (Alto Alentejo, Baixo Alentejo)"
    },
    {
     "Country": "Portugal",
     "Region": "Southern Europe",
     "Province": "Algarve"
    },
    {
     "Country": "Portugal",
     "Region": "Southern Europe",
     "Province": "Beira (Beira Alta, Beira Baixa, Beira Litoral)"
    },
    {
     "Country": "Portugal",
     "Region": "Southern Europe",
     "Province": "Douro Litoral"
    },
    {
     "Country": "Portugal",
     "Region": "Southern Europe",
     "Province": "Estremadura"
    },
    {
     "Country": "Portugal",
     "Region": "Southern Europe",
     "Province": "Minho"
    },
    {
     "Country": "Portugal",
     "Region": "Southern Europe",
     "Province": "Ribatejo"
    },
    {
     "Country": "Portugal",
     "Region": "Southern Europe",
     "Province": "Trás-os-Montes e Alto Douro"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Adjuntas"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Aguada"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Aguadilla"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Aguas Buenas"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Aibonito"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Añasco"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Arecibo"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Arroyo"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Barceloneta"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Barranquitas"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Bayamón"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Cabo Rojo"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Caguas"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Camuy"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Canóvanas"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Carolina"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Cataño"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Cayey"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Ceiba"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Ciales"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Cidra"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Coamo"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Comerío"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Corozal"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Culebra"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Dorado"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Fajardo"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Florida"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Guánica"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Guayama"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Guayanilla"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Guaynabo"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Gurabo"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Hatillo"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Hormigueros"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Humacao"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Isabela"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Jayuya"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Juana Díaz"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Juncos"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Lajas"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Lares"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Las Marías"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Las Piedras"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Loíza"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Luquillo"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Manatí"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Maricao"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Maunabo"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Mayagüez"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Moca"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Morovis"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Naguabo"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Naranjito"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Orocovis"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Patillas"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Peñuelas"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Ponce"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Quebradillas"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Rincón"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Río Grande"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Sabana Grande"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Salinas"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "San Germán"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "San Juan"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "San Lorenzo"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "San Sebastián"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Santa Isabel"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Toa Alta"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Toa Baja"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Trujillo Alto"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Utuado"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Vega Alta"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Vega Baja"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Vieques"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Villalba"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Yabucoa"
    },
    {
     "Country": "Puerto Rico",
     "Region": "Greater Antilles, Caribbean",
     "Province": "Yauco"
    },
    {
     "Country": "Qatar",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Al Shamal"
    },
    {
     "Country": "Qatar",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Al Khor"
    },
    {
     "Country": "Qatar",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Al-Shahaniya"
    },
    {
     "Country": "Qatar",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Umm Salal"
    },
    {
     "Country": "Qatar",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Al Daayen"
    },
    {
     "Country": "Qatar",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Ad Dawhah (Doha)"
    },
    {
     "Country": "Qatar",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Al Rayyan"
    },
    {
     "Country": "Qatar",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Al Wakrah"
    },
    {
     "Country": "Qatar",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Dawlat Qatar"
    },
    {
     "Country": "Reunion Island",
     "Region": "Eastern Africa",
     "Province": "Les Avirons"
    },
    {
     "Country": "Reunion Island",
     "Region": "Eastern Africa",
     "Province": "Bras-Panon"
    },
    {
     "Country": "Reunion Island",
     "Region": "Eastern Africa",
     "Province": "Cilaos"
    },
    {
     "Country": "Reunion Island",
     "Region": "Eastern Africa",
     "Province": "Entre-Deux"
    },
    {
     "Country": "Reunion Island",
     "Region": "Eastern Africa",
     "Province": "L'Étang-Salé"
    },
    {
     "Country": "Reunion Island",
     "Region": "Eastern Africa",
     "Province": "Petite-Île"
    },
    {
     "Country": "Reunion Island",
     "Region": "Eastern Africa",
     "Province": "La Plaine-des-Palmistes"
    },
    {
     "Country": "Reunion Island",
     "Region": "Eastern Africa",
     "Province": "Le Port"
    },
    {
     "Country": "Reunion Island",
     "Region": "Eastern Africa",
     "Province": "La Possession"
    },
    {
     "Country": "Reunion Island",
     "Region": "Eastern Africa",
     "Province": "Saint-André"
    },
    {
     "Country": "Reunion Island",
     "Region": "Eastern Africa",
     "Province": "Saint-Benoît"
    },
    {
     "Country": "Reunion Island",
     "Region": "Eastern Africa",
     "Province": "Saint-Denis"
    },
    {
     "Country": "Reunion Island",
     "Region": "Eastern Africa",
     "Province": "Saint-Joseph"
    },
    {
     "Country": "Reunion Island",
     "Region": "Eastern Africa",
     "Province": "Saint-Leu"
    },
    {
     "Country": "Reunion Island",
     "Region": "Eastern Africa",
     "Province": "Saint-Louis"
    },
    {
     "Country": "Reunion Island",
     "Region": "Eastern Africa",
     "Province": "Saint-Paul"
    },
    {
     "Country": "Reunion Island",
     "Region": "Eastern Africa",
     "Province": "Saint-Philippe"
    },
    {
     "Country": "Reunion Island",
     "Region": "Eastern Africa",
     "Province": "Saint-Pierre"
    },
    {
     "Country": "Reunion Island",
     "Region": "Eastern Africa",
     "Province": "Sainte-Marie"
    },
    {
     "Country": "Reunion Island",
     "Region": "Eastern Africa",
     "Province": "Sainte-Rose"
    },
    {
     "Country": "Reunion Island",
     "Region": "Eastern Africa",
     "Province": "Sainte-Suzanne"
    },
    {
     "Country": "Reunion Island",
     "Region": "Eastern Africa",
     "Province": "Salazie"
    },
    {
     "Country": "Reunion Island",
     "Region": "Eastern Africa",
     "Province": "Le Tampon"
    },
    {
     "Country": "Reunion Island",
     "Region": "Eastern Africa",
     "Province": "Les Trois-Bassins"
    },
    {
     "Country": "Romania",
     "Region": "Eastern Europe",
     "Province": "Alba"
    },
    {
     "Country": "Romania",
     "Region": "Eastern Europe",
     "Province": "Arad"
    },
    {
     "Country": "Romania",
     "Region": "Eastern Europe",
     "Province": "Argeș"
    },
    {
     "Country": "Romania",
     "Region": "Eastern Europe",
     "Province": "Bacău"
    },
    {
     "Country": "Romania",
     "Region": "Eastern Europe",
     "Province": "Bihor"
    },
    {
     "Country": "Romania",
     "Region": "Eastern Europe",
     "Province": "Bistrița-Năsăud"
    },
    {
     "Country": "Romania",
     "Region": "Eastern Europe",
     "Province": "Botoșani"
    },
    {
     "Country": "Romania",
     "Region": "Eastern Europe",
     "Province": "Brașov"
    },
    {
     "Country": "Romania",
     "Region": "Eastern Europe",
     "Province": "Brăila"
    },
    {
     "Country": "Romania",
     "Region": "Eastern Europe",
     "Province": "Bucharest"
    },
    {
     "Country": "Romania",
     "Region": "Eastern Europe",
     "Province": "Buzău"
    },
    {
     "Country": "Romania",
     "Region": "Eastern Europe",
     "Province": "Caraș-Severin"
    },
    {
     "Country": "Romania",
     "Region": "Eastern Europe",
     "Province": "Călărași"
    },
    {
     "Country": "Romania",
     "Region": "Eastern Europe",
     "Province": "Cluj"
    },
    {
     "Country": "Romania",
     "Region": "Eastern Europe",
     "Province": "Constanța"
    },
    {
     "Country": "Romania",
     "Region": "Eastern Europe",
     "Province": "Covasna"
    },
    {
     "Country": "Romania",
     "Region": "Eastern Europe",
     "Province": "Dâmbovița"
    },
    {
     "Country": "Romania",
     "Region": "Eastern Europe",
     "Province": "Dolj"
    },
    {
     "Country": "Romania",
     "Region": "Eastern Europe",
     "Province": "Galați"
    },
    {
     "Country": "Romania",
     "Region": "Eastern Europe",
     "Province": "Giurgiu"
    },
    {
     "Country": "Romania",
     "Region": "Eastern Europe",
     "Province": "Gorj"
    },
    {
     "Country": "Romania",
     "Region": "Eastern Europe",
     "Province": "Harghita"
    },
    {
     "Country": "Romania",
     "Region": "Eastern Europe",
     "Province": "Hunedoara"
    },
    {
     "Country": "Romania",
     "Region": "Eastern Europe",
     "Province": "Ialomița"
    },
    {
     "Country": "Romania",
     "Region": "Eastern Europe",
     "Province": "Iași"
    },
    {
     "Country": "Romania",
     "Region": "Eastern Europe",
     "Province": "Ilfov"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Adygea"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Bashkortostan"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Buryatia"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Altai Republic"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Dagestan"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Ingushetia"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Kabardino-Balkaria"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Kalmykia"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Karachay-Cherkessia"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Karelia"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Komi Republic"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Mari El"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Mordovia"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Sakha (Yakutia)"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "North Ossetia–Alania"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Tatarstan"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Tuva"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Udmurtia"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Khakassia"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Chechnya"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Chuvashia"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Altai Krai"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Krasnodar Krai"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Krasnoyarsk Krai"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Primorsky Krai"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Stavropol Krai"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Khabarovsk Krai"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Amur Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Arkhangelsk Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Astrakhan Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Belgorod Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Bryansk Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Vladimir Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Volgograd Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Vologda Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Voronezh Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Ivanovo Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Irkutsk Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Kaliningrad Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Kaluga Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Kamchatka Krai"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Kemerovo Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Kirov Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Kostroma Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Kurgan Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Kursk Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Leningrad Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Lipetsk Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Magadan Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Moscow Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Murmansk Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Nizhny Novgorod Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Novgorod Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Novosibirsk Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Omsk Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Orenburg Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Oryol Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Penza Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Perm Krai"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Pskov Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Rostov Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Ryazan Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Samara Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Saratov Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Sakhalin Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Sverdlovsk Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Smolensk Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Tambov Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Tver Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Tomsk Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Tula Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Tyumen Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Ulyanovsk Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Chelyabinsk Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Zabaykalsky Krai"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Yaroslavl Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Moscow"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Saint Petersburg"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Jewish Autonomous Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Nenets Autonomous Okrug"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Khanty–Mansi Autonomous Okrug – Yugra"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Chukotka Autonomous Okrug"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Yamalo-Nenets Autonomous Okrug"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Republic of Crimea"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Sevastopol"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Donetsk People's Republic"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Luhansk People's Republic"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Zaporozhye Oblast"
    },
    {
     "Country": "Russian Federation",
     "Region": "Eastern Europe - Northern Asia",
     "Province": "Kherson Oblast"
    },
    {
     "Country": "Rwanda",
     "Region": "Eastern Africa, African Great Lakes",
     "Province": "Umujyi wa Kigali"
    },
    {
     "Country": "Rwanda",
     "Region": "Eastern Africa, African Great Lakes",
     "Province": "Amajyepfo"
    },
    {
     "Country": "Rwanda",
     "Region": "Eastern Africa, African Great Lakes",
     "Province": "Iburengerazuba"
    },
    {
     "Country": "Rwanda",
     "Region": "Eastern Africa, African Great Lakes",
     "Province": "Amajyaruguru"
    },
    {
     "Country": "Rwanda",
     "Region": "Eastern Africa, African Great Lakes",
     "Province": "Iburasirazuba"
    },
    {
     "Country": "Saint Kitts and Nevis",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Nichola Town"
    },
    {
     "Country": "Saint Kitts and Nevis",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Sandy Point Town"
    },
    {
     "Country": "Saint Kitts and Nevis",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Basseterre"
    },
    {
     "Country": "Saint Kitts and Nevis",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Dieppe Bay Town"
    },
    {
     "Country": "Saint Kitts and Nevis",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Cayon"
    },
    {
     "Country": "Saint Kitts and Nevis",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Saint Paul Capisterre"
    },
    {
     "Country": "Saint Kitts and Nevis",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Monkey Hill"
    },
    {
     "Country": "Saint Kitts and Nevis",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Middle Island"
    },
    {
     "Country": "Saint Kitts and Nevis",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Trinity"
    },
    {
     "Country": "Saint Kitts and Nevis",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Market Shop"
    },
    {
     "Country": "Saint Kitts and Nevis",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Newcastle"
    },
    {
     "Country": "Saint Kitts and Nevis",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Figtree"
    },
    {
     "Country": "Saint Kitts and Nevis",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Charlestown"
    },
    {
     "Country": "Saint Kitts and Nevis",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Cotton Ground"
    },
    {
     "Country": "Saint Lucia",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Anse la Raye"
    },
    {
     "Country": "Saint Lucia",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Canaries"
    },
    {
     "Country": "Saint Lucia",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Castries"
    },
    {
     "Country": "Saint Lucia",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Choiseul"
    },
    {
     "Country": "Saint Lucia",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Dennery"
    },
    {
     "Country": "Saint Lucia",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Gros Islet"
    },
    {
     "Country": "Saint Lucia",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Laborie"
    },
    {
     "Country": "Saint Lucia",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Micoud"
    },
    {
     "Country": "Saint Lucia",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Soufrière"
    },
    {
     "Country": "Saint Lucia",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Vieux Fort"
    },
    {
     "Country": "Saint Vincent and the Grenadines",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Georgetown"
    },
    {
     "Country": "Saint Vincent and the Grenadines",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Port Elizabeth"
    },
    {
     "Country": "Saint Vincent and the Grenadines",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Layou"
    },
    {
     "Country": "Saint Vincent and the Grenadines",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Chateaubelair"
    },
    {
     "Country": "Saint Vincent and the Grenadines",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Kingstown"
    },
    {
     "Country": "Saint Vincent and the Grenadines",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Barrouallie"
    },
    {
     "Country": "Samoa",
     "Region": "Polynesia, Oceania",
     "Province": " Tuamasaga "
    },
    {
     "Country": "Samoa",
     "Region": "Polynesia, Oceania",
     "Province": " Aʻana "
    },
    {
     "Country": "Samoa",
     "Region": "Polynesia, Oceania",
     "Province": " Aiga-i-le-Tai "
    },
    {
     "Country": "Samoa",
     "Region": "Polynesia, Oceania",
     "Province": " Atua "
    },
    {
     "Country": "Samoa",
     "Region": "Polynesia, Oceania",
     "Province": " Vaʻa-o-Fonoti "
    },
    {
     "Country": "Samoa",
     "Region": "Polynesia, Oceania",
     "Province": " Faʻasaleleaga "
    },
    {
     "Country": "Samoa",
     "Region": "Polynesia, Oceania",
     "Province": " Gagaʻemauga "
    },
    {
     "Country": "Samoa",
     "Region": "Polynesia, Oceania",
     "Province": " Gagaʻifomauga "
    },
    {
     "Country": "Samoa",
     "Region": "Polynesia, Oceania",
     "Province": " Vaisigano "
    },
    {
     "Country": "Samoa",
     "Region": "Polynesia, Oceania",
     "Province": " Satupaʻitea "
    },
    {
     "Country": "Samoa",
     "Region": "Polynesia, Oceania",
     "Province": " Palauli "
    },
    {
     "Country": "San Marino",
     "Region": "Southern Europe within Italy",
     "Province": "Serravalle"
    },
    {
     "Country": "San Marino",
     "Region": "Southern Europe within Italy",
     "Province": "Borgo Maggiore"
    },
    {
     "Country": "San Marino",
     "Region": "Southern Europe within Italy",
     "Province": "City of San Marino"
    },
    {
     "Country": "San Marino",
     "Region": "Southern Europe within Italy",
     "Province": "Domagnano"
    },
    {
     "Country": "San Marino",
     "Region": "Southern Europe within Italy",
     "Province": "Fiorentino"
    },
    {
     "Country": "San Marino",
     "Region": "Southern Europe within Italy",
     "Province": "Acquaviva"
    },
    {
     "Country": "San Marino",
     "Region": "Southern Europe within Italy",
     "Province": "Faetano"
    },
    {
     "Country": "San Marino",
     "Region": "Southern Europe within Italy",
     "Province": "Chiesanuova"
    },
    {
     "Country": "San Marino",
     "Region": "Southern Europe within Italy",
     "Province": "Montegiardino"
    },
    {
     "Country": "Sao Tome and Principe",
     "Region": "Central Africa",
     "Province": "Água Grande"
    },
    {
     "Country": "Sao Tome and Principe",
     "Region": "Central Africa",
     "Province": "Cantagalo"
    },
    {
     "Country": "Sao Tome and Principe",
     "Region": "Central Africa",
     "Province": "Caué"
    },
    {
     "Country": "Sao Tome and Principe",
     "Region": "Central Africa",
     "Province": "Lembá"
    },
    {
     "Country": "Sao Tome and Principe",
     "Region": "Central Africa",
     "Province": "Lobata"
    },
    {
     "Country": "Sao Tome and Principe",
     "Region": "Central Africa",
     "Province": "Mé-Zóchi"
    },
    {
     "Country": "Sao Tome and Principe",
     "Region": "Central Africa",
     "Province": "Pagué"
    },
    {
     "Country": "Saudi Arabia",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "'Asir Province"
    },
    {
     "Country": "Saudi Arabia",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Al-Bahah Province"
    },
    {
     "Country": "Saudi Arabia",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Al-Jawf Province"
    },
    {
     "Country": "Saudi Arabia",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Al-Qassim Province"
    },
    {
     "Country": "Saudi Arabia",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Eastern Province"
    },
    {
     "Country": "Saudi Arabia",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Ḥa'il Province"
    },
    {
     "Country": "Saudi Arabia",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Jazan Province"
    },
    {
     "Country": "Saudi Arabia",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Mecca Province"
    },
    {
     "Country": "Saudi Arabia",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Medina Province"
    },
    {
     "Country": "Saudi Arabia",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Najran Province"
    },
    {
     "Country": "Saudi Arabia",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Northern Borders Province"
    },
    {
     "Country": "Saudi Arabia",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Riyadh Province"
    },
    {
     "Country": "Saudi Arabia",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Tabuk Province"
    },
    {
     "Country": "Senegal",
     "Region": "West Africa",
     "Province": "Dakar"
    },
    {
     "Country": "Senegal",
     "Region": "West Africa",
     "Province": "Diourbel"
    },
    {
     "Country": "Senegal",
     "Region": "West Africa",
     "Province": "Fatick"
    },
    {
     "Country": "Senegal",
     "Region": "West Africa",
     "Province": "Kaffrine"
    },
    {
     "Country": "Senegal",
     "Region": "West Africa",
     "Province": "Kaolack"
    },
    {
     "Country": "Senegal",
     "Region": "West Africa",
     "Province": "Kédougou"
    },
    {
     "Country": "Senegal",
     "Region": "West Africa",
     "Province": "Kolda"
    },
    {
     "Country": "Senegal",
     "Region": "West Africa",
     "Province": "Louga"
    },
    {
     "Country": "Senegal",
     "Region": "West Africa",
     "Province": "Matam"
    },
    {
     "Country": "Senegal",
     "Region": "West Africa",
     "Province": "Saint-Louis"
    },
    {
     "Country": "Senegal",
     "Region": "West Africa",
     "Province": "Sédhiou"
    },
    {
     "Country": "Senegal",
     "Region": "West Africa",
     "Province": "Tambacounda"
    },
    {
     "Country": "Senegal",
     "Region": "West Africa",
     "Province": "Thiès"
    },
    {
     "Country": "Senegal",
     "Region": "West Africa",
     "Province": "Ziguinchor"
    },
    {
     "Country": "Serbia",
     "Region": "Southern Europe",
     "Province": "City of Belgrade"
    },
    {
     "Country": "Seychelles",
     "Region": "Eastern Africa",
     "Province": "Bor District"
    },
    {
     "Country": "Sierra Leone",
     "Region": "West Africa",
     "Province": "Braničevo District"
    },
    {
     "Country": "Singapore",
     "Region": "Southeast Asia",
     "Province": "Central Banat District"
    },
    {
     "Country": "Slovakia (Slovak Republic)",
     "Region": "Eastern Europe",
     "Province": "Jablanica District"
    },
    {
     "Country": "Slovenia",
     "Region": "Southern Europe",
     "Province": "Kolubara District"
    },
    {
     "Country": "Solomon Islands",
     "Region": "Melanesia, Oceania",
     "Province": "Mačva District"
    },
    {
     "Country": "Somalia",
     "Region": "Eastern Africa",
     "Province": "Moravica District"
    },
    {
     "Country": "South Africa",
     "Region": "Southern Africa",
     "Province": "Nišava District"
    },
    {
     "Country": "South Sudan",
     "Region": "East-Central Africa",
     "Province": "North Bačka District"
    },
    {
     "Country": "Spain",
     "Region": "Southern Europe",
     "Province": "North Banat District"
    },
    {
     "Country": "Sri Lanka",
     "Region": "South-Central Asia",
     "Province": "Pčinja District"
    },
    {
     "Country": "Sudan",
     "Region": "Northern Africa",
     "Province": "Pirot District"
    },
    {
     "Country": "Suriname",
     "Region": "North-Eastern South America",
     "Province": "Podunavlje District"
    },
    {
     "Country": "Swaziland (Eswatini)",
     "Region": "Southern Africa",
     "Province": "Pomoravlje District"
    },
    {
     "Country": "Sweden",
     "Region": "Northern Europe",
     "Province": "Raška District"
    },
    {
     "Country": "Switzerland",
     "Region": "Western Europe",
     "Province": "Rasina District"
    },
    {
     "Country": "Syria, Syrian Arab Republic",
     "Region": "Middle East, Western Asia",
     "Province": "South Bačka District"
    },
    {
     "Country": "Taiwan (Republic of China)",
     "Region": "Eastern Asia",
     "Province": "South Banat District"
    },
    {
     "Country": "Tajikistan",
     "Region": "Central Asia",
     "Province": "Srem District"
    },
    {
     "Country": "Tanzania; officially the United Republic of Tanzania",
     "Region": "Eastern Africa",
     "Province": "Šumadija District"
    },
    {
     "Country": "Thailand",
     "Region": "South-East Asia",
     "Province": "Toplica District"
    },
    {
     "Country": "Tibet",
     "Region": "South-Central Asia",
     "Province": "West Bačka District"
    },
    {
     "Country": "Timor-Leste (East Timor)",
     "Region": "Maritime South-East Asia",
     "Province": "Zaječar District"
    },
    {
     "Country": "Togo",
     "Region": "West Africa",
     "Province": "Zlatibor District"
    },
    {
     "Country": "Tokelau",
     "Region": "Oceania\/Australia",
     "Province": "Kosovo District (Kosovo)"
    },
    {
     "Country": "Tonga",
     "Region": "Polynesia, Oceania",
     "Province": "Kosovo-Pomoravlje District (Kosovo)"
    },
    {
     "Country": "Trinidad and Tobago",
     "Region": "Northern South America, Caribbean",
     "Province": "Kosovska Mitrovica District (Kosovo)"
    },
    {
     "Country": "Tunisia",
     "Region": "Northern Africa",
     "Province": "Peć District (Kosovo)"
    },
    {
     "Country": "Turkey",
     "Region": "Southeastern Europe, Western Asia",
     "Province": "Prizren District (Kosovo)"
    },
    {
     "Country": "Turkmenistan",
     "Region": "Central Asia",
     "Province": " Bagtyýarlyk etraby"
    },
    {
     "Country": "Turkmenistan",
     "Region": "Central Asia",
     "Province": " Berkararlyk etraby"
    },
    {
     "Country": "Turkmenistan",
     "Region": "Central Asia",
     "Province": " Büzmeýin etraby"
    },
    {
     "Country": "Turkmenistan",
     "Region": "Central Asia",
     "Province": " Köpetdag etraby"
    },
    {
     "Country": "Turkmenistan",
     "Region": "Central Asia",
     "Province": " Ak bugdaý "
    },
    {
     "Country": "Turkmenistan",
     "Region": "Central Asia",
     "Province": " Babadaýhan"
    },
    {
     "Country": "Turkmenistan",
     "Region": "Central Asia",
     "Province": " Bäherden "
    },
    {
     "Country": "Turkmenistan",
     "Region": "Central Asia",
     "Province": " Gökdepe"
    },
    {
     "Country": "Turkmenistan",
     "Region": "Central Asia",
     "Province": " Kaka"
    },
    {
     "Country": "Turkmenistan",
     "Region": "Central Asia",
     "Province": " Sarahs"
    },
    {
     "Country": "Turkmenistan",
     "Region": "Central Asia",
     "Province": " Tejen"
    },
    {
     "Country": "Turkmenistan",
     "Region": "Central Asia",
     "Province": " Bereket "
    },
    {
     "Country": "Turkmenistan",
     "Region": "Central Asia",
     "Province": " Esenguly"
    },
    {
     "Country": "Turkmenistan",
     "Region": "Central Asia",
     "Province": " Etrek "
    },
    {
     "Country": "Turkmenistan",
     "Region": "Central Asia",
     "Province": " Gyzylarbat "
    },
    {
     "Country": "Turkmenistan",
     "Region": "Central Asia",
     "Province": " Magtymguly "
    },
    {
     "Country": "Turkmenistan",
     "Region": "Central Asia",
     "Province": " Türkmenbaşy"
    },
    {
     "Country": "Turkmenistan",
     "Region": "Central Asia",
     "Province": " Awaza etraby"
    },
    {
     "Country": "Turkmenistan",
     "Region": "Central Asia",
     "Province": " Akdepe"
    },
    {
     "Country": "Turkmenistan",
     "Region": "Central Asia",
     "Province": " Boldumsaz"
    },
    {
     "Country": "Turkmenistan",
     "Region": "Central Asia",
     "Province": " Görogly "
    },
    {
     "Country": "Turkmenistan",
     "Region": "Central Asia",
     "Province": " Köneurgenç"
    },
    {
     "Country": "Turkmenistan",
     "Region": "Central Asia",
     "Province": " Ruhubelent"
    },
    {
     "Country": "Turkmenistan",
     "Region": "Central Asia",
     "Province": " Shabat "
    },
    {
     "Country": "Turkmenistan",
     "Region": "Central Asia",
     "Province": " Saparmyrat Türkmenbaşy"
    },
    {
     "Country": "Turkmenistan",
     "Region": "Central Asia",
     "Province": " Çärjew "
    },
    {
     "Country": "Turkmenistan",
     "Region": "Central Asia",
     "Province": " Dänew "
    },
    {
     "Country": "Turkmenistan",
     "Region": "Central Asia",
     "Province": " Darganata "
    },
    {
     "Country": "Turkmenistan",
     "Region": "Central Asia",
     "Province": " Halaç"
    },
    {
     "Country": "Turkmenistan",
     "Region": "Central Asia",
     "Province": " Hojambaz"
    },
    {
     "Country": "Turkmenistan",
     "Region": "Central Asia",
     "Province": " Kerki "
    },
    {
     "Country": "Turkmenistan",
     "Region": "Central Asia",
     "Province": " Köýtendag "
    },
    {
     "Country": "Turkmenistan",
     "Region": "Central Asia",
     "Province": " Saýat"
    },
    {
     "Country": "Turkmenistan",
     "Region": "Central Asia",
     "Province": " Baýramaly"
    },
    {
     "Country": "Turkmenistan",
     "Region": "Central Asia",
     "Province": " Garagum"
    },
    {
     "Country": "Turkmenistan",
     "Region": "Central Asia",
     "Province": " Mary"
    },
    {
     "Country": "Turkmenistan",
     "Region": "Central Asia",
     "Province": " Murgap"
    },
    {
     "Country": "Turkmenistan",
     "Region": "Central Asia",
     "Province": " Sakarçäge"
    },
    {
     "Country": "Turkmenistan",
     "Region": "Central Asia",
     "Province": " Tagtabazar"
    },
    {
     "Country": "Turkmenistan",
     "Region": "Central Asia",
     "Province": " Türkmengala"
    },
    {
     "Country": "Turkmenistan",
     "Region": "Central Asia",
     "Province": " Wekilbazar"
    },
    {
     "Country": "Turkmenistan",
     "Region": "Central Asia",
     "Province": " Ýolöten"
    },
    {
     "Country": "Turks and Caicos Islands",
     "Region": "Caribbean, parts of the Bahamas island chain.",
     "Province": "Ambergris Cays"
    },
    {
     "Country": "Turks and Caicos Islands",
     "Region": "Caribbean, parts of the Bahamas island chain.",
     "Province": "Big Ambergris Cay"
    },
    {
     "Country": "Turks and Caicos Islands",
     "Region": "Caribbean, parts of the Bahamas island chain.",
     "Province": "Little Ambergris Cay"
    },
    {
     "Country": "Turks and Caicos Islands",
     "Region": "Caribbean, parts of the Bahamas island chain.",
     "Province": "Bay Cay"
    },
    {
     "Country": "Turks and Caicos Islands",
     "Region": "Caribbean, parts of the Bahamas island chain.",
     "Province": "Bush Cay"
    },
    {
     "Country": "Turks and Caicos Islands",
     "Region": "Caribbean, parts of the Bahamas island chain.",
     "Province": "Dellis Cay"
    },
    {
     "Country": "Turks and Caicos Islands",
     "Region": "Caribbean, parts of the Bahamas island chain.",
     "Province": "Donna Cay"
    },
    {
     "Country": "Turks and Caicos Islands",
     "Region": "Caribbean, parts of the Bahamas island chain.",
     "Province": "Dove Cay"
    },
    {
     "Country": "Turks and Caicos Islands",
     "Region": "Caribbean, parts of the Bahamas island chain.",
     "Province": "East Bay Cay"
    },
    {
     "Country": "Turks and Caicos Islands",
     "Region": "Caribbean, parts of the Bahamas island chain.",
     "Province": "East Caicos"
    },
    {
     "Country": "Turks and Caicos Islands",
     "Region": "Caribbean, parts of the Bahamas island chain.",
     "Province": "Fish Cays"
    },
    {
     "Country": "Turks and Caicos Islands",
     "Region": "Caribbean, parts of the Bahamas island chain.",
     "Province": "Five Cays"
    },
    {
     "Country": "Turks and Caicos Islands",
     "Region": "Caribbean, parts of the Bahamas island chain.",
     "Province": "Five Little Cays"
    },
    {
     "Country": "Turks and Caicos Islands",
     "Region": "Caribbean, parts of the Bahamas island chain.",
     "Province": "Fort George Cay"
    },
    {
     "Country": "Turks and Caicos Islands",
     "Region": "Caribbean, parts of the Bahamas island chain.",
     "Province": "French Cay"
    },
    {
     "Country": "Turks and Caicos Islands",
     "Region": "Caribbean, parts of the Bahamas island chain.",
     "Province": "Little Water Cay"
    },
    {
     "Country": "Turks and Caicos Islands",
     "Region": "Caribbean, parts of the Bahamas island chain.",
     "Province": "Long Cay"
    },
    {
     "Country": "Turks and Caicos Islands",
     "Region": "Caribbean, parts of the Bahamas island chain.",
     "Province": "Mangrove Cay"
    },
    {
     "Country": "Turks and Caicos Islands",
     "Region": "Caribbean, parts of the Bahamas island chain.",
     "Province": "Middle Caicos"
    },
    {
     "Country": "Turks and Caicos Islands",
     "Region": "Caribbean, parts of the Bahamas island chain.",
     "Province": "Middleton Cay"
    },
    {
     "Country": "Turks and Caicos Islands",
     "Region": "Caribbean, parts of the Bahamas island chain.",
     "Province": "North Caicos"
    },
    {
     "Country": "Turks and Caicos Islands",
     "Region": "Caribbean, parts of the Bahamas island chain.",
     "Province": "Parrot Cay"
    },
    {
     "Country": "Turks and Caicos Islands",
     "Region": "Caribbean, parts of the Bahamas island chain.",
     "Province": "Pine Cay"
    },
    {
     "Country": "Turks and Caicos Islands",
     "Region": "Caribbean, parts of the Bahamas island chain.",
     "Province": "Plandon Cay"
    },
    {
     "Country": "Turks and Caicos Islands",
     "Region": "Caribbean, parts of the Bahamas island chain.",
     "Province": "Providenciales"
    },
    {
     "Country": "Turks and Caicos Islands",
     "Region": "Caribbean, parts of the Bahamas island chain.",
     "Province": "Seal Cays"
    },
    {
     "Country": "Turks and Caicos Islands",
     "Region": "Caribbean, parts of the Bahamas island chain.",
     "Province": "Six Hill Cays"
    },
    {
     "Country": "Turks and Caicos Islands",
     "Region": "Caribbean, parts of the Bahamas island chain.",
     "Province": "South Caicos"
    },
    {
     "Country": "Turks and Caicos Islands",
     "Region": "Caribbean, parts of the Bahamas island chain.",
     "Province": "Stubbs Cay"
    },
    {
     "Country": "Turks and Caicos Islands",
     "Region": "Caribbean, parts of the Bahamas island chain.",
     "Province": "Water Cay"
    },
    {
     "Country": "Turks and Caicos Islands",
     "Region": "Caribbean, parts of the Bahamas island chain.",
     "Province": "West Caicos"
    },
    {
     "Country": "Turks and Caicos Islands",
     "Region": "Caribbean, parts of the Bahamas island chain.",
     "Province": "West Sand Spit"
    },
    {
     "Country": "Tuvalu",
     "Region": "Polynesia, Oceania",
     "Province": "Funafuti"
    },
    {
     "Country": "Tuvalu",
     "Region": "Polynesia, Oceania",
     "Province": "Nanumanga"
    },
    {
     "Country": "Tuvalu",
     "Region": "Polynesia, Oceania",
     "Province": "Nanumea"
    },
    {
     "Country": "Tuvalu",
     "Region": "Polynesia, Oceania",
     "Province": "Niulakita"
    },
    {
     "Country": "Tuvalu",
     "Region": "Polynesia, Oceania",
     "Province": "Niutao"
    },
    {
     "Country": "Tuvalu",
     "Region": "Polynesia, Oceania",
     "Province": "Nui"
    },
    {
     "Country": "Tuvalu",
     "Region": "Polynesia, Oceania",
     "Province": "Nukufetau"
    },
    {
     "Country": "Tuvalu",
     "Region": "Polynesia, Oceania",
     "Province": "Nukulaelae"
    },
    {
     "Country": "Tuvalu",
     "Region": "Polynesia, Oceania",
     "Province": "Vaitupu"
    },
    {
     "Country": "Uganda",
     "Region": "Eastern Africa",
     "Province": "Kampala"
    },
    {
     "Country": "Uganda",
     "Region": "Eastern Africa",
     "Province": "Mbarara"
    },
    {
     "Country": "Uganda",
     "Region": "Eastern Africa",
     "Province": "Mbale"
    },
    {
     "Country": "Uganda",
     "Region": "Eastern Africa",
     "Province": "Gulu"
    },
    {
     "Country": "Ukraine",
     "Region": "Eastern Europe",
     "Province": " Cherkasy Oblast"
    },
    {
     "Country": "Ukraine",
     "Region": "Eastern Europe",
     "Province": " Chernihiv Oblast"
    },
    {
     "Country": "Ukraine",
     "Region": "Eastern Europe",
     "Province": " Chernivtsi Oblast"
    },
    {
     "Country": "Ukraine",
     "Region": "Eastern Europe",
     "Province": " Dnipropetrovsk Oblast"
    },
    {
     "Country": "Ukraine",
     "Region": "Eastern Europe",
     "Province": " Donetsk Oblast"
    },
    {
     "Country": "Ukraine",
     "Region": "Eastern Europe",
     "Province": " Ivano-Frankivsk Oblast"
    },
    {
     "Country": "Ukraine",
     "Region": "Eastern Europe",
     "Province": " Kharkiv Oblast"
    },
    {
     "Country": "Ukraine",
     "Region": "Eastern Europe",
     "Province": " Kherson Oblast"
    },
    {
     "Country": "Ukraine",
     "Region": "Eastern Europe",
     "Province": " Khmelnytskyi Oblast"
    },
    {
     "Country": "Ukraine",
     "Region": "Eastern Europe",
     "Province": " Kirovohrad Oblast"
    },
    {
     "Country": "Ukraine",
     "Region": "Eastern Europe",
     "Province": " Kyiv Oblast"
    },
    {
     "Country": "Ukraine",
     "Region": "Eastern Europe",
     "Province": " Luhansk Oblast"
    },
    {
     "Country": "Ukraine",
     "Region": "Eastern Europe",
     "Province": " Lviv Oblast"
    },
    {
     "Country": "Ukraine",
     "Region": "Eastern Europe",
     "Province": " Mykolaiv Oblast"
    },
    {
     "Country": "Ukraine",
     "Region": "Eastern Europe",
     "Province": " Odesa Oblast"
    },
    {
     "Country": "Ukraine",
     "Region": "Eastern Europe",
     "Province": " Poltava Oblast"
    },
    {
     "Country": "Ukraine",
     "Region": "Eastern Europe",
     "Province": " Rivne Oblast"
    },
    {
     "Country": "Ukraine",
     "Region": "Eastern Europe",
     "Province": " Sumy Oblast"
    },
    {
     "Country": "Ukraine",
     "Region": "Eastern Europe",
     "Province": " Ternopil Oblast"
    },
    {
     "Country": "Ukraine",
     "Region": "Eastern Europe",
     "Province": " Vinnytsia Oblast"
    },
    {
     "Country": "Ukraine",
     "Region": "Eastern Europe",
     "Province": " Volyn Oblast"
    },
    {
     "Country": "Ukraine",
     "Region": "Eastern Europe",
     "Province": " Zakarpattia Oblast"
    },
    {
     "Country": "Ukraine",
     "Region": "Eastern Europe",
     "Province": " Zaporizhzhia Oblast"
    },
    {
     "Country": "Ukraine",
     "Region": "Eastern Europe",
     "Province": " Zhytomyr Oblast"
    },
    {
     "Country": "United Arab Emirates",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Abu Dhabi"
    },
    {
     "Country": "United Arab Emirates",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Ajman"
    },
    {
     "Country": "United Arab Emirates",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Dubai"
    },
    {
     "Country": "United Arab Emirates",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Fujairah"
    },
    {
     "Country": "United Arab Emirates",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Ras Al Khaimah"
    },
    {
     "Country": "United Arab Emirates",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Sharjah"
    },
    {
     "Country": "United Arab Emirates",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Umm Al Quwain"
    },
    {
     "Country": "United Kingdom",
     "Region": "Northern Europe",
     "Province": "Nation"
    },
    {
     "Country": "United Kingdom",
     "Region": "Northern Europe",
     "Province": "England"
    },
    {
     "Country": "United Kingdom",
     "Region": "Northern Europe",
     "Province": "Scotland"
    },
    {
     "Country": "United Kingdom",
     "Region": "Northern Europe",
     "Province": "Wales"
    },
    {
     "Country": "United Kingdom",
     "Region": "Northern Europe",
     "Province": "Northern Ireland"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " Alabama"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " Alaska"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " Arizona"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " Arkansas"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " California"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " Colorado"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " Connecticut"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " Delaware"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " Florida"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " Georgia"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " Hawaii"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " Idaho"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " Illinois"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " Indiana"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " Iowa"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " Kansas"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " Kentucky"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " Louisiana"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " Maine"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " Maryland"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " Massachusetts"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " Michigan"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " Minnesota"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " Mississippi"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " Missouri"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " Montana"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " Nebraska"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " Nevada"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " New Hampshire"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " New Jersey"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " New Mexico"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " New York"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " North Carolina"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " North Dakota"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " Ohio"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " Oklahoma"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " Oregon"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " Pennsylvania"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " Rhode Island"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " South Carolina"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " South Dakota"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " Tennessee"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " Texas"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " Utah"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " Vermont"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " Virginia"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " Washington"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " West Virginia"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " Wisconsin"
    },
    {
     "Country": "United States",
     "Region": "North America",
     "Province": " Wyoming"
    },
    {
     "Country": "Uruguay",
     "Region": "Central East South America",
     "Province": "Artigas"
    },
    {
     "Country": "Uruguay",
     "Region": "Central East South America",
     "Province": "Canelones"
    },
    {
     "Country": "Uruguay",
     "Region": "Central East South America",
     "Province": "Cerro Largo"
    },
    {
     "Country": "Uruguay",
     "Region": "Central East South America",
     "Province": "Colonia"
    },
    {
     "Country": "Uruguay",
     "Region": "Central East South America",
     "Province": "Durazno"
    },
    {
     "Country": "Uruguay",
     "Region": "Central East South America",
     "Province": "Flores"
    },
    {
     "Country": "Uruguay",
     "Region": "Central East South America",
     "Province": "Florida"
    },
    {
     "Country": "Uruguay",
     "Region": "Central East South America",
     "Province": "Lavalleja"
    },
    {
     "Country": "Uruguay",
     "Region": "Central East South America",
     "Province": "Maldonado"
    },
    {
     "Country": "Uruguay",
     "Region": "Central East South America",
     "Province": "Montevideo"
    },
    {
     "Country": "Uruguay",
     "Region": "Central East South America",
     "Province": "Paysandú"
    },
    {
     "Country": "Uruguay",
     "Region": "Central East South America",
     "Province": "Río Negro"
    },
    {
     "Country": "Uruguay",
     "Region": "Central East South America",
     "Province": "Rivera"
    },
    {
     "Country": "Uruguay",
     "Region": "Central East South America",
     "Province": "Rocha"
    },
    {
     "Country": "Uruguay",
     "Region": "Central East South America",
     "Province": "Salto"
    },
    {
     "Country": "Uruguay",
     "Region": "Central East South America",
     "Province": "San José"
    },
    {
     "Country": "Uruguay",
     "Region": "Central East South America",
     "Province": "Soriano"
    },
    {
     "Country": "Uruguay",
     "Region": "Central East South America",
     "Province": "Tacuarembó"
    },
    {
     "Country": "Uruguay",
     "Region": "Central East South America",
     "Province": "Treinta y Tres  "
    },
    {
     "Country": "Uzbekistan",
     "Region": "Central Asia",
     "Province": "Tashkent"
    },
    {
     "Country": "Uzbekistan",
     "Region": "Central Asia",
     "Province": "Andijan Region"
    },
    {
     "Country": "Uzbekistan",
     "Region": "Central Asia",
     "Province": "Bukhara Region"
    },
    {
     "Country": "Uzbekistan",
     "Region": "Central Asia",
     "Province": "Fergana Region"
    },
    {
     "Country": "Uzbekistan",
     "Region": "Central Asia",
     "Province": "Jizzakh Region"
    },
    {
     "Country": "Uzbekistan",
     "Region": "Central Asia",
     "Province": "Namangan Region"
    },
    {
     "Country": "Uzbekistan",
     "Region": "Central Asia",
     "Province": "Navoiy Region"
    },
    {
     "Country": "Uzbekistan",
     "Region": "Central Asia",
     "Province": "Qashqadaryo Region"
    },
    {
     "Country": "Uzbekistan",
     "Region": "Central Asia",
     "Province": "Samarqand Region"
    },
    {
     "Country": "Uzbekistan",
     "Region": "Central Asia",
     "Province": "Sirdaryo Region"
    },
    {
     "Country": "Uzbekistan",
     "Region": "Central Asia",
     "Province": "Surxondaryo Region"
    },
    {
     "Country": "Uzbekistan",
     "Region": "Central Asia",
     "Province": "Tashkent Region"
    },
    {
     "Country": "Uzbekistan",
     "Region": "Central Asia",
     "Province": "Xorazm Region"
    },
    {
     "Country": "Uzbekistan",
     "Region": "Central Asia",
     "Province": "Republic of Karakalpakstan"
    },
    {
     "Country": "Vanuatu",
     "Region": "Melanesia, Oceania",
     "Province": " Malampa"
    },
    {
     "Country": "Vanuatu",
     "Region": "Melanesia, Oceania",
     "Province": " Penama"
    },
    {
     "Country": "Vanuatu",
     "Region": "Melanesia, Oceania",
     "Province": " Sanma"
    },
    {
     "Country": "Vanuatu",
     "Region": "Melanesia, Oceania",
     "Province": " Shefa"
    },
    {
     "Country": "Vanuatu",
     "Region": "Melanesia, Oceania",
     "Province": " Tafea"
    },
    {
     "Country": "Vanuatu",
     "Region": "Melanesia, Oceania",
     "Province": " Torba"
    },
    {
     "Country": "Vanuatu",
     "Region": "Melanesia, Oceania",
     "Province": " Vanuatu"
    },
    {
     "Country": "Venezuela",
     "Region": "Northern South America",
     "Province": "Andean"
    },
    {
     "Country": "Venezuela",
     "Region": "Northern South America",
     "Province": "Capital"
    },
    {
     "Country": "Venezuela",
     "Region": "Northern South America",
     "Province": "Central"
    },
    {
     "Country": "Venezuela",
     "Region": "Northern South America",
     "Province": "Central-Western"
    },
    {
     "Country": "Venezuela",
     "Region": "Northern South America",
     "Province": "Guayana"
    },
    {
     "Country": "Venezuela",
     "Region": "Northern South America",
     "Province": "Insular"
    },
    {
     "Country": "Venezuela",
     "Region": "Northern South America",
     "Province": "Los Llanos"
    },
    {
     "Country": "Venezuela",
     "Region": "Northern South America",
     "Province": "Eastern"
    },
    {
     "Country": "Venezuela",
     "Region": "Northern South America",
     "Province": "Zulian"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Bắc Giang province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Bắc Kạn province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Cao Bằng province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Hà Giang province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Lạng Sơn province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Phú Thọ province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Quảng Ninh province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Thái Nguyên province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Tuyên Quang province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Lào Cai province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Yên Bái province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Điện Biên province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Hòa Bình province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Lai Châu province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Sơn La province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Bắc Ninh province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Hà Nam province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Hải Dương province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Hưng Yên province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Nam Định province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Ninh Bình province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Thái Bình province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Vĩnh Phúc province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Hà Nội city"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Hải Phòng city"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Hà Tĩnh province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Nghệ An province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Quảng Bình province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Quảng Trị province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Thanh Hóa province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Thừa Thiên Huế province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Đắk Lắk province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Đăk Nông province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Gia Lai province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Kon Tum province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Lâm Đồng province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Bình Định province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Bình Thuận province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Khánh Hòa province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Ninh Thuận province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Phú Yên province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Quảng Nam province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Quảng Ngãi province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Đà Nẵng city"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Bà Rịa–Vũng Tàu province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Bình Dương province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Bình Phước province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Đồng Nai province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Tây Ninh province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Hồ Chí Minh City"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "An Giang province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Bạc Liêu province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Bến Tre province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Cà Mau province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Đồng Tháp province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Hậu Giang province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Kiên Giang province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Long An province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Sóc Trăng province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Tiền Giang province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Trà Vinh province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Vĩnh Long province"
    },
    {
     "Country": "Vietnam",
     "Region": "South-East Asia",
     "Province": "Cần Thơ city"
    },
    {
     "Country": "Virgin Islands (British)",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Methodist"
    },
    {
     "Country": "Virgin Islands (British)",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Church of God"
    },
    {
     "Country": "Virgin Islands (British)",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Anglican"
    },
    {
     "Country": "Virgin Islands (British)",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Seventh Day Adventist"
    },
    {
     "Country": "Virgin Islands (British)",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Roman Catholic"
    },
    {
     "Country": "Virgin Islands (British)",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Pentecostal"
    },
    {
     "Country": "Virgin Islands (British)",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "None"
    },
    {
     "Country": "Virgin Islands (British)",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Baptist"
    },
    {
     "Country": "Virgin Islands (British)",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Other"
    },
    {
     "Country": "Virgin Islands (British)",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Jehovah's Witnesses"
    },
    {
     "Country": "Virgin Islands (British)",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Not stated"
    },
    {
     "Country": "Virgin Islands (British)",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Hindu"
    },
    {
     "Country": "Virgin Islands (British)",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Muslim"
    },
    {
     "Country": "Virgin Islands (British)",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Evangelical"
    },
    {
     "Country": "Virgin Islands (British)",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Rastafarian"
    },
    {
     "Country": "Virgin Islands (British)",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Moravian"
    },
    {
     "Country": "Virgin Islands (British)",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Presbyterian"
    },
    {
     "Country": "Virgin Islands (British)",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Buddhist"
    },
    {
     "Country": "Virgin Islands (British)",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Jewish"
    },
    {
     "Country": "Virgin Islands (British)",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Bahai"
    },
    {
     "Country": "Virgin Islands (British)",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Brethren"
    },
    {
     "Country": "Virgin Islands (British)",
     "Region": "Lesser Antilles, Caribbean",
     "Province": "Salvation Army"
    },
    {
     "Country": "Wallis and Futuna Islands",
     "Region": "Polynesia, Oceania",
     "Province": "Mata Utu"
    },
    {
     "Country": "Wallis and Futuna Islands",
     "Region": "Polynesia, Oceania",
     "Province": "Vaitupu"
    },
    {
     "Country": "Wallis and Futuna Islands",
     "Region": "Polynesia, Oceania",
     "Province": "Mata Utu"
    },
    {
     "Country": "Wallis and Futuna Islands",
     "Region": "Polynesia, Oceania",
     "Province": "Mala'efo'ou"
    },
    {
     "Country": "Wallis and Futuna Islands",
     "Region": "Polynesia, Oceania",
     "Province": "Leava"
    },
    {
     "Country": "Wallis and Futuna Islands",
     "Region": "Polynesia, Oceania",
     "Province": "Mala'e"
    },
    {
     "Country": "Wallis and Futuna Islands",
     "Region": "Polynesia, Oceania",
     "Province": "Leava"
    },
    {
     "Country": "Wallis and Futuna Islands",
     "Region": "Polynesia, Oceania",
     "Province": "Mata Utu"
    },
    {
     "Country": "Western Sahara",
     "Region": "Northern Africa",
     "Province": "Guelmim-Oued Noun Region"
    },
    {
     "Country": "Western Sahara",
     "Region": "Northern Africa",
     "Province": "Assa-Zag Province"
    },
    {
     "Country": "Western Sahara",
     "Region": "Northern Africa",
     "Province": "Laâyoune-Sakia El Hamra Region"
    },
    {
     "Country": "Western Sahara",
     "Region": "Northern Africa",
     "Province": "Boujdour Province"
    },
    {
     "Country": "Western Sahara",
     "Region": "Northern Africa",
     "Province": "Es Semara Province"
    },
    {
     "Country": "Western Sahara",
     "Region": "Northern Africa",
     "Province": "Laâyoune Province"
    },
    {
     "Country": "Western Sahara",
     "Region": "Northern Africa",
     "Province": "Tarfaya Province"
    },
    {
     "Country": "Western Sahara",
     "Region": "Northern Africa",
     "Province": "Dakhla-Oued Ed-Dahab Region"
    },
    {
     "Country": "Western Sahara",
     "Region": "Northern Africa",
     "Province": "Aousserd Province"
    },
    {
     "Country": "Western Sahara",
     "Region": "Northern Africa",
     "Province": "Oued Eddahab Province"
    },
    {
     "Country": "Yemen",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Abyan"
    },
    {
     "Country": "Yemen",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Aden"
    },
    {
     "Country": "Yemen",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Al Bayda"
    },
    {
     "Country": "Yemen",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Al Hudaydah"
    },
    {
     "Country": "Yemen",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Al Jawf"
    },
    {
     "Country": "Yemen",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Al Mahrah"
    },
    {
     "Country": "Yemen",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Al Mahwit"
    },
    {
     "Country": "Yemen",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Amanat Al Asimaha"
    },
    {
     "Country": "Yemen",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "'Amran"
    },
    {
     "Country": "Yemen",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Dhale"
    },
    {
     "Country": "Yemen",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Dhamar"
    },
    {
     "Country": "Yemen",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Hadramaut"
    },
    {
     "Country": "Yemen",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Hajjah"
    },
    {
     "Country": "Yemen",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Ibb"
    },
    {
     "Country": "Yemen",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Lahij"
    },
    {
     "Country": "Yemen",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Ma'rib"
    },
    {
     "Country": "Yemen",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Raymah"
    },
    {
     "Country": "Yemen",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Sa'dah"
    },
    {
     "Country": "Yemen",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Sana'a"
    },
    {
     "Country": "Yemen",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Shabwah"
    },
    {
     "Country": "Yemen",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Socotra Archipelagob"
    },
    {
     "Country": "Yemen",
     "Region": "Arabian Peninsula, Middle East",
     "Province": "Taiz"
    },
    {
     "Country": "Zambia",
     "Region": "Eastern Africa",
     "Province": "Central"
    },
    {
     "Country": "Zambia",
     "Region": "Eastern Africa",
     "Province": "Copperbelt"
    },
    {
     "Country": "Zambia",
     "Region": "Eastern Africa",
     "Province": "Eastern"
    },
    {
     "Country": "Zambia",
     "Region": "Eastern Africa",
     "Province": "Luapula"
    },
    {
     "Country": "Zambia",
     "Region": "Eastern Africa",
     "Province": "Lusaka"
    },
    {
     "Country": "Zambia",
     "Region": "Eastern Africa",
     "Province": "Muchinga"
    },
    {
     "Country": "Zambia",
     "Region": "Eastern Africa",
     "Province": "Northern"
    },
    {
     "Country": "Zambia",
     "Region": "Eastern Africa",
     "Province": "North-Western"
    },
    {
     "Country": "Zambia",
     "Region": "Eastern Africa",
     "Province": "Southern"
    },
    {
     "Country": "Zambia",
     "Region": "Eastern Africa",
     "Province": "Western"
    },
    {
     "Country": "Zimbabwe",
     "Region": "Eastern Africa",
     "Province": "Bulawayo"
    },
    {
     "Country": "Zimbabwe",
     "Region": "Eastern Africa",
     "Province": "Harare"
    },
    {
     "Country": "Zimbabwe",
     "Region": "Eastern Africa",
     "Province": "Manicaland"
    },
    {
     "Country": "Zimbabwe",
     "Region": "Eastern Africa",
     "Province": "Mashonaland Central"
    },
    {
     "Country": "Zimbabwe",
     "Region": "Eastern Africa",
     "Province": "Mashonaland East"
    },
    {
     "Country": "Zimbabwe",
     "Region": "Eastern Africa",
     "Province": "Mashonaland West"
    },
    {
     "Country": "Zimbabwe",
     "Region": "Eastern Africa",
     "Province": "Masvingo"
    },
    {
     "Country": "Zimbabwe",
     "Region": "Eastern Africa",
     "Province": "Matabeleland North"
    },
    {
     "Country": "Zimbabwe",
     "Region": "Eastern Africa",
     "Province": "Matabeleland South"
    },
    {
     "Country": "Zimbabwe",
     "Region": "Eastern Africa",
     "Province": "Midlands"
    }
   ]